const ASSETS = window.ENGRAVE_ASSETS;
/* ---------------------------------------------------------------
   Mounting. On product pages the designer is placed inside a
   shadow root on window.ENGRAVE_MOUNT so the theme's styles and
   ours never mix. On its own page it uses the document as is.
---------------------------------------------------------------- */
const MOUNT = window.ENGRAVE_MOUNT || null;
const SHELL_CSS = "\n:host{\n  --stage-1:#fffcf5; --stage-2:#fffcf5;\n  --panel:#f4f5f3; --panel-2:#e8eae6; --ink:#1d2326; --ink-2:#5a6469; --line:#d2d6d0;\n  --accent:#d64027; --accent-2:#ad2b2c; --accent-ink:#ffffff; --warn:#b8611a; --danger:#a5352b;\n  --radius-s:6px; --radius-m:10px;\n  --ui:Poppins, system-ui, -apple-system, \"Segoe UI\", sans-serif;\n  --display:Poppins, system-ui, -apple-system, \"Segoe UI\", sans-serif;\n  color-scheme: light dark;\n}\n@media (prefers-color-scheme: dark){\n  :host{\n    --stage-1:#fffcf5; --stage-2:#fffcf5;\n    --panel:#1b2225; --panel-2:#242d31; --ink:#e7ebe9; --ink-2:#9aa5a9; --line:#334044;\n    --accent:#f6901f; --accent-2:#ffa94a; --accent-ink:#1f1d1b; --warn:#e3964f; --danger:#e07a6e;\n  }\n}\n:host([data-theme=\"dark\"]){\n  --stage-1:#fffcf5; --stage-2:#fffcf5;\n  --panel:#1b2225; --panel-2:#242d31; --ink:#e7ebe9; --ink-2:#9aa5a9; --line:#334044;\n  --accent:#f6901f; --accent-2:#ffa94a; --accent-ink:#1f1d1b; --warn:#e3964f; --danger:#e07a6e;\n}\n:host{ all:initial; display:block; box-sizing:border-box; }\n*,*::before,*::after{ box-sizing:inherit; }\n.eroot{ height:100%; margin:0; position:relative; background:var(--panel); color:var(--ink); font:15px/1.5 var(--ui); -webkit-font-smoothing:antialiased; }\nbutton,input,select,textarea{ font:inherit; color:inherit; }\n:focus-visible{ outline:2px solid var(--accent); outline-offset:2px; }\n\n.app{ display:grid; grid-template-columns:minmax(300px,360px) 1fr; height:100%; }\n.panel{ display:flex; flex-direction:column; min-height:0; border-right:1px solid var(--line); background:var(--panel); }\n.panel-scroll{ flex:1; overflow-y:auto; padding:24px 22px 16px; }\n.panel-foot{ padding:14px 22px 18px; border-top:1px solid var(--line); display:flex; flex-direction:column; gap:8px; }\n.panel-foot .btn{ width:100%; }\n\nh1{ font:400 1.75rem/1.15 var(--display); margin:0 0 4px; letter-spacing:-0.01em; }\n.sub{ color:var(--ink-2); margin:0 0 22px; }\nh2{ font-size:.95rem; font-weight:600; margin:0 0 10px; }\n.block{ margin-bottom:26px; }\n.hint{ color:var(--ink-2); font-size:.85rem; margin:8px 0 0; }\n\n.seg{ display:flex; background:var(--panel-2); border-radius:var(--radius-m); padding:3px; gap:3px; }\n#woods{ display:grid; grid-template-columns:repeat(3, 1fr); }\n.seg button{ flex:1; border:0; background:transparent; border-radius:7px; padding:7px 8px; cursor:pointer; font-weight:500; color:var(--ink-2); display:flex; align-items:center; justify-content:center; gap:7px; }\n.seg button[aria-pressed=\"true\"]{ background:var(--panel); color:var(--ink); box-shadow:0 1px 2px rgba(0,0,0,.12); }\n.swatch{ width:14px; height:14px; border-radius:50%; border:1px solid rgba(0,0,0,.2); }\n\n.add-row{ display:grid; grid-template-columns:1fr 1fr; gap:10px; }\n.btn{ border:1px solid var(--line); background:var(--panel); border-radius:var(--radius-m); padding:10px 12px; cursor:pointer; font-weight:500; display:inline-flex; align-items:center; justify-content:center; gap:8px; }\n.btn:hover{ border-color:var(--ink-2); }\n.btn-big{ flex-direction:column; padding:16px 10px 14px; gap:6px; }\n.btn-big svg{ width:24px; height:24px; }\n.btn-primary{ background:var(--accent); border-color:var(--accent); color:var(--accent-ink); }\n.btn-primary:hover{ background:var(--accent-2); border-color:var(--accent-2); }\n.btn-small{ padding:6px 10px; font-size:.85rem; border-radius:var(--radius-s); }\n.btn-danger{ color:var(--danger); }\n.btn[disabled]{ opacity:.45; cursor:default; }\n\n.borders{ display:grid; grid-template-columns:repeat(3,1fr); gap:6px; }\n.borders button{ border:1px solid var(--line); background:var(--panel); border-radius:var(--radius-s); padding:6px 4px 5px; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:3px; font-size:.78rem; color:var(--ink-2); }\n.borders button[aria-pressed=\"true\"]{ border-color:var(--accent); box-shadow:inset 0 0 0 1px var(--accent); color:var(--ink); }\n.borders canvas{ display:block; border-radius:3px; }\n.sec{ border-top:1px solid var(--line); padding-top:20px; }\n.sec-title{ font:400 1.3rem/1.2 var(--display); margin:0 0 4px; }\n.block-head{ display:flex; align-items:center; justify-content:space-between; gap:12px; margin-bottom:10px; }\n.block-head h2{ margin:0; }\n.switch{ position:relative; width:44px; height:26px; flex:none; border:0; border-radius:999px; background:var(--line); cursor:pointer; padding:0; transition:background .18s; }\n.switch span{ position:absolute; top:3px; left:3px; width:20px; height:20px; border-radius:50%; background:#fff; box-shadow:0 1px 3px rgba(0,0,0,.3); transition:transform .18s; }\n.switch[aria-checked=\"true\"]{ background:var(--accent); }\n.switch[aria-checked=\"true\"] span{ transform:translateX(18px); }\n#borderOpts{ margin-top:14px; }\n#borderOpts .field[hidden]{ display:none; }\n.layers{ list-style:none; margin:0; padding:0; display:flex; flex-direction:column; gap:6px; }\n.layers li button{ width:100%; display:flex; align-items:center; gap:10px; text-align:left; border:1px solid transparent; background:var(--panel-2); border-radius:var(--radius-m); padding:6px 10px 6px 6px; cursor:pointer; }\n.layers li button[aria-current=\"true\"]{ border-color:var(--accent); background:var(--panel); }\n.thumb{ width:40px; height:40px; flex:none; border-radius:6px; background:#d9b48a; display:grid; place-items:center; overflow:hidden; }\n.thumb canvas{ max-width:34px; max-height:34px; }\n.layer-name{ flex:1; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-weight:500; }\n.layer-size{ color:var(--ink-2); font-size:.8rem; white-space:nowrap; }\n.warn-dot{ width:8px; height:8px; border-radius:50%; background:var(--warn); flex:none; }\n\n.props{ border-top:1px solid var(--line); padding-top:20px; }\n.props-head{ display:flex; align-items:baseline; justify-content:space-between; gap:10px; margin-bottom:12px; }\n.props-head h2{ margin:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }\n.field{ margin-bottom:16px; }\n.field > label, .field > .label{ display:block; font-size:.85rem; font-weight:500; margin-bottom:6px; }\ntextarea{ width:100%; min-height:72px; resize:vertical; border:1px solid var(--line); border-radius:var(--radius-m); padding:9px 11px; background:var(--panel); line-height:1.35; }\n.fonts{ display:grid; grid-template-columns:repeat(2,1fr); gap:6px; }\n.fonts button{ border:1px solid var(--line); background:var(--panel); border-radius:var(--radius-s); padding:7px 9px; text-align:left; cursor:pointer; font-size:1.05rem; line-height:1.2; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }\n.fonts button[aria-pressed=\"true\"]{ border-color:var(--accent); box-shadow:inset 0 0 0 1px var(--accent); }\n.dims{ display:grid; grid-template-columns:1fr 1fr 1fr; gap:8px; }\n.dims label{ font-size:.8rem; color:var(--ink-2); display:block; }\n.dims input{ width:100%; border:1px solid var(--line); border-radius:var(--radius-s); padding:6px 8px; background:var(--panel); font-variant-numeric:tabular-nums; }\ninput[type=range]{ width:100%; accent-color:var(--accent); }\n.range-row{ display:flex; justify-content:space-between; font-size:.85rem; font-weight:500; margin-bottom:2px; }\n.range-row span:last-child{ color:var(--ink-2); font-variant-numeric:tabular-nums; font-weight:400; }\n.check{ display:flex; align-items:center; gap:8px; font-size:.9rem; cursor:pointer; }\n.check input{ accent-color:var(--accent); width:16px; height:16px; }\n.actions{ display:flex; flex-wrap:wrap; gap:6px; margin-top:4px; }\n\n.stage{ position:relative; overflow:hidden; background:radial-gradient(120% 90% at 50% 38%, var(--stage-1), var(--stage-2)); min-height:0; touch-action:none; user-select:none; -webkit-user-select:none; }\n.stage canvas{ position:absolute; inset:0; width:100%; height:100%; display:block; }\n#overlay{ cursor:default; }\n.stage-bar{ position:absolute; top:14px; left:14px; right:14px; display:flex; justify-content:space-between; gap:10px; pointer-events:none; z-index:2; }\n.stage-bar > *{ pointer-events:auto; }\n.glass{ background:rgba(255,255,255,.88); border:1px solid rgba(60,45,30,.12); box-shadow:0 1px 3px rgba(60,45,30,.08); backdrop-filter:blur(10px); -webkit-backdrop-filter:blur(10px); border-radius:var(--radius-m); padding:3px; display:flex; gap:3px; color:#2b2622; }\n.glass button{ white-space:nowrap; border:0; background:transparent; color:inherit; border-radius:7px; padding:7px 12px; cursor:pointer; font-weight:500; display:flex; align-items:center; gap:6px; }\n.glass button:hover{ background:rgba(60,45,30,.07); }\n.glass button[aria-pressed=\"true\"]{ background:#2b2622; color:#fffcf5; }\n.glass button[disabled]{ opacity:.4; cursor:default; background:transparent; }\n.glass svg{ width:18px; height:18px; }\n.stage-note{ position:absolute; left:50%; bottom:18px; transform:translateX(-50%); z-index:2; color:#fffcf5; background:rgba(43,38,34,.82); backdrop-filter:blur(10px); -webkit-backdrop-filter:blur(10px); padding:8px 14px; border-radius:999px; font-size:.88rem; max-width:calc(100% - 28px); text-align:center; pointer-events:none; }\n.stage-note.warn{ background:rgba(120,58,14,.85); }\n.toast{ position:absolute; left:50%; top:66px; transform:translateX(-50%); z-index:3; background:#fbfbfa; color:#1d2326; border-radius:var(--radius-m); padding:11px 14px; box-shadow:0 6px 24px rgba(0,0,0,.25); max-width:min(440px, calc(100% - 28px)); font-size:.9rem; }\n.toast[hidden], .stage-note[hidden]{ display:none; }\n.drop{ position:absolute; inset:10px; border:2px dashed rgba(214,64,39,.7); border-radius:14px; z-index:4; display:grid; place-items:center; color:#ad2b2c; font-size:1.2rem; font-weight:500; background:rgba(214,64,39,.25); pointer-events:none; }\n.drop[hidden]{ display:none; }\n.loading{ position:absolute; inset:0; display:grid; place-items:center; color:#dfe6e3; z-index:1; }\n\n[hidden]{ display:none !important; }\n.sr-only{ position:absolute; width:1px; height:1px; overflow:hidden; clip:rect(0 0 0 0); white-space:nowrap; }\n\n\n.badge{ min-width:18px; height:18px; padding:0 5px; border-radius:9px; background:var(--accent); color:#fff; font-size:.72rem; font-weight:600; display:inline-grid; place-items:center; margin-left:-4px; }\n.cart-wrap{ position:fixed; inset:0; background:rgba(10,14,16,.45); z-index:50; display:flex; justify-content:flex-end; }\n.cart{ width:min(440px, 100%); height:100%; background:var(--panel); padding:22px 22px calc(22px + env(safe-area-inset-bottom,0px)); overflow-y:auto; box-shadow:-8px 0 30px rgba(0,0,0,.25); }\n.cart-head{ display:flex; justify-content:space-between; align-items:center; margin-bottom:12px; }\n.cart-head h2{ font:400 1.5rem/1.2 var(--display); margin:0; }\n.cart-list{ list-style:none; margin:0; padding:0; display:flex; flex-direction:column; gap:14px; }\n.cart-item{ display:flex; gap:12px; padding:12px; border:1px solid var(--line); border-radius:var(--radius-m); background:var(--panel-2); }\n.cart-item img{ width:96px; height:72px; object-fit:cover; border-radius:6px; flex:none; }\n.ci-body{ min-width:0; display:flex; flex-direction:column; gap:4px; }\n.ci-name{ font-weight:600; }\n.ci-meta{ font-size:.82rem; color:var(--ink-2); }\n.ci-sent{ font-size:.82rem; color:var(--accent); }\n.ci-sent:empty{ display:none; }\n.ci-actions{ display:flex; gap:6px; flex-wrap:wrap; margin-top:4px; }\n.cart-foot{ margin-top:18px; }\n#woods button{ flex-direction:column; gap:1px; padding:6px 6px; }\n.wood-name{ display:flex; align-items:center; gap:6px; }\n.wood-delta{ font-size:.75rem; font-weight:500; color:var(--ink-2); }\n#woods button[aria-pressed=\"true\"] .wood-delta{ color:var(--accent); }\n.price-row{ display:flex; justify-content:space-between; align-items:baseline; gap:10px; margin-bottom:2px; }\n.price-row span{ color:var(--ink-2); font-size:.88rem; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }\n.price-row strong{ font:400 1.5rem/1 var(--display); }\n.card-price{ margin-top:8px; font-weight:600; }\n.cart-total{ display:flex; justify-content:space-between; align-items:baseline; margin-top:16px; padding-top:14px; border-top:1px solid var(--line); }\n.cart-total strong{ font:400 1.4rem/1 var(--display); }\n.sizes{ display:grid; grid-template-columns:repeat(3,1fr); gap:6px; }\n.sizes button{ border:1px solid var(--line); background:var(--panel); border-radius:var(--radius-s); padding:7px 6px; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:1px; font-size:.85rem; font-weight:500; }\n.sizes button[aria-pressed=\"true\"]{ border-color:var(--accent); box-shadow:inset 0 0 0 1px var(--accent); }\n.sizes button[aria-pressed=\"true\"] .wood-delta{ color:var(--accent); }\n.btn-sub{ display:block; font-size:.72rem; font-weight:400; color:var(--ink-2); line-height:1.3; margin-top:1px; }\n.btn-txt{ display:flex; flex-direction:column; align-items:flex-start; text-align:left; }\n.sec-title{ font-weight:600 !important; }\nh1, .card-name, .cart-head h2, .cat-sec > h2, .price-row strong, .cart-total strong{ font-weight:600 !important; letter-spacing:-0.01em; }\n/* catalog */\n#catalog{ height:100%; overflow-y:auto; background:var(--panel); }\n.cat-wrap{ max-width:1180px; margin:0 auto; padding:56px 28px 64px; }\n.cat-head{ max-width:640px; margin-bottom:36px; }\n.cat-head h1{ font-size:clamp(2rem, 4vw, 2.75rem); margin-bottom:10px; }\n.cat-head p{ color:var(--ink-2); font-size:1.05rem; margin:0; }\n.cat-sec{ margin-bottom:44px; }\n.cat-sec > h2{ font:400 1.5rem/1.2 var(--display); margin:0 0 16px; }\n.products{ display:grid; grid-template-columns:repeat(3, 1fr); gap:22px; }\n.card{ display:flex; flex-direction:column; text-decoration:none; color:inherit; border-radius:14px; overflow:hidden; background:var(--panel-2); border:1px solid var(--line); }\n.card:hover{ border-color:var(--ink-2); }\n.card:hover .card-img img{ transform:scale(1.03); }\n.card-img{ position:relative; aspect-ratio:4 / 3; background:radial-gradient(120% 90% at 50% 38%, var(--stage-1), var(--stage-2)); overflow:hidden; display:grid; place-items:center; }\n.card-img img{ width:100%; height:100%; object-fit:cover; display:block; transition:transform .35s ease; }\n.card-wait{ color:#8a8170; font-size:.9rem; }\n.card-body{ display:flex; flex-direction:column; gap:3px; padding:14px 16px 18px; }\n.card-name{ font:400 1.3rem/1.2 var(--display); }\n.card-size{ color:var(--ink-2); font-size:.88rem; }\n.card-blurb{ margin-top:6px; font-size:.95rem; }\n.back{ border:0; background:none; padding:0; margin:0 0 14px; color:var(--accent); font-weight:500; cursor:pointer; display:inline-flex; align-items:center; gap:6px; }\n.back svg{ width:16px; height:16px; }\n.pnote{ color:var(--ink); background:var(--panel-2); border-radius:var(--radius-s); padding:8px 10px; font-size:.88rem; margin:-12px 0 22px; }\n@media (max-width: 960px){ .products{ grid-template-columns:repeat(2, 1fr); } }\n@media (max-width: 600px){ .products{ grid-template-columns:1fr; } .cat-wrap{ padding:36px 18px 48px; } }\n@media (max-width: 820px){ #catalog{ height:auto; overflow:visible; } }\n@media (max-width: 820px){\n  .eroot{ height:auto; }\n  .app{ display:flex; flex-direction:column-reverse; height:auto; }\n  .stage{ position:sticky; top:env(safe-area-inset-top,0px); height:58vh; height:58svh; z-index:5; }\n  .panel{ border-right:0; }\n  .panel-scroll{ overflow:visible; padding:20px 18px 8px; }\n  .panel-foot{ position:sticky; bottom:0; background:var(--panel); padding-bottom:calc(14px + env(safe-area-inset-bottom,0px)); }\n  .glass button{ padding:7px 10px; }\n  .hide-narrow{ display:none; }\n}\n@media (prefers-reduced-motion: reduce){ *{ transition:none !important; } }\n";
const SHELL_HTML = "\n<div id=\"catalog\">\n  <div class=\"cat-wrap\">\n    <header class=\"cat-head\">\n      <h1>What would you like to personalize?</h1>\n      <p>Pick a piece to start designing. You\u2019ll see your engraving on it before you order.</p>\n    </header>\n    <div id=\"products\"></div>\n  </div>\n</div>\n<div class=\"app\" id=\"designer\" hidden>\n  <aside class=\"panel\" aria-label=\"Design controls\">\n    <div class=\"panel-scroll\">\n      <button class=\"back\" type=\"button\" id=\"backBtn\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 18l-6-6 6-6\"/></svg>All products</button>\n      <h1 id=\"pTitle\"></h1>\n      <p class=\"sub\" id=\"boardSize\"></p>\n      <p class=\"pnote\" id=\"pNote\" hidden></p>\n\n      <div class=\"block\">\n        <h2 id=\"woodLabel\">Choose a wood</h2>\n        <div class=\"seg\" role=\"group\" aria-labelledby=\"woodLabel\" id=\"woods\"></div>\n      </div>\n\n      <div class=\"block\" id=\"sizeBlock\" hidden>\n        <h2>Choose a size</h2>\n        <div class=\"sizes\" id=\"sizes\" role=\"group\" aria-label=\"Sign size\"></div>\n        <div class=\"dims\" id=\"customSize\" hidden style=\"grid-template-columns:1fr 1fr;margin-top:10px\">\n          <div><label for=\"cW\">Width (in)</label><input id=\"cW\" type=\"number\" step=\"0.25\" inputmode=\"decimal\"></div>\n          <div><label for=\"cH\">Height (in)</label><input id=\"cH\" type=\"number\" step=\"0.25\" inputmode=\"decimal\"></div>\n        </div>\n        <p class=\"hint\" id=\"sizeHint\"></p>\n      </div>\n\n      <div class=\"block sec\" id=\"plateHead\" hidden>\n        <h2 class=\"sec-title\">Background plate</h2>\n        <p class=\"hint\">The base layer. Add names, a date or a message, and a border.</p>\n      </div>\n\n      <div class=\"block\">\n        <div class=\"block-head\">\n          <h2 id=\"borderLabel\"><span id=\"borderTitle\">Border</span></h2>\n          <button type=\"button\" class=\"switch\" role=\"switch\" id=\"borderSwitch\" aria-checked=\"false\" aria-labelledby=\"borderLabel\"><span></span></button>\n        </div>\n        <div id=\"borderBody\" hidden>\n          <div class=\"borders\" role=\"group\" aria-label=\"Border style\" id=\"borders\"></div>\n          <div id=\"borderOpts\">\n            <div class=\"field\">\n              <div class=\"range-row\"><label for=\"bWeight\">Line thickness</label><span id=\"bWeightOut\"></span></div>\n              <input id=\"bWeight\" type=\"range\" min=\"0.03\" max=\"0.25\" step=\"0.01\">\n            </div>\n            <div class=\"field\" id=\"bCornersField\" style=\"margin-bottom:0\">\n              <span class=\"label\" id=\"bCornersLbl\">Corners</span>\n              <div class=\"seg\" role=\"group\" aria-labelledby=\"bCornersLbl\" id=\"bCorners\">\n                <button type=\"button\" data-v=\"match\">Follow the edge</button>\n                <button type=\"button\" data-v=\"square\">Square</button>\n              </div>\n            </div>\n          </div>\n          <p class=\"hint\" id=\"borderHint\"></p>\n        </div>\n      </div>\n\n      <div class=\"block\" id=\"plateText\" hidden>\n        <h2>Plate text</h2>\n        <button class=\"btn\" type=\"button\" id=\"textBtn2\">\n          <svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M5 6V4h14v2\"/><path d=\"M12 4v16\"/><path d=\"M9 20h6\"/></svg>\n          <span class=\"btn-txt\">Add text<span class=\"btn-sub\">Can add multiple lines of text</span></span>\n        </button>\n        <p class=\"hint\">Keep text in the open area below the raised image.</p>\n      </div>\n\n      <div class=\"block sec\" id=\"imgBlock\" hidden>\n        <h2 class=\"sec-title\">Image</h2>\n        <p class=\"hint\" style=\"margin:0 0 12px\">The raised top layer. We cut it around your picture and etch the picture on it.</p>\n        <button class=\"btn\" type=\"button\" id=\"imgBtn\">\n          <svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"16\" rx=\"2\"/><circle cx=\"9\" cy=\"10\" r=\"1.8\"/><path d=\"M21 16l-5-5-8 9\"/></svg>\n          Upload PNG image\n        </button>\n        <p class=\"hint\">PNG only. For a cut that follows your family, remove the background first so it\u2019s transparent.</p>\n        <input type=\"file\" id=\"imgInput\" class=\"sr-only\" accept=\".png,image/png\">\n      </div>\n\n      <div class=\"block\" id=\"addBlock\">\n        <h2>Add your design</h2>\n        <div class=\"add-row\">\n          <button class=\"btn btn-big\" id=\"uploadBtn\" type=\"button\">\n            <svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"16\" rx=\"2\"/><circle cx=\"9\" cy=\"10\" r=\"1.8\"/><path d=\"M21 16l-5-5-8 9\"/></svg>\n            Upload artwork\n          </button>\n          <button class=\"btn btn-big\" id=\"textBtn\" type=\"button\">\n            <svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M5 6V4h14v2\"/><path d=\"M12 4v16\"/><path d=\"M9 20h6\"/></svg>\n            Add text\n            <span class=\"btn-sub\">Can add multiple lines of text</span>\n          </button>\n        </div>\n        <p class=\"hint\">Artwork can be JPG, PNG, SVG or EPS. You can also drop files onto the preview.</p>\n        <input type=\"file\" id=\"fileInput\" class=\"sr-only\" accept=\".jpg,.jpeg,.png,.svg,.eps,image/jpeg,image/png,image/svg+xml,application/postscript\" multiple>\n      </div>\n\n      <div class=\"block\" id=\"photoBlock\" hidden>\n        <h2>Photo in the frame</h2>\n        <button class=\"btn\" type=\"button\" id=\"photoBtn\">Choose a photo</button>\n        <p class=\"hint\">Preview your own photo in the frame. It\u2019s shown here only and isn\u2019t engraved.</p>\n        <input type=\"file\" id=\"photoInput\" class=\"sr-only\" accept=\".jpg,.jpeg,.png,image/jpeg,image/png\">\n      </div>\n\n      <div class=\"block\" id=\"layersBlock\" hidden>\n        <h2>On your board</h2>\n        <ul class=\"layers\" id=\"layers\"></ul>\n      </div>\n\n      <div class=\"block props\" id=\"props\" hidden></div>\n    </div>\n    <div class=\"panel-foot\">\n      <div class=\"price-row\"><span id=\"priceWood\"></span><strong id=\"priceNow\"></strong></div>\n      <button class=\"btn\" id=\"proofBtn\" type=\"button\" disabled>Save proof</button>\n      <button class=\"btn btn-primary\" id=\"cartAddBtn\" type=\"button\">Add to cart</button>\n    </div>\n  </aside>\n\n  <main class=\"stage\" id=\"stage\" aria-label=\"Board preview\">\n        <canvas id=\"gl\" aria-hidden=\"true\"></canvas>\n    <canvas id=\"overlay\" aria-label=\"Design area. Drag artwork to move it, use the corner handles to resize and the round handle to rotate.\"></canvas>\n    <div class=\"stage-bar\">\n      <div class=\"glass\" role=\"group\" aria-label=\"View\">\n        <button type=\"button\" id=\"viewFlat\" aria-pressed=\"true\">\n          <svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" aria-hidden=\"true\"><rect x=\"4\" y=\"6\" width=\"16\" height=\"12\" rx=\"2\"/></svg>Design\n        </button>\n        <button type=\"button\" id=\"view3d\" aria-pressed=\"false\">\n          <svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M3 14l8 4 10-5-8-4z\"/><path d=\"M3 14v2l8 4 10-5v-2\"/></svg>3D<span class=\"hide-narrow\">preview</span>\n        </button>\n      </div>\n      <div class=\"glass\" role=\"group\" aria-label=\"Edit\">\n        <button type=\"button\" id=\"undoBtn\" aria-label=\"Undo\" title=\"Undo\" disabled><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M9 14L4 9l5-5\"/><path d=\"M4 9h11a5 5 0 010 10h-3\"/></svg></button>\n        <button type=\"button\" id=\"redoBtn\" aria-label=\"Redo\" title=\"Redo\" disabled><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 14l5-5-5-5\"/><path d=\"M20 9H9a5 5 0 000 10h3\"/></svg></button>\n        <button type=\"button\" id=\"cartBtn\" aria-label=\"Cart\" title=\"Cart\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M3 4h2l2.4 11h10.2L20 7H6.2\"/><circle cx=\"9\" cy=\"19\" r=\"1.4\"/><circle cx=\"17\" cy=\"19\" r=\"1.4\"/></svg><span class=\"badge\" id=\"cartCount\" hidden>0</span></button>\n        <button type=\"button\" id=\"fitBtn\" aria-label=\"Reset view\" title=\"Reset view\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" aria-hidden=\"true\"><path d=\"M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5\"/></svg></button>\n      </div>\n    </div>\n    <div class=\"toast\" id=\"toast\" role=\"status\" hidden></div>\n    <div class=\"stage-note\" id=\"note\" hidden></div>\n    <div class=\"drop\" id=\"drop\" hidden>Drop to add to your design</div>\n  </main>\n</div>\n<div class=\"cart-wrap\" id=\"cart\" hidden>\n  <section class=\"cart\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"cartTitle\">\n    <header class=\"cart-head\"><h2 id=\"cartTitle\">Your cart</h2><button class=\"btn btn-small\" type=\"button\" id=\"cartClose\">Close</button></header>\n    <p class=\"hint\" id=\"cartEmpty\">Your cart is empty.</p>\n    <ul class=\"cart-list\" id=\"cartList\"></ul>\n    <div class=\"cart-total\" id=\"cartTotal\" hidden><span>Total</span><strong id=\"cartTotalNum\"></strong></div>\n    <p class=\"hint cart-foot\">Checkout isn\u2019t connected yet, so this is a sample order. Each design downloads as a real-size SVG for your laser software.</p>\n  </section>\n</div>\n";
function mountShadow(host) {
  const root = host.attachShadow({ mode: 'open' });
  root.innerHTML = `<style>${SHELL_CSS}</style><div class="eroot">${SHELL_HTML}</div>`;
  return root;
}
const DOC = MOUNT ? mountShadow(MOUNT) : document;
/* ---------------------------------------------------------------
   Shop settings — edit these to match your products.
   Sizes are in inches. Each product's `price` lists the woods it is
   offered in (in dollars); leave a wood out to hide it for that product.
---------------------------------------------------------------- */
const WOODS = [
  { id: 'cherry', label: 'Cherry', swatch: '#b46a3a', sat: 1.0,  tint: [1.0, 1.0, 1.0],   burn: [0.055, 0.024, 0.010] },
  { id: 'maple',  label: 'Maple',  swatch: '#dcb98a', sat: 0.55, tint: [1.9, 1.62, 1.22], burn: [0.085, 0.038, 0.014] },
  { id: 'walnut', label: 'Walnut', swatch: '#5b3d2b', sat: 0.8,  tint: [0.42, 0.29, 0.22], burn: [0.016, 0.009, 0.005] },
  { id: 'poplar', label: 'Poplar', swatch: '#d8d1a8', sat: 0.38, tint: [1.72, 1.74, 1.3], burn: [0.07, 0.038, 0.016] },
  { id: 'birch',  label: 'Birch',  swatch: '#eadcbc', sat: 0.32, tint: [2.1, 1.9, 1.52], burn: [0.08, 0.04, 0.015] },
];

const ALL_BORDERS = ['single', 'double', 'thickthin', 'triple', 'dashed', 'dotted', 'midcentury', 'rope', 'deco', 'crosshair', 'chamfer', 'layered'];
const ROUND_BORDERS = ['single', 'double', 'thickthin', 'triple', 'dashed', 'dotted', 'rope'];

const PRODUCTS = [
  {
    id: 'cutting-board', price: { birch: 52, maple: 55, cherry: 55, walnut: 65 }, cat: 'Cutting boards', name: 'Cutting board', size: '15 × 10 in, with a hanging hole',
    blurb: 'A kitchen keepsake for weddings, housewarmings and holidays.',
    safeMargin: 0.6, cornerR: 0.68,
    border: { inset: 0.5, weight: 0.08, max: 0.25, styles: ALL_BORDERS },
    text: { value: 'The Millers\nEst. 2026', font: 'playfair', lineH: 1.6, y: 0 }, thumbBorder: 'double',
    build: () => buildBoard(),
  },
  {
    id: 'charcuterie-board', price: { birch: 105, maple: 110, cherry: 110, walnut: 145 }, cat: 'Cutting boards', name: 'Charcuterie board with handle', size: '28 × 16 in overall, 3/4 in thick',
    blurb: 'A large serving board with a long handle and a hanging hole.',
    safeMargin: 0.6, cornerR: 1.5,
    border: { inset: 0.5, weight: 0.08, max: 0.25, styles: ALL_BORDERS },
    text: { value: 'The Millers\nEst. 2026', font: 'playfair', lineH: 2.0, y: 0 }, thumbBorder: 'double',
    build: () => buildCharcuterie(),
  },
  {
    id: 'cutting-board-end-grain', price: { birch: 165, maple: 175, cherry: 175, walnut: 225 }, cat: 'Cutting boards', name: 'End grain cutting board', size: '16 × 12 × 1.5 in',
    blurb: 'A thick butcher-block board with a checkerboard end-grain top.',
    safeMargin: 0.6, cornerR: 0.25,
    border: { inset: 0.5, weight: 0.08, max: 0.25, styles: ALL_BORDERS },
    text: { value: 'The Millers\nEst. 2026', font: 'playfair', lineH: 1.6, y: 0 }, thumbBorder: 'single',
    build: () => buildEndGrain(),
  },
  {
    id: 'coasters', price: { poplar: 36, birch: 36, maple: 36, cherry: 36, walnut: 44 }, cat: 'Coasters', name: 'Square coasters', size: 'Set of 4, each 4 × 4 in', note: 'Price is for a set of 4 coasters with the same design.',
    blurb: 'Monograms, family names or a favorite saying.',
    safeMargin: 0.3, cornerR: 0,
    border: { inset: 0.25, weight: 0.05, max: 0.12, styles: ALL_BORDERS },
    text: { value: 'The Millers', font: 'cinzel', lineH: 0.5, y: 0 }, thumbBorder: 'single',
    build: () => buildCoasters(),
  },
  {
    id: 'coaster-rounded', price: { poplar: 36, birch: 36, maple: 36, cherry: 36, walnut: 44 }, cat: 'Coasters', name: 'Rounded coasters', size: 'Set of 4, each 4 × 4 in', note: 'Price is for a set of 4 coasters with the same design.',
    blurb: 'A square coaster with soft, rounded corners.',
    safeMargin: 0.3, cornerR: 0.5,
    border: { inset: 0.25, weight: 0.05, max: 0.12, styles: ALL_BORDERS },
    text: { value: 'The Millers', font: 'cinzel', lineH: 0.5, y: 0 }, thumbBorder: 'single',
    build: () => buildCoasterShape('rounded'),
  },
  {
    id: 'coaster-round', price: { poplar: 36, birch: 36, maple: 36, cherry: 36, walnut: 44 }, cat: 'Coasters', name: 'Round coasters', size: 'Set of 4, each 4 in round', note: 'Price is for a set of 4 coasters with the same design.', round: true,
    blurb: 'A classic round coaster.',
    safeMargin: 0.3, cornerR: 2,
    border: { inset: 0.25, weight: 0.05, max: 0.12, styles: ROUND_BORDERS },
    text: { value: 'The Millers', font: 'cinzel', lineH: 0.45, y: 0 }, thumbBorder: 'double',
    build: () => buildCoasterShape('round'),
  },
  {
    id: 'photo-frame', price: { poplar: 38, birch: 38, maple: 38, cherry: 38, walnut: 46 }, cat: 'Photo frames', name: 'Photo frame', size: '6.5 × 8.9 in, holds a 5 × 7 photo',
    blurb: 'Names, dates or a short message engraved around the photo.',
    safeMargin: 0.18, cornerR: 0, photo: true,
    border: { inset: 0.15, weight: 0.04, max: 0.1, gap: 0.06, styles: ['single', 'double', 'thickthin', 'dashed', 'dotted'] },
    text: { value: 'Best Friend', font: 'vibes', lineH: 0.42, y: 4.04 },
    build: () => buildFrame(),
  },
  {
    id: 'photo-frame-rounded', price: { poplar: 42, birch: 42, maple: 42, cherry: 42, walnut: 50 }, cat: 'Photo frames', name: 'Rounded photo frame', size: '6.5 × 8.9 in, holds a 5 × 7 photo',
    blurb: 'The same frame with softly rounded corners.',
    safeMargin: 0.18, cornerR: 0.6, photo: true,
    border: { inset: 0.15, weight: 0.04, max: 0.1, gap: 0.06, styles: ['single', 'double', 'thickthin', 'dashed', 'dotted'] },
    text: { value: 'Best Friend', font: 'vibes', lineH: 0.42, y: 4.03 },
    build: () => buildFrameRounded(),
  },
  {
    id: 'ornament', price: { poplar: 16, birch: 16, maple: 16, cherry: 16, walnut: 21 }, cat: 'Christmas ornaments', name: 'Round ornament', size: '3.5 in round', round: true,
    blurb: 'Baby’s first Christmas, family names or a year to remember.',
    safeMargin: 0.25, cornerR: 1.75,
    border: { inset: 0.18, weight: 0.04, max: 0.1, styles: ROUND_BORDERS },
    text: { value: 'Baby’s First\nChristmas 2026', font: 'dancing', lineH: 0.42, y: 0.15 }, thumbBorder: 'dotted',
    build: () => buildOrnament(),
  },
  {
    id: 'ornament-family', price: { poplar: 32, birch: 32, maple: 32, cherry: 32, walnut: 38 }, cat: 'Christmas ornaments', name: 'Round family photo ornament', size: '4 in round, two layers', round: true,
    blurb: 'Your family, cut out and etched on a raised layer, with names below.',
    safeMargin: 0.2, cornerR: 2, family: true, keepOutLabel: 'the family cutout',
    border: { inset: 0.15, weight: 0.04, max: 0.1, gap: 0.08, styles: ROUND_BORDERS },
    text: { value: 'The Millers\n2026', font: 'playfair', lineH: 0.42, y: -0.92 }, thumbBorder: 'double', seedBorder: 'double',
    build: () => buildFamilyOrnament('round'),
  },
  {
    id: 'ornament-family-rect', price: { poplar: 34, birch: 34, maple: 34, cherry: 34, walnut: 40 }, cat: 'Christmas ornaments', name: 'Rectangle family photo ornament', size: '4 × 3 in, two layers',
    blurb: 'A rectangular version: your family raised on top, names below.',
    safeMargin: 0.2, cornerR: 0.25, family: true,
    border: { inset: 0.15, weight: 0.04, max: 0.1, gap: 0.08, styles: ALL_BORDERS },
    text: { value: 'The Millers\n2026', font: 'playfair', lineH: 0.3, y: -0.76 }, thumbBorder: 'double', seedBorder: 'double',
    build: () => buildFamilyOrnament('rect'),
  },
  {
    id: 'family-sign', cat: 'Signs', name: 'Family name sign',
    blurb: 'For the front porch, the entryway or a wedding table.',
    sizes: true, sizeW: 18, sizeH: 7.25, presets: [[18, 7.25], [12, 8], [18, 12], [24, 12], [24, 18], [36, 12]],
    safeMargin: 0.6, cornerR: 0.3,
    border: { inset: 0.5, weight: 0.08, max: 0.25, styles: ALL_BORDERS },
    text: { value: 'The Millers', font: 'playfair', lineFrac: 0.36, yFrac: 0 }, thumbBorder: 'deco',
    build: (w = 18, h = 7.25) => buildCustomSign(w, h, false),
  },
  {
    id: 'custom-sign', cat: 'Signs', name: 'Custom sign',
    blurb: 'Pick a size and make it your own. Priced by size and wood.',
    sizes: true, sizeW: 18, sizeH: 12, layerPremium: 0,
    safeMargin: 0.6, cornerR: 0.3,
    border: { inset: 0.5, weight: 0.08, max: 0.25, styles: ALL_BORDERS },
    text: { value: 'Welcome', font: 'playfair', lineFrac: 0.22, yFrac: 0 }, thumbBorder: 'double',
    build: (w = 18, h = 12) => buildCustomSign(w, h, false),
  },
  {
    id: 'custom-sign-layered', cat: 'Signs', name: 'Layered custom sign',
    blurb: 'A raised, cut-out picture on top of an engraved sign.',
    sizes: true, sizeW: 18, sizeH: 12, layered: true,
    safeMargin: 0.5, cornerR: 0.3, family: true, keepOutLabel: 'the raised image',
    border: { inset: 0.5, weight: 0.08, max: 0.25, gap: 0.15, styles: ALL_BORDERS },
    text: { value: 'The Millers', font: 'playfair', lineFrac: 0.13, yFrac: -0.3 }, thumbBorder: 'double', seedBorder: 'double',
    build: (w = 18, h = 12) => buildCustomSign(w, h, true),
  },
  {
    id: 'keepsake-box', price: { poplar: 85, birch: 85, maple: 99, cherry: 99, walnut: 120 }, cat: 'Boxes', name: 'Keepsake box', size: '8 × 5 in lid',
    blurb: 'For recipes, letters, watches and small treasures.',
    safeMargin: 0.4, cornerR: 0.2,
    border: { inset: 0.35, weight: 0.06, max: 0.18, styles: ALL_BORDERS },
    text: { value: 'Grandma’s\nRecipes', font: 'vibes', lineH: 0.95, y: 0 }, thumbBorder: 'thickthin',
    build: () => buildBox(),
  },
];

/* Custom signs are priced by size: base + square inches × rate for the wood.
   The layered sign adds a markup and a flat fee for the raised layer. */
const SIGN_PRICING = {
  base: 30,
  rate: { poplar: 0.22, birch: 0.22, maple: 0.29, cherry: 0.29, walnut: 0.37 },
  layerMarkup: 1.25, layerFee: 15,
  presets: [[12, 8], [18, 12], [24, 12], [24, 18], [36, 12]],
  min: [6, 4], max: [36, 24],
};
function signPrices(w, h, layered) {
  const out = {};
  for (const [k, r] of Object.entries(SIGN_PRICING.rate)) {
    const p = SIGN_PRICING.base + w * h * r;
    out[k] = Math.round(layered ? p * SIGN_PRICING.layerMarkup + SIGN_PRICING.layerFee : p);
  }
  return out;
}
const signSizeText = (p) => `${p.sizeW} × ${p.sizeH} in${p.layered ? ', two layers' : ''}`;
for (const p of PRODUCTS.filter((x) => x.sizes)) { p.price = signPrices(p.sizeW, p.sizeH, p.layered); p.size = signSizeText(p); }

const FONTS = [
  { id: 'playfair', label: 'Playfair',      family: 'Playfair Display', weight: 600 },
  { id: 'vibes',    label: 'Great Vibes',   family: 'Great Vibes',      weight: 400 },
  { id: 'bebas',    label: 'Bebas Neue',    family: 'Bebas Neue',       weight: 400 },
  { id: 'cinzel',   label: 'Cinzel',        family: 'Cinzel',           weight: 600 },
  { id: 'dancing',  label: 'Dancing Script',family: 'Dancing Script',   weight: 600 },
  { id: 'josefin',  label: 'Josefin Sans',  family: 'Josefin Sans',     weight: 600 },
  { id: 'abril',    label: 'Abril Fatface', family: 'Abril Fatface',    weight: 400 },
  { id: 'caveat',   label: 'Caveat',        family: 'Caveat',           weight: 600 },
  { id: 'pacifico', label: 'Pacifico',      family: 'Pacifico',         weight: 400 },
  { id: 'lora',     label: 'Lora',          family: 'Lora',             weight: 500 },
];

/* ---------------------------------------------------------------
   Basics
---------------------------------------------------------------- */
const $ = (id) => DOC.getElementById(id);
const fmt = (n) => (Math.round(n * 10) / 10).toFixed(1);
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
const V3 = (a) => new THREE.Vector3(a[0], a[1], a[2]);

let P = null;            // current product (with its built scene data)
let DW = 1, DH = 1;      // design area in inches
let MW = 1, MH = 1, PPI = 1;
let els = [];
let selId = null;
let nextId = 1;
let wood = WOODS[0];
let view = 'flat';
let border = { style: 'none', weight: 0.08, corners: 'match' };
let lastBorderStyle = 'single';
let hist = { stack: [], i: -1 };
const STORE = {};

const getSel = () => els.find((e) => e.id === selId) || null;
const dims = (e) => ({ w: e.bmp.width * e.ipp, h: e.bmp.height * e.ipp });

/* ---------------------------------------------------------------
   Renderer, scene, lights
---------------------------------------------------------------- */
const stage = $('stage');
const glCanvas = $('gl');
const overlay = $('overlay');
const octx = overlay.getContext('2d');

const renderer = new THREE.WebGLRenderer({ canvas: glCanvas, antialias: true, alpha: true });
renderer.setClearColor(0x000000, 0);
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
const ANISO = renderer.capabilities.getMaxAnisotropy();

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(26, 1, 0.1, 800);
scene.add(new THREE.HemisphereLight(0xfdf6ec, 0x3a3430, 0.55));
const key = new THREE.DirectionalLight(0xfff1de, 1.55);
key.castShadow = true;
key.shadow.mapSize.set(2048, 2048);
key.shadow.radius = 6;
key.shadow.bias = -0.0004;
scene.add(key, key.target);
const fillLight = new THREE.DirectionalLight(0xdbe6ff, 0.45);
scene.add(fillLight, fillLight.target);
const ground = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.ShadowMaterial({ opacity: 0.3 }));
ground.rotation.x = -Math.PI / 2;
ground.receiveShadow = true;
scene.add(ground);

/* ---------------------------------------------------------------
   Textures and the engraving material
---------------------------------------------------------------- */
function b64(s, Type) {
  const bin = atob(s); const u8 = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
  return new Type(u8.buffer);
}
const texLoader = new THREE.TextureLoader();
function loadTex(src, { srgb = false, repeat = false } = {}) {
  return new Promise((res) => texLoader.load(src, (t) => {
    if (srgb) t.encoding = THREE.sRGBEncoding;
    if (repeat) t.wrapS = t.wrapT = THREE.MirroredRepeatWrapping;
    t.anisotropy = ANISO;
    res(t);
  }, undefined, () => res(null)));
}
const TEX = {};
async function loadTextures() {
  const [bm, bn, br, bao, gm, gn, gr] = await Promise.all([
    loadTex(ASSETS.board.map, { srgb: true }), loadTex(ASSETS.board.normal), loadTex(ASSETS.board.rough), loadTex(ASSETS.board.ao),
    loadTex(ASSETS.grain.map, { srgb: true, repeat: true }), loadTex(ASSETS.grain.normal, { repeat: true }), loadTex(ASSETS.grain.rough, { repeat: true }),
  ]);
  Object.assign(TEX, { bm, bn, br, bao, gm, gn, gr });
  if (ASSETS.family) {
    TEX.family = await new Promise((res) => { const im = new Image(); im.onload = () => res(im); im.onerror = () => res(null); im.src = ASSETS.family; });
  }
}

const WOOD_U = {
  uBurn: { value: new THREE.Vector3(...wood.burn) },
  uTint: { value: new THREE.Vector3(...wood.tint) },
  uSat: { value: wood.sat },
};

// surf: {o,U,V,N,hw,hh} in inches, or null for wood that isn't engraved.
function woodMaterial(kind, surf, maskU) {
  const m = new THREE.MeshStandardMaterial({ roughness: 1, metalness: 0 });
  if (kind === 'board') {
    m.map = TEX.bm; m.normalMap = TEX.bn; m.roughnessMap = TEX.br;
    if (TEX.bao) { m.aoMap = TEX.bao; m.aoMapIntensity = 0.8; }
  } else {
    m.map = TEX.gm; m.normalMap = TEX.gn; m.roughnessMap = TEX.gr;
  }
  if (m.normalMap) m.normalScale.set(0.6, 0.6);
  const own = {
    uO: { value: surf ? V3(surf.o) : new THREE.Vector3() },
    uU: { value: surf ? V3(surf.U) : new THREE.Vector3(1, 0, 0) },
    uV: { value: surf ? V3(surf.V) : new THREE.Vector3(0, 0, 1) },
    uN: { value: surf ? V3(surf.N) : new THREE.Vector3(0, 1, 0) },
    uHalf: { value: new THREE.Vector2(surf ? surf.hw : 1, surf ? surf.hh : 1) },
    uEng: { value: surf ? 1 : 0 },
  };
  m.onBeforeCompile = (sh) => {
    Object.assign(sh.uniforms, WOOD_U, maskU, own);
    sh.vertexShader = sh.vertexShader
      .replace('#include <common>', '#include <common>\nvarying vec3 vLP;\nvarying vec3 vLN;')
      .replace('#include <begin_vertex>', '#include <begin_vertex>\nvLP = (modelMatrix * vec4(position, 1.0)).xyz;\nvLN = normalize(mat3(modelMatrix) * normal);');
    sh.fragmentShader = sh.fragmentShader
      .replace('#include <common>', `#include <common>
varying vec3 vLP; varying vec3 vLN;
uniform sampler2D uMask; uniform vec2 uTexel;
uniform vec3 uBurn; uniform vec3 uTint; uniform float uSat;
uniform vec3 uO; uniform vec3 uU; uniform vec3 uV; uniform vec3 uN; uniform vec2 uHalf; uniform float uEng;
float eTop(){ vec3 d = vLP - uO; return uEng * smoothstep(0.93, 0.995, dot(normalize(vLN), uN)) * step(-0.04, dot(d, uN)); }
vec2 eUV(){ vec3 d = vLP - uO; return vec2(dot(d, uU) / (2.0 * uHalf.x) + 0.5, 0.5 - dot(d, uV) / (2.0 * uHalf.y)); }`)
      .replace('#include <map_fragment>', `#include <map_fragment>
{ float lum0 = dot(diffuseColor.rgb, vec3(0.299, 0.587, 0.114));
  diffuseColor.rgb = mix(vec3(lum0), diffuseColor.rgb, uSat) * uTint; }
float eMask = 0.0;
if (uEng > 0.5) {
  vec2 euv = eUV();
  if (euv.x > 0.0 && euv.x < 1.0 && euv.y > 0.0 && euv.y < 1.0) eMask = texture2D(uMask, euv).a * eTop();
}
{ float lum1 = dot(diffuseColor.rgb, vec3(0.299, 0.587, 0.114));
  vec3 burnt = uBurn * (0.6 + 2.2 * lum1);
  diffuseColor.rgb = mix(diffuseColor.rgb, burnt, eMask); }`)
      .replace('#include <roughnessmap_fragment>', `#include <roughnessmap_fragment>
roughnessFactor = mix(roughnessFactor, 0.97, eMask);`)
      .replace('#include <normal_fragment_maps>', `#include <normal_fragment_maps>
if (eMask > 0.0 || uEng > 0.5) {
  vec2 euv = eUV(); float et = eTop();
  float gx = texture2D(uMask, euv + vec2(uTexel.x, 0.0)).a - texture2D(uMask, euv - vec2(uTexel.x, 0.0)).a;
  float gz = texture2D(uMask, euv - vec2(0.0, uTexel.y)).a - texture2D(uMask, euv + vec2(0.0, uTexel.y)).a;
  vec3 bump = (uU * gx + uV * gz) * 0.85 * et;
  normal = normalize(normal + (viewMatrix * vec4(bump, 0.0)).xyz);
}`);
  };
  return m;
}

// Planar wood-grain UVs (inches / tile size), picked per face by its main direction.
function woodUV(geo, grainAlongX = false) {
  if (geo.index) geo = geo.toNonIndexed();
  geo.computeVertexNormals();
  const p = geo.attributes.position, n = geo.attributes.normal, uv = new Float32Array(p.count * 2);
  const TW = 6, TH = 8;
  for (let i = 0; i < p.count; i += 3) {
    const nx = Math.abs(n.getX(i) + n.getX(i + 1) + n.getX(i + 2)), ny = Math.abs(n.getY(i) + n.getY(i + 1) + n.getY(i + 2)), nz = Math.abs(n.getZ(i) + n.getZ(i + 1) + n.getZ(i + 2));
    for (let k = i; k < i + 3; k++) {
      const x = p.getX(k), y = p.getY(k), z = p.getZ(k);
      let a, b;
      if (ny >= nx && ny >= nz) { a = x; b = z; }
      else if (nx >= nz) { a = z; b = y; }
      else { a = x; b = y; }
      if (grainAlongX) [a, b] = [b, a];
      uv[k * 2] = a / TW + 0.37; uv[k * 2 + 1] = b / TH + 0.21;
    }
  }
  geo.setAttribute('uv', new THREE.BufferAttribute(uv, 2));
  return geo;
}
function rawGeo(posB64) {
  const g = new THREE.BufferGeometry();
  g.setAttribute('position', new THREE.BufferAttribute(b64(posB64, Float32Array), 3));
  return g;
}
function addMesh(group, geo, mat, cast = true) {
  const m = new THREE.Mesh(geo, mat);
  m.castShadow = cast; m.receiveShadow = true;
  group.add(m);
  return m;
}
function roundedRectShape(w, h, r) {
  const s = new THREE.Shape(), x = -w / 2, y = -h / 2;
  r = Math.min(r, w / 2, h / 2);
  s.moveTo(x + r, y); s.lineTo(x + w - r, y); s.quadraticCurveTo(x + w, y, x + w, y + r);
  s.lineTo(x + w, y + h - r); s.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  s.lineTo(x + r, y + h); s.quadraticCurveTo(x, y + h, x, y + h - r);
  s.lineTo(x, y + r); s.quadraticCurveTo(x, y, x + r, y);
  return s;
}

/* ---------------------------------------------------------------
   Product models (all in inches, Y up, ground at y = 0)
---------------------------------------------------------------- */
function newMask(surf) {
  const canvas = document.createElement('canvas');
  const long = 2560;
  const w = surf.hw >= surf.hh ? long : Math.round(long * surf.hw / surf.hh);
  const h = surf.hw >= surf.hh ? Math.round(long * surf.hh / surf.hw) : long;
  canvas.width = w; canvas.height = h;
  const tex = new THREE.CanvasTexture(canvas);
  tex.anisotropy = ANISO;
  return { canvas, tex, U: { uMask: { value: tex }, uTexel: { value: new THREE.Vector2(1.4 / w, 1.4 / h) } } };
}

function buildBoard() {
  const g = new THREE.Group();
  const geo = new THREE.BufferGeometry();
  geo.setAttribute('position', new THREE.BufferAttribute(b64(ASSETS.board.pos, Float32Array), 3));
  const uv = new THREE.BufferAttribute(b64(ASSETS.board.uv, Float32Array), 2);
  geo.setAttribute('uv', uv); geo.setAttribute('uv2', uv);
  geo.setIndex(new THREE.BufferAttribute(b64(ASSETS.board.idx, Uint16Array), 1));
  geo.computeVertexNormals();
  const surf = { o: [0, 0.7663, 0], U: [1, 0, 0], V: [0, 0, 1], N: [0, 1, 0], hw: 7.5, hh: 5.058 };
  const mask = newMask(surf);
  addMesh(g, geo, woodMaterial('board', surf, mask.U));
  return { group: g, surf, mask, target3d: [0, 0.4, 0], radius: 8.6, preset: { theta: -0.5, phi: 0.92 } };
}

function buildCoasters() {
  const g = new THREE.Group();
  const W = 4, T = 0.25, bev = 0.03;
  const geo = new THREE.ExtrudeGeometry(roundedRectShape(W - bev * 2, W - bev * 2, 0.03), { depth: T - bev * 2, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 2, curveSegments: 4 });
  geo.rotateX(-Math.PI / 2); geo.translate(0, bev, 0);
  const surf = { o: [0, T, 0], U: [1, 0, 0], V: [0, 0, 1], N: [0, 1, 0], hw: W / 2, hh: W / 2 };
  const mask = newMask(surf);
  addMesh(g, woodUV(geo), woodMaterial('grain', surf, mask.U));
  return { group: g, surf, mask, target3d: [0, 0.1, 0], radius: 2.9, preset: { theta: -0.5, phi: 0.95 } };
}

function buildFrame() {
  const g = new THREE.Group();
  const F = ASSETS.frame;
  const surf = { o: F.o, U: F.U, V: F.V, N: F.N, hw: F.hw, hh: F.hh };
  const mask = newMask(surf);
  addMesh(g, woodUV(rawGeo(F.frame)), woodMaterial('grain', surf, mask.U));
  addMesh(g, woodUV(rawGeo(F.stand)), woodMaterial('grain', null, mask.U));
  const hinge = rawGeo(F.hinge); hinge.computeVertexNormals();
  addMesh(g, hinge, new THREE.MeshStandardMaterial({ color: 0x9a9da0, metalness: 0.8, roughness: 0.35 }));
  const pg = rawGeo(F.photo);
  pg.setAttribute('uv', new THREE.BufferAttribute(b64(F.photoUV, Float32Array), 2));
  pg.computeVertexNormals();
  const photoMat = new THREE.MeshStandardMaterial({ roughness: 0.45, metalness: 0 });
  addMesh(g, pg, photoMat, false);
  const k = F.keep;
  return {
    group: g, surf, mask, target3d: [0, 4.3, 0.8], radius: 6.2, preset: { theta: -0.42, phi: 1.22 },
    keepOut: { x0: k[0], y0: k[1], x1: k[2], y1: k[3] }, keepOutLabel: 'the photo opening', photoMat,
  };
}

function buildFrameRounded() {
  const g = new THREE.Group();
  const W = 6.5, H = 8.85, T = 0.55, bev = 0.04, R = 0.6;   // outer size, thickness, corner radius
  const PW = 5, PH = 7.25, PR = 0.25, recess = 0.25;          // photo opening
  const lean = -0.2465;                                        // leans back like the original frame
  const M = new THREE.Matrix4().makeRotationX(lean);
  M.setPosition(0, T * Math.sin(-lean) + 0.01, 0);
  const rot = new THREE.Matrix4().makeRotationX(lean);
  const tf = (geo) => { geo.applyMatrix4(M); return geo; };

  const shape = roundedRectShape(W - bev * 2, H - bev * 2, R - bev);
  shape.holes.push(roundedRectShape(PW + bev * 2, PH + bev * 2, PR + bev));
  const front = new THREE.ExtrudeGeometry(shape, { depth: T - bev * 2, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 2, curveSegments: 12 });
  front.translate(0, H / 2, -T + bev);           // front face at z = 0, back at z = -T
  const surfLocal = new THREE.Vector3(0, H / 2, 0);
  const o = surfLocal.clone().applyMatrix4(M);
  const surf = { o: o.toArray(), U: [1, 0, 0], V: new THREE.Vector3(0, -1, 0).applyMatrix4(rot).toArray(), N: new THREE.Vector3(0, 0, 1).applyMatrix4(rot).toArray(), hw: W / 2, hh: H / 2 };
  const mask = newMask(surf);
  addMesh(g, woodUV(tf(front)), woodMaterial('grain', surf, mask.U));

  // backing board behind the photo
  const back = new THREE.ExtrudeGeometry(roundedRectShape(PW + 0.3, PH + 0.3, PR), { depth: T - recess - 0.02, bevelEnabled: false, curveSegments: 8 });
  back.translate(0, H / 2, -T);
  addMesh(g, woodUV(tf(back)), woodMaterial('grain', null, mask.U));

  // the photo
  const photo = new THREE.PlaneGeometry(PW + 0.1, PH + 0.1);
  photo.translate(0, H / 2, -recess);
  const photoMat = new THREE.MeshStandardMaterial({ roughness: 0.45, metalness: 0 });
  addMesh(g, tf(photo), photoMat, false);

  // easel leg
  const top = new THREE.Vector3(0, H * 0.62, -T).applyMatrix4(M);
  const foot = new THREE.Vector3(0, 0.12, top.z - 3.2);
  const dir = top.clone().sub(foot);
  const leg = new THREE.BoxGeometry(0.9, dir.length(), 0.22);
  const legMesh = addMesh(g, woodUV(leg), woodMaterial('grain', null, mask.U));
  legMesh.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), dir.clone().normalize());
  legMesh.position.copy(foot.clone().add(top).multiplyScalar(0.5));

  return {
    group: g, surf, mask, target3d: [0, 4.3, -0.6], radius: 6.2, preset: { theta: -0.42, phi: 1.22 },
    keepOut: { x0: -PW / 2, y0: -PH / 2, x1: PW / 2, y1: PH / 2 }, keepOutLabel: 'the photo opening', photoMat,
  };
}

function buildOrnament() {
  const g = new THREE.Group();
  const R = 1.75, T = 0.125, bev = 0.02, cy = 3.4, holeY = 1.42;
  const shape = new THREE.Shape(); shape.absarc(0, 0, R, 0, Math.PI * 2, false);
  const hole = new THREE.Path(); hole.absarc(0, holeY, 0.1, 0, Math.PI * 2, true); shape.holes.push(hole);
  const geo = new THREE.ExtrudeGeometry(shape, { depth: T, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 2, curveSegments: 72 });
  geo.translate(0, cy, -T / 2);
  const surf = { o: [0, cy, T / 2 + bev], U: [1, 0, 0], V: [0, -1, 0], N: [0, 0, 1], hw: R, hh: R };
  const mask = newMask(surf);
  addMesh(g, woodUV(geo), woodMaterial('grain', surf, mask.U));
  const hy = cy + holeY;
  const curve = new THREE.CatmullRomCurve3([
    new THREE.Vector3(0, hy, 0.12), new THREE.Vector3(0, hy + 0.6, 0.18), new THREE.Vector3(0, hy + 1.6, 0.02),
    new THREE.Vector3(0, hy + 0.6, -0.18), new THREE.Vector3(0, hy, -0.12), new THREE.Vector3(0, hy - 0.02, 0),
  ], true);
  addMesh(g, new THREE.TubeGeometry(curve, 80, 0.03, 8, true), new THREE.MeshStandardMaterial({ color: 0x8e2b26, roughness: 0.85 }));
  return { group: g, surf, mask, target3d: [0, 3.8, 0], radius: 3.1, preset: { theta: -0.4, phi: 1.3 } };
}

function buildSign() {
  const g = new THREE.Group();
  const W = 18, H = 7.25, T = 0.75, bev = 0.06;
  const geo = new THREE.ExtrudeGeometry(roundedRectShape(W - bev * 2, H - bev * 2, 0.3), { depth: T - bev * 2, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 3, curveSegments: 10 });
  geo.translate(0, H / 2, -(T - bev * 2) / 2);
  const surf = { o: [0, H / 2, T / 2], U: [1, 0, 0], V: [0, -1, 0], N: [0, 0, 1], hw: W / 2, hh: H / 2 };
  const mask = newMask(surf);
  addMesh(g, woodUV(geo, true), woodMaterial('grain', surf, mask.U));
  return { group: g, surf, mask, target3d: [0, 3.6, 0], radius: 9.8, preset: { theta: -0.4, phi: 1.25 } };
}

function buildBox() {
  const g = new THREE.Group();
  const W = 8, D = 5, Hb = 2.6, Tl = 0.6, bev = 0.04;
  const body = new THREE.ExtrudeGeometry(roundedRectShape(W - 0.16, D - 0.16, 0.15), { depth: Hb, bevelEnabled: false, curveSegments: 8 });
  body.rotateX(-Math.PI / 2);
  const lid = new THREE.ExtrudeGeometry(roundedRectShape(W - bev * 2, D - bev * 2, 0.2), { depth: Tl - bev * 2, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 2, curveSegments: 8 });
  lid.rotateX(-Math.PI / 2); lid.translate(0, Hb + bev, 0);
  const top = Hb + Tl;
  const surf = { o: [0, top, 0], U: [1, 0, 0], V: [0, 0, 1], N: [0, 1, 0], hw: W / 2, hh: D / 2 };
  const mask = newMask(surf);
  addMesh(g, woodUV(body), woodMaterial('grain', null, mask.U));
  addMesh(g, woodUV(lid), woodMaterial('grain', surf, mask.U));
  return { group: g, surf, mask, target3d: [0, 1.6, 0], radius: 5.6, preset: { theta: -0.5, phi: 0.95 } };
}
/* ---------------------------------------------------------------
   More product models
---------------------------------------------------------------- */
function buildCoasterShape(kind) {
  const g = new THREE.Group();
  const W = 4, T = 0.25, bev = 0.03;
  let shape;
  if (kind === 'round') { shape = new THREE.Shape(); shape.absarc(0, 0, W / 2 - bev, 0, Math.PI * 2, false); }
  else shape = roundedRectShape(W - bev * 2, W - bev * 2, kind === 'rounded' ? 0.5 - bev : 0.03);
  const geo = new THREE.ExtrudeGeometry(shape, { depth: T - bev * 2, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 2, curveSegments: kind === 'round' ? 72 : 10 });
  geo.rotateX(-Math.PI / 2); geo.translate(0, bev, 0);
  const surf = { o: [0, T, 0], U: [1, 0, 0], V: [0, 0, 1], N: [0, 1, 0], hw: W / 2, hh: W / 2 };
  const mask = newMask(surf);
  addMesh(g, woodUV(geo), woodMaterial('grain', surf, mask.U));
  return { group: g, surf, mask, target3d: [0, 0.1, 0], radius: 2.9, preset: { theta: -0.5, phi: 0.95 } };
}

// Charcuterie board: 28 × 16 in overall, 3/4 in thick, with a centred paddle handle.
function buildCharcuterie() {
  const g = new THREE.Group();
  const x0 = -14, x1 = 7, hb = 8, r = 1.5;        // body: 21 × 16 in, rounded corners
  const base = 1.5, tip = 1.3, f = 2.2;            // handle half-width at the board and at the end, fillet size
  const xe = 14, rc = 0.65;                         // handle end and its corner radius
  const T = 0.75, bev = 0.1;
  const s = new THREE.Shape();
  s.moveTo(x0 + r, -hb); s.lineTo(x1 - r, -hb); s.quadraticCurveTo(x1, -hb, x1, -hb + r);
  s.lineTo(x1, -base - f);
  s.bezierCurveTo(x1, -base - f * 0.35, x1 + f * 0.45, -base, x1 + f, -base);
  s.lineTo(xe - rc, -tip); s.quadraticCurveTo(xe, -tip, xe, -tip + rc);
  s.lineTo(xe, tip - rc); s.quadraticCurveTo(xe, tip, xe - rc, tip);
  s.lineTo(x1 + f, base);
  s.bezierCurveTo(x1 + f * 0.45, base, x1, base + f * 0.35, x1, base + f);
  s.lineTo(x1, hb - r); s.quadraticCurveTo(x1, hb, x1 - r, hb);
  s.lineTo(x0 + r, hb); s.quadraticCurveTo(x0, hb, x0, hb - r);
  s.lineTo(x0, -hb + r); s.quadraticCurveTo(x0, -hb, x0 + r, -hb);
  const hole = new THREE.Path(); hole.absarc(xe - 0.9, 0, 0.22, 0, Math.PI * 2, true); s.holes.push(hole);
  const geo = new THREE.ExtrudeGeometry(s, { depth: T - bev * 2, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 4, curveSegments: 28 });
  geo.rotateX(-Math.PI / 2); geo.translate(0, bev, 0);
  const cx = (x0 + x1) / 2;
  const surf = { o: [cx, T, 0], U: [1, 0, 0], V: [0, 0, 1], N: [0, 1, 0], hw: (x1 - x0) / 2, hh: hb };
  const mask = newMask(surf);
  addMesh(g, woodUV(geo, true), woodMaterial('grain', surf, mask.U));
  return { group: g, surf, mask, target3d: [0, 0.35, 0], radius: 15.6, preset: { theta: -0.5, phi: 0.92 } };
}

// A checkerboard of end-grain blocks with growth rings, drawn once.
function endGrainTexture(W, D) {
  const c = document.createElement('canvas');
  const ppi = 128; c.width = Math.round(W * ppi); c.height = Math.round(D * ppi);
  const g = c.getContext('2d');
  let seed = 7; const rnd = () => (seed = (seed * 16807) % 2147483647) / 2147483647;
  const tones = [['#b77446', '#a2643a'], ['#8f5634', '#7e4a2c']];
  const rows = 8, rowH = c.height / rows;
  for (let rI = 0; rI < rows; rI++) {
    const off = (rI % 2) * 0.5;
    const blockW = c.width / 10;
    for (let k = -1; k < 11; k++) {
      const x0 = (k + off) * blockW, y0 = rI * rowH;
      const pal = tones[(((k + rI) % 2) + 2) % 2];
      g.save();
      g.beginPath(); g.rect(x0, y0, blockW, rowH); g.clip();
      g.fillStyle = pal[rnd() < 0.5 ? 0 : 1]; g.fillRect(x0, y0, blockW, rowH);
      const ang = rnd() * Math.PI * 2, dist = (0.7 + rnd() * 1.6) * blockW;
      const cx = x0 + blockW / 2 + Math.cos(ang) * dist, cy = y0 + rowH / 2 + Math.sin(ang) * dist;
      for (let rad = dist - blockW; rad < dist + blockW * 1.2; rad += 5 + rnd() * 9) {
        g.beginPath(); g.arc(cx, cy, Math.max(1, rad), 0, Math.PI * 2);
        g.lineWidth = 1 + rnd() * 2.6; g.strokeStyle = `rgba(55,28,12,${0.12 + rnd() * 0.16})`; g.stroke();
      }
      for (let i = 0; i < 260; i++) { g.fillStyle = `rgba(40,20,8,${rnd() * 0.25})`; g.fillRect(x0 + rnd() * blockW, y0 + rnd() * rowH, 1.4, 1.4); }
      g.restore();
      g.fillStyle = 'rgba(50,25,10,0.35)'; g.fillRect(x0, y0, 1.5, rowH);
    }
    g.fillStyle = 'rgba(50,25,10,0.35)'; g.fillRect(0, rI * rowH, c.width, 1.5);
  }
  const t = new THREE.CanvasTexture(c);
  t.encoding = THREE.sRGBEncoding; t.anisotropy = ANISO;
  return t;
}

function buildEndGrain() {
  const g = new THREE.Group();
  const W = 16, D = 12, T = 1.5, bev = 0.07;
  const geo0 = new THREE.ExtrudeGeometry(roundedRectShape(W - bev * 2, D - bev * 2, 0.25), { depth: T - bev * 2, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 3, curveSegments: 8 });
  geo0.rotateX(-Math.PI / 2); geo0.translate(0, bev, 0);
  const geo = woodUV(geo0);
  // the top and bottom show the end-grain blocks
  const p = geo.attributes.position, n = geo.attributes.normal, uv = geo.attributes.uv;
  for (let i = 0; i < p.count; i++) {
    if (Math.abs(n.getY(i)) > 0.9) uv.setXY(i, p.getX(i) / W + 0.5, 0.5 - p.getZ(i) / D);
  }
  const surf = { o: [0, T, 0], U: [1, 0, 0], V: [0, 0, 1], N: [0, 1, 0], hw: W / 2, hh: D / 2 };
  const mask = newMask(surf);
  const top = woodMaterial('grain', surf, mask.U);
  top.map = endGrainTexture(W, D); top.normalMap = null; top.roughnessMap = null; top.roughness = 0.82;
  const side = woodMaterial('grain', null, mask.U);
  const m = new THREE.Mesh(geo, [top, side]);
  m.castShadow = true; m.receiveShadow = true; g.add(m);
  return { group: g, surf, mask, target3d: [0, 0.75, 0], radius: 10.4, preset: { theta: -0.5, phi: 0.9 } };
}

/* ---------------------------------------------------------------
   Family photo ornament: a round base with a second layer cut
   around the family, with the photo etched on that layer.
---------------------------------------------------------------- */
// Custom sign at any size; `layered` adds a raised cut-out picture layer like the ornaments.
function buildCustomSign(W, H, layered) {
  const g = new THREE.Group();
  const T = 0.75, bev = 0.06, zf = 0.02;
  const geo = new THREE.ExtrudeGeometry(roundedRectShape(W - bev * 2, H - bev * 2, 0.3), { depth: T - bev * 2, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 3, curveSegments: 10 });
  geo.translate(0, H / 2, zf - (T - bev));        // front face at z = zf, standing on the ground
  const surf = { o: [0, H / 2, zf], U: [1, 0, 0], V: [0, -1, 0], N: [0, 0, 1], hw: W / 2, hh: H / 2 };
  const mask = newMask(surf);
  addMesh(g, woodUV(geo, W >= H), woodMaterial('grain', surf, mask.U));
  const R = Math.hypot(W / 2, H / 2);
  const out = { group: g, surf, mask, target3d: [0, H / 2, 0], radius: R * 1.08, preset: { theta: -0.4, phi: 1.25 } };
  if (layered) {
    const fb = 0.02, LT = 0.25;
    out.fam = { T: LT, bev: fb, cy: H / 2, box: { cx: 0, cy: H * 0.27, w: W * 0.9, h: H * 0.72 } };
    out.topSurf = { ...surf, o: [0, H / 2, fb + LT + fb * 2] };
    out.topMask = newMask(surf);
    out.cutMesh = null;
  }
  return out;
}

// Two-layer ornament shapes. box = where the raised image starts (design inches, y down).
const FAM_SHAPES = {
  round: { T: 0.125, bev: 0.015, cy: 3.6, W: 4, H: 4, box: { cx: 0, cy: 0.68, w: 3.7, h: 2.45 } },
  rect:  { T: 0.125, bev: 0.015, cy: 3.3, W: 4, H: 3, r: 0.25, box: { cx: 0, cy: 0.82, w: 3.8, h: 2.3 } },
};

function buildFamilyOrnament(kind = 'round') {
  const F = FAM_SHAPES[kind];
  const g = new THREE.Group();
  const { T, bev, cy, W, H } = F;
  let shape;
  if (kind === 'round') { shape = new THREE.Shape(); shape.absarc(0, 0, W / 2, 0, Math.PI * 2, false); }
  else shape = roundedRectShape(W, H, F.r);
  const holeY = H / 2 - 0.25;
  const hole = new THREE.Path(); hole.absarc(0, holeY, 0.1, 0, Math.PI * 2, true); shape.holes.push(hole);
  const geo = new THREE.ExtrudeGeometry(shape, { depth: T, bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelSegments: 2, curveSegments: kind === 'round' ? 72 : 10 });
  geo.translate(0, cy, -T);
  const surf = { o: [0, cy, bev], U: [1, 0, 0], V: [0, -1, 0], N: [0, 0, 1], hw: W / 2, hh: H / 2 };
  const mask = newMask(surf);
  addMesh(g, woodUV(geo, kind === 'rect'), woodMaterial('grain', surf, mask.U));
  const topSurf = { ...surf, o: [0, cy, bev + T + bev * 2] };
  const topMask = newMask(surf);
  const hy = cy + holeY;
  const curve = new THREE.CatmullRomCurve3([
    new THREE.Vector3(0, hy, 0.1), new THREE.Vector3(0, hy + 0.6, 0.16), new THREE.Vector3(0, hy + 1.6, -0.05),
    new THREE.Vector3(0, hy + 0.6, -0.3), new THREE.Vector3(0, hy, -0.24), new THREE.Vector3(0, hy - 0.02, -0.06),
  ], true);
  addMesh(g, new THREE.TubeGeometry(curve, 80, 0.03, 8, true), new THREE.MeshStandardMaterial({ color: 0x8e2b26, roughness: 0.85 }));
  return { group: g, surf, mask, topSurf, topMask, fam: F, cutMesh: null, target3d: [0, cy + 0.4, 0], radius: 3.4, preset: { theta: -0.4, phi: 1.3 } };
}

// A simple placeholder family (two adults and a child) until a photo is chosen.
function placeholderFamily() {
  if (TEX.family) return TEX.family;     // sample family photo, background already removed
  const c = document.createElement('canvas'); c.width = 620; c.height = 460;
  const g = c.getContext('2d');
  const person = (x, top, s, shirt) => {
    g.fillStyle = '#cfcfcf';
    g.beginPath(); g.arc(x, top + 52 * s, 46 * s, 0, Math.PI * 2); g.fill();
    g.fillStyle = '#7d7d7d';
    g.beginPath(); g.arc(x, top + 40 * s, 47 * s, Math.PI * 1.05, Math.PI * 1.95); g.fill();
    g.fillStyle = shirt;
    g.beginPath();
    g.moveTo(x - 92 * s, 460); g.quadraticCurveTo(x - 96 * s, top + 120 * s, x - 30 * s, top + 108 * s);
    g.lineTo(x + 30 * s, top + 108 * s); g.quadraticCurveTo(x + 96 * s, top + 120 * s, x + 92 * s, 460); g.closePath(); g.fill();
    g.fillStyle = '#bdbdbd'; g.fillRect(x - 18 * s, top + 92 * s, 36 * s, 22 * s);
  };
  person(185, 40, 1.12, '#555');
  person(430, 60, 1.05, '#6a6a6a');
  person(305, 190, 0.78, '#8a8a8a');
  return c;
}

// Marching squares: the largest outline in a 0/1 grid, as points in grid units.
function largestOutline(mask, w, h) {
  const at = (x, y) => (x < 0 || y < 0 || x >= w || y >= h) ? 0 : mask[y * w + x];
  const adj = new Map();
  const link = (a, b) => {
    const ka = a[0] * 100003 + a[1], kb = b[0] * 100003 + b[1];
    if (!adj.has(ka)) adj.set(ka, { p: a, n: [] }); if (!adj.has(kb)) adj.set(kb, { p: b, n: [] });
    adj.get(ka).n.push(kb); adj.get(kb).n.push(ka);
  };
  for (let y = -1; y < h; y++) for (let x = -1; x < w; x++) {
    const a = at(x, y), b = at(x + 1, y), c = at(x + 1, y + 1), d = at(x, y + 1);
    const idx = a * 8 + b * 4 + c * 2 + d;
    if (idx === 0 || idx === 15) continue;
    const T = [2 * x + 1, 2 * y], Rr = [2 * x + 2, 2 * y + 1], B = [2 * x + 1, 2 * y + 2], L = [2 * x, 2 * y + 1];
    const segs = { 1: [[L, B]], 2: [[B, Rr]], 3: [[L, Rr]], 4: [[T, Rr]], 5: [[T, L], [B, Rr]], 6: [[T, B]], 7: [[T, L]], 8: [[T, L]], 9: [[T, B]], 10: [[T, Rr], [L, B]], 11: [[T, Rr]], 12: [[L, Rr]], 13: [[B, Rr]], 14: [[L, B]] }[idx];
    for (const [p, q] of segs) link(p, q);
  }
  const seen = new Set(); let best = null, bestA = 0;
  for (const [k0, node0] of adj) {
    if (seen.has(k0)) continue;
    const loop = []; let prev = null, k = k0;
    while (k !== undefined && !seen.has(k)) {
      seen.add(k); const node = adj.get(k); loop.push([node.p[0] / 2, node.p[1] / 2]);
      const nx = node.n.find((m) => m !== prev && !seen.has(m));
      prev = k; k = nx;
    }
    let A = 0; for (let i = 0; i < loop.length; i++) { const p = loop[i], q = loop[(i + 1) % loop.length]; A += p[0] * q[1] - q[0] * p[1]; }
    if (Math.abs(A) > bestA) { bestA = Math.abs(A); best = loop; }
  }
  return best;
}
function simplify(pts, eps) {
  if (pts.length < 4) return pts;
  const rdp = (a, b) => {
    let md = 0, mi = -1; const [x1, y1] = pts[a], [x2, y2] = pts[b];
    const L = Math.hypot(x2 - x1, y2 - y1) || 1e-9;
    for (let i = a + 1; i < b; i++) { const d = Math.abs((x2 - x1) * (y1 - pts[i][1]) - (x1 - pts[i][0]) * (y2 - y1)) / L; if (d > md) { md = d; mi = i; } }
    return md > eps ? [...rdp(a, mi).slice(0, -1), ...rdp(mi, b)] : [pts[a], pts[b]];
  };
  const half = Math.floor(pts.length / 2);
  return [...rdp(0, half).slice(0, -1), ...rdp(half, pts.length - 1).slice(0, -1)];
}
function boxBlur(src, w, h, r) {
  const tmp = new Float32Array(w * h), out = new Float32Array(w * h);
  for (let y = 0; y < h; y++) { let s = 0; for (let x = -r; x <= r; x++) s += src[y * w + Math.min(w - 1, Math.max(0, x))]; for (let x = 0; x < w; x++) { tmp[y * w + x] = s / (2 * r + 1); s += src[y * w + Math.min(w - 1, x + r + 1)] - src[y * w + Math.max(0, x - r)]; } }
  for (let x = 0; x < w; x++) { let s = 0; for (let y = -r; y <= r; y++) s += tmp[Math.min(h - 1, Math.max(0, y)) * w + x]; for (let y = 0; y < h; y++) { out[y * w + x] = s / (2 * r + 1); s += tmp[Math.min(h - 1, y + r + 1) * w + x] - tmp[Math.max(0, y - r) * w + x]; } }
  return out;
}

// Turn a PNG into a top-layer cutout: an outline that follows the image's
// transparency (with a thin wooden rim) and an etch image of the picture.
function makeCutout(img) {
  const { box } = P.fam;
  const iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
  const fit = Math.min(box.w / iw, box.h / ih);
  const fw = iw * fit, fh = ih * fit;                     // inches at the default size
  // trim fully transparent margins so the handles hug the picture
  const pre = document.createElement('canvas'); pre.width = Math.min(iw, 1200); pre.height = Math.round(pre.width * ih / iw);
  const pctx = pre.getContext('2d', { willReadFrequently: true }); pctx.drawImage(img, 0, 0, pre.width, pre.height);
  const pd = pctx.getImageData(0, 0, pre.width, pre.height).data;
  let x0 = pre.width, y0 = pre.height, x1 = -1, y1 = -1, transparent = false;
  for (let y = 0; y < pre.height; y++) for (let x = 0; x < pre.width; x++) {
    const a = pd[(y * pre.width + x) * 4 + 3];
    if (a < 200) transparent = true;
    if (a > 20) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
  }
  if (x1 < 0) return null;
  const pad = Math.round(Math.max(pre.width, pre.height) * 0.04);
  x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad); x1 = Math.min(pre.width - 1, x1 + pad); y1 = Math.min(pre.height - 1, y1 + pad);
  const cw = x1 - x0 + 1, ch = y1 - y0 + 1;
  const src = document.createElement('canvas'); src.width = cw; src.height = ch;
  src.getContext('2d').drawImage(pre, -x0, -y0);
  const inPerSrc = (fw / pre.width);
  // outline grid
  const gw = 240, gh = Math.max(8, Math.round(gw * ch / cw));
  const gc = document.createElement('canvas'); gc.width = gw; gc.height = gh;
  const gctx = gc.getContext('2d', { willReadFrequently: true }); gctx.drawImage(src, 0, 0, gw, gh);
  const gd = gctx.getImageData(0, 0, gw, gh).data, n = gw * gh;
  const keep = new Float32Array(n); for (let i = 0; i < n; i++) keep[i] = gd[i * 4 + 3] > 128 ? 1 : 0;
  const smooth = boxBlur(keep, gw, gh, 2);
  const solid = new Uint8Array(n); for (let i = 0; i < n; i++) solid[i] = smooth[i] > 0.5 ? 1 : 0;
  const inPerGrid = inPerSrc * cw / gw;
  const rimPx = Math.max(1, Math.round(0.05 / inPerGrid));
  const grown = boxBlur(Float32Array.from(solid), gw, gh, rimPx);
  const cutMask = new Uint8Array(n); for (let i = 0; i < n; i++) cutMask[i] = grown[i] > 0.04 ? 1 : 0;
  const outline = largestOutline(cutMask, gw, gh);
  if (!outline || outline.length < 8) return null;
  const pts = simplify(outline, 0.6);
  // etch image at a fixed resolution, gray burn, only where the picture is solid
  const ew = 720, eh = Math.round(ew * ch / cw);
  const ec = document.createElement('canvas'); ec.width = ew; ec.height = eh;
  const ectx = ec.getContext('2d'); ectx.drawImage(src, 0, 0, ew, eh);
  const ed = ectx.getImageData(0, 0, ew, eh);
  for (let i = 0; i < ew * eh; i++) {
    const l = (0.299 * ed.data[i * 4] + 0.587 * ed.data[i * 4 + 1] + 0.114 * ed.data[i * 4 + 2]) / 255;
    const burn = Math.min(1, Math.max(0, (1 - l) * 1.15 - 0.05));
    const a = ed.data[i * 4 + 3] / 255;
    ed.data[i * 4] = ed.data[i * 4 + 1] = ed.data[i * 4 + 2] = 0;
    ed.data[i * 4 + 3] = burn * (a > 0.5 ? 255 : 0);
  }
  ectx.putImageData(ed, 0, 0);
  // outline in etch-pixel units, relative to the centre
  const outlinePx = pts.map((p) => [p[0] / gw * ew - ew / 2, p[1] / gh * eh - eh / 2]);
  const ipp = Math.min(box.w / ew, box.h / eh);
  return { transparent, etch: ec, outlinePx, ipp0: ipp };
}

// Keep the raised layer's 3D mesh in step with the image element.
// Photos may run past the engraving area; they are masked to it instead.
// Masked items may run past the engraving area and are trimmed at its edge (the same masking the
// ornament photos use). Images and decorations are masked unless turned off; text only when turned on.
const isMasked = (e) => e.type === 'cutout' || (!e.path && (e.mask ?? e.type === 'image'));
function maskPolygon() { return shapePoints(safeShape()); }
// Sutherland–Hodgman: clip any polygon by a convex one.
function clipPolygon(subject, clip) {
  let area = 0;
  for (let i = 0; i < clip.length; i++) { const a = clip[i], b = clip[(i + 1) % clip.length]; area += a.x * b.y - b.x * a.y; }
  const sgn = area > 0 ? 1 : -1;
  const inside = (p, a, b) => sgn * ((b.x - a.x) * (p.y - a.y) - (b.y - a.y) * (p.x - a.x)) >= 0;
  const cross = (p, q, a, b) => {
    const A1 = q.y - p.y, B1 = p.x - q.x, C1 = A1 * p.x + B1 * p.y;
    const A2 = b.y - a.y, B2 = a.x - b.x, C2 = A2 * a.x + B2 * a.y;
    const det = A1 * B2 - A2 * B1 || 1e-12;
    return { x: (B2 * C1 - B1 * C2) / det, y: (A1 * C2 - A2 * C1) / det };
  };
  let out = subject;
  for (let i = 0; i < clip.length && out.length; i++) {
    const a = clip[i], b = clip[(i + 1) % clip.length], input = out; out = [];
    for (let j = 0; j < input.length; j++) {
      const p = input[j], q = input[(j + 1) % input.length], pin = inside(p, a, b), qin = inside(q, a, b);
      if (pin) { out.push(p); if (!qin) out.push(cross(p, q, a, b)); }
      else if (qin) out.push(cross(p, q, a, b));
    }
  }
  return out;
}
// The raised layer's outline, masked to the engraving area (design inches).
function cutoutClipped(e) { return clipPolygon(cutoutPoints(e), maskPolygon()); }

// Keep the raised layer's 3D mesh in step with the image element (rebuilt when it moves).
function syncCutout() {
  if (!P || !P.family) return;
  const e = els.find((x) => x.type === 'cutout');
  if (!e) { if (P.cutMesh) P.cutMesh.visible = false; return; }
  const { cy, T, bev } = P.fam;
  const key = [e.x, e.y, e.rot, e.ipp, e.flip, e.cut.ipp0, e.cut.outlinePx.length, JSON.stringify(safeShape())].join('|');
  if (P.cutKey !== key) {
    P.cutKey = key;
    const pts = cutoutClipped(e);
    let geo = null;
    if (pts.length >= 3) {
      const shape = new THREE.Shape();
      pts.forEach((p, i) => (i ? shape.lineTo(p.x, cy - p.y) : shape.moveTo(p.x, cy - p.y)));
      geo = new THREE.ExtrudeGeometry(shape, { depth: T, bevelEnabled: true, bevelThickness: bev, bevelSize: bev * 0.6, bevelSegments: 1 });
      geo.translate(0, 0, bev * 2);
      geo = woodUV(geo);
    }
    if (!P.cutMesh && geo) P.cutMesh = addMesh(P.group, geo, woodMaterial('grain', P.topSurf, P.topMask.U));
    if (P.cutMesh) {
      if (P.cutMesh.geometry && P.cutMesh.geometry !== geo && P.cutMesh.geometry.dispose) P.cutMesh.geometry.dispose();
      if (geo) P.cutMesh.geometry = geo;
      P.cutMesh.visible = !!geo;
    }
  } else if (P.cutMesh) P.cutMesh.visible = true;
}

// Outline of the raised layer in design inches (for edge checks).
function cutoutPoints(e) {
  const a = e.rot * Math.PI / 180, c = Math.cos(a), s = Math.sin(a), k = e.ipp;
  return e.cut.outlinePx.map(([px, py]) => {
    const x = px * k * (e.flip ? -1 : 1), y = py * k;
    return { x: e.x + x * c - y * s, y: e.y + x * s + y * c };
  });
}

function newCutoutElement(img, name, file) {
  const cut = makeCutout(img);
  if (!cut) return null;
  return { id: nextId++, type: 'cutout', name, file, x: P.fam.box.cx, y: P.fam.box.cy, rot: 0, flip: false, darkness: 0.95, bmp: cut.etch, ipp: cut.ipp0, cut };
}
/* ---------------------------------------------------------------
   Camera
---------------------------------------------------------------- */
const cam = { theta: 0, phi: 0, zoom: 1, pu: 0, pv: 0 };
let camAnim = null;
let W = 1, H = 1, DPR = 1;

function surfVec(name) { return V3(P.surf[name]); }

function poseFlat(zoom = cam.zoom, pu = cam.pu, pv = cam.pv) {
  const vf = THREE.MathUtils.degToRad(camera.fov) / 2;
  const halfW = DW / 2 * 1.14, halfH = DH / 2 * 1.14 * 1.18;
  const d = Math.max(halfH / Math.tan(vf), halfW / (Math.tan(vf) * camera.aspect)) / zoom;
  const target = V3(P.surf.o).addScaledVector(surfVec('U'), pu).addScaledVector(surfVec('V'), pv);
  return { target, pos: target.clone().addScaledVector(surfVec('N'), d), up: surfVec('V').negate() };
}
function pose3d(theta = cam.theta, phi = cam.phi, zoom = cam.zoom) {
  const vf = THREE.MathUtils.degToRad(camera.fov) / 2;
  const R = P.radius * 1.08;
  const d = Math.max(R / Math.sin(vf), R / (Math.tan(vf) * camera.aspect) * 1.05) / zoom;
  const target = V3(P.target3d);
  const pos = target.clone().add(new THREE.Vector3(Math.sin(phi) * Math.sin(theta), Math.cos(phi), Math.sin(phi) * Math.cos(theta)).multiplyScalar(d));
  const up = new THREE.Vector3(-Math.cos(phi) * Math.sin(theta), Math.sin(phi), -Math.cos(phi) * Math.cos(theta));
  return { target, pos, up };
}
function currentPose() { return view === 'flat' ? poseFlat() : pose3d(); }
function setPose(p) {
  camera.position.copy(p.pos); camera.up.copy(p.up); camera.lookAt(p.target); camera.updateMatrixWorld();
}
function blendPose(a, b, k) {
  const target = a.target.clone().lerp(b.target, k);
  const da = a.pos.clone().sub(a.target), db = b.pos.clone().sub(b.target);
  const len = THREE.MathUtils.lerp(da.length(), db.length(), k);
  const dir = da.normalize().lerp(db.normalize(), k).normalize();
  return { target, pos: target.clone().addScaledVector(dir, len), up: a.up.clone().lerp(b.up, k).normalize() };
}

function setView(v, animate = true) {
  const from = P ? (camAnim ? camAnim.last : currentPose()) : null;
  view = v;
  $('viewFlat').setAttribute('aria-pressed', v === 'flat');
  $('view3d').setAttribute('aria-pressed', v === '3d');
  Object.assign(cam, { zoom: 1, pu: 0, pv: 0 }, v === '3d' ? P.preset : {});
  camAnim = (animate && !reduceMotion && from) ? { from, t0: performance.now(), dur: 650, last: from } : null;
  requestRender();
}

/* ---------------------------------------------------------------
   Lights and ground for the current product
---------------------------------------------------------------- */
function placeLights() {
  const t = V3(P.target3d), R = P.radius;
  key.position.copy(t).add(new THREE.Vector3(0.45, 1.2, 0.75).multiplyScalar(R * 2.6));
  key.target.position.copy(t);
  Object.assign(key.shadow.camera, { left: -R * 1.5, right: R * 1.5, top: R * 1.5, bottom: -R * 1.5, near: R * 0.5, far: R * 8 });
  key.shadow.camera.updateProjectionMatrix();
  fillLight.position.copy(t).add(new THREE.Vector3(-1, 0.6, -0.5).multiplyScalar(R * 3));
  fillLight.target.position.copy(t);
  ground.scale.set(R * 10, R * 10, 1);
  ground.position.set(t.x, -0.001, t.z);
}

/* ---------------------------------------------------------------
   Render loop (on demand)
---------------------------------------------------------------- */
let dirty = true;
function requestRender() { dirty = true; }

function resize() {
  const r = stage.getBoundingClientRect();
  W = Math.max(1, r.width); H = Math.max(1, r.height);
  DPR = Math.min(window.devicePixelRatio || 1, 2);
  renderer.setPixelRatio(DPR);
  renderer.setSize(W, H, false);
  overlay.width = Math.round(W * DPR); overlay.height = Math.round(H * DPR);
  camera.aspect = W / H;
  camera.updateProjectionMatrix();
  requestRender();
}
new ResizeObserver(resize).observe(stage);

function frame(now) {
  if (P && !$('designer').hidden) {
    if (camAnim) {
      const t = Math.min(1, (now - camAnim.t0) / camAnim.dur);
      const k = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      camAnim.last = blendPose(camAnim.from, currentPose(), k);
      if (t >= 1) camAnim = null;
      dirty = true;
    }
    if (dirty) {
      dirty = false;
      setPose(camAnim ? camAnim.last : currentPose());
      renderer.render(scene, camera);
      drawOverlay();
    }
  }
  requestAnimationFrame(frame);
}
requestAnimationFrame(frame);

/* ---------------------------------------------------------------
   Design space: inches on the product's face, origin at its centre,
   +x to the right and +y downward as the customer sees it.
---------------------------------------------------------------- */
const _v = new THREE.Vector3();
function toScreen(bx, by) {
  _v.copy(V3(P.surf.o)).addScaledVector(surfVec('U'), bx).addScaledVector(surfVec('V'), by).project(camera);
  return { x: (_v.x + 1) / 2 * W, y: (1 - _v.y) / 2 * H };
}
const ray = new THREE.Raycaster();
function toBoard(px, py) {
  ray.setFromCamera({ x: px / W * 2 - 1, y: -(py / H * 2 - 1) }, camera);
  const plane = new THREE.Plane().setFromNormalAndCoplanarPoint(surfVec('N'), V3(P.surf.o));
  const hit = ray.ray.intersectPlane(plane, new THREE.Vector3());
  if (!hit) return null;
  hit.sub(V3(P.surf.o));
  return { x: hit.dot(surfVec('U')), y: hit.dot(surfVec('V')) };
}
function corners(e) {
  const { w, h } = dims(e);
  const a = e.rot * Math.PI / 180, c = Math.cos(a), s = Math.sin(a);
  return [[-w / 2, -h / 2], [w / 2, -h / 2], [w / 2, h / 2], [-w / 2, h / 2]]
    .map(([x, y]) => ({ x: e.x + x * c - y * s, y: e.y + x * s + y * c }));
}
function contains(e, p) {
  if (e.path) return containsPath(e, p);
  const { w, h } = dims(e);
  const a = -e.rot * Math.PI / 180;
  const dx = p.x - e.x, dy = p.y - e.y;
  const lx = dx * Math.cos(a) - dy * Math.sin(a), ly = dx * Math.sin(a) + dy * Math.cos(a);
  return Math.abs(lx) <= w / 2 && Math.abs(ly) <= h / 2;
}

// The area artwork should stay inside, as a rounded rectangle.
function safeShape() {
  const gap = P.border.gap ?? Math.min(0.25, P.border.inset);
  const m = border.style === 'none' ? P.safeMargin : Math.max(P.safeMargin, P.border.inset + borderBand() + gap);
  const hw = DW / 2 - m, hh = DH / 2 - m;
  return { hw, hh, r: Math.min(Math.max(0, P.cornerR - m), hw, hh) };
}
function insideShape(p, s) {
  const ax = Math.abs(p.x), ay = Math.abs(p.y);
  if (ax > s.hw + 0.01 || ay > s.hh + 0.01) return false;
  const cx = s.hw - s.r, cy = s.hh - s.r;
  if (ax > cx && ay > cy) return Math.hypot(ax - cx, ay - cy) <= s.r + 0.01;
  return true;
}
function overlapsRect(poly, r) {
  const rect = [{ x: r.x0, y: r.y0 }, { x: r.x1, y: r.y0 }, { x: r.x1, y: r.y1 }, { x: r.x0, y: r.y1 }];
  const axes = [];
  for (const pg of [poly, rect]) for (let i = 0; i < 4; i++) {
    const a = pg[i], b = pg[(i + 1) % 4]; axes.push({ x: -(b.y - a.y), y: b.x - a.x });
  }
  return axes.every((ax) => {
    const pr = (pg) => pg.map((p) => p.x * ax.x + p.y * ax.y);
    const A = pr(poly), B = pr(rect);
    return Math.max(...A) > Math.min(...B) + 1e-6 && Math.max(...B) > Math.min(...A) + 1e-6;
  });
}
function quadsOverlap(a, b) {
  const axes = [];
  for (const pg of [a, b]) for (let i = 0; i < 4; i++) { const p = pg[i], q = pg[(i + 1) % 4]; axes.push({ x: -(q.y - p.y), y: q.x - p.x }); }
  return axes.every((ax) => {
    const A = a.map((p) => p.x * ax.x + p.y * ax.y), B = b.map((p) => p.x * ax.x + p.y * ax.y);
    return Math.max(...A) > Math.min(...B) + 1e-6 && Math.max(...B) > Math.min(...A) + 1e-6;
  });
}
function problem(e) {
  if (e.path) return null;
  const cs = corners(e);
  if (P.keepOut && overlapsRect(cs, P.keepOut)) return 'photo';
  const s = safeShape();
  if (!isMasked(e) && cs.some((p) => !insideShape(p, s))) return 'edge';
  if (P.family && e.type !== 'cutout') {
    const c = els.find((x) => x.type === 'cutout');
    if (c && quadsOverlap(cs, corners(c))) return 'under';
  }
  return null;
}
function rotKnob(e) {
  const cs = corners(e).map((p) => toScreen(p.x, p.y));
  const mid = { x: (cs[0].x + cs[1].x) / 2, y: (cs[0].y + cs[1].y) / 2 };
  const cen = toScreen(e.x, e.y);
  const dx = mid.x - cen.x, dy = mid.y - cen.y;
  const L = Math.hypot(dx, dy) || 1;
  return { mid, knob: { x: mid.x + dx / L * 30, y: mid.y + dy / L * 30 }, cs };
}

/* ---------------------------------------------------------------
   Engraving mask
---------------------------------------------------------------- */
function clipToMask(ctx, X, Y) {
  const pts = maskPolygon();
  ctx.beginPath(); pts.forEach((p, i) => (i ? ctx.lineTo(X(p.x), Y(p.y)) : ctx.moveTo(X(p.x), Y(p.y)))); ctx.closePath();
  ctx.clip();
}
function renderMask() {
  const key = borderKey();
  for (const e of els) if (e.path && e.pathKey !== key) buildPathText(e);
  const mctx = P.mask.canvas.getContext('2d');
  mctx.clearRect(0, 0, MW, MH);
  mctx.fillStyle = mctx.strokeStyle = '#000';
  mctx.globalAlpha = 0.95;
  drawBorder(mctx, (x) => (x + DW / 2) * PPI, (y) => (y + DH / 2) * PPI, PPI);
  mctx.globalAlpha = 1;
  const tctx = P.topMask ? P.topMask.canvas.getContext('2d') : null;
  if (tctx) tctx.clearRect(0, 0, MW, MH);
  for (const e of els) {
    const { w, h } = dims(e);
    const ctx = e.type === 'cutout' ? tctx : mctx;
    if (!ctx) continue;
    ctx.save();
    if (isMasked(e)) clipToMask(ctx, (x) => (x + DW / 2) * PPI, (y) => (y + DH / 2) * PPI);
    ctx.globalAlpha = e.darkness;
    ctx.translate((e.x + DW / 2) * PPI, (e.y + DH / 2) * PPI);
    ctx.rotate(e.rot * Math.PI / 180);
    if (e.flip) ctx.scale(-1, 1);
    ctx.drawImage(e.bmp, -w * PPI / 2, -h * PPI / 2, w * PPI, h * PPI);
    ctx.restore();
  }
  if (tctx) P.topMask.tex.needsUpdate = true;
  syncCutout();
  P.mask.tex.needsUpdate = true;
  requestRender();
}

/* ---------------------------------------------------------------
   Overlay: safe area, selection, guides
---------------------------------------------------------------- */
let guides = { x: false, y: false };
let hoverId = null;
let dragging = false;

function poly(pts, close = true) { octx.beginPath(); pts.forEach((p, i) => i ? octx.lineTo(p.x, p.y) : octx.moveTo(p.x, p.y)); if (close) octx.closePath(); }
function shapePoints(s) {
  const pts = [], n = 10;
  const arc = (cx, cy, a0) => { for (let i = 0; i <= n; i++) { const a = a0 + i / n * Math.PI / 2; pts.push({ x: cx + s.r * Math.cos(a), y: cy + s.r * Math.sin(a) }); } };
  arc(s.hw - s.r, -s.hh + s.r, -Math.PI / 2); arc(s.hw - s.r, s.hh - s.r, 0);
  arc(-s.hw + s.r, s.hh - s.r, Math.PI / 2); arc(-s.hw + s.r, -s.hh + s.r, Math.PI);
  return pts;
}

function drawOverlay() {
  octx.setTransform(DPR, 0, 0, DPR, 0, 0);
  octx.clearRect(0, 0, W, H);
  const sel = getSel();
  if (view === 'flat' || dragging) {
    octx.setLineDash([6, 6]);
    octx.lineWidth = 1.25;
    octx.strokeStyle = 'rgba(70,52,34,0.45)';
    poly(shapePoints(safeShape()).map((p) => toScreen(p.x, p.y))); octx.stroke();
    if (P.keepOut) {
      const k = P.keepOut;
      poly([[k.x0, k.y0], [k.x1, k.y0], [k.x1, k.y1], [k.x0, k.y1]].map(([x, y]) => toScreen(x, y))); octx.stroke();
    }
    octx.setLineDash([]);
  }
  octx.strokeStyle = 'rgba(214,64,39,0.9)';
  octx.lineWidth = 1;
  if (guides.x) { const a = toScreen(0, -DH / 2), b = toScreen(0, DH / 2); octx.beginPath(); octx.moveTo(a.x, a.y); octx.lineTo(b.x, b.y); octx.stroke(); }
  if (guides.y) { const a = toScreen(-DW / 2, 0), b = toScreen(DW / 2, 0); octx.beginPath(); octx.moveTo(a.x, a.y); octx.lineTo(b.x, b.y); octx.stroke(); }

  for (const e of els) {
    const bad = problem(e);
    if (e.id !== selId && (e.id === hoverId || bad)) {
      poly(corners(e).map((p) => toScreen(p.x, p.y)));
      octx.lineWidth = 1.25;
      octx.setLineDash(bad ? [4, 4] : []);
      octx.strokeStyle = bad ? '#d9822b' : 'rgba(70,52,34,0.55)';
      octx.stroke();
      octx.setLineDash([]);
    }
  }
  if (sel && sel.path) {
    poly(pathBand(sel).map((p) => toScreen(p.x, p.y)));
    octx.lineWidth = 1.5; octx.strokeStyle = '#d64027'; octx.stroke();
  } else if (sel) {
    const color = problem(sel) ? '#d9822b' : '#d64027';
    const { mid, knob, cs } = rotKnob(sel);
    poly(cs);
    octx.lineWidth = 1.5; octx.strokeStyle = color; octx.stroke();
    octx.beginPath(); octx.moveTo(mid.x, mid.y); octx.lineTo(knob.x, knob.y); octx.stroke();
    octx.fillStyle = '#ffffff';
    for (const p of cs) { octx.beginPath(); octx.rect(p.x - 5.5, p.y - 5.5, 11, 11); octx.fill(); octx.stroke(); }
    octx.beginPath(); octx.arc(knob.x, knob.y, 7, 0, Math.PI * 2); octx.fill(); octx.stroke();
    octx.beginPath(); octx.arc(knob.x, knob.y, 3, 0.4, Math.PI * 1.6); octx.stroke();
  }
}

/* ---------------------------------------------------------------
   Pointer interaction
---------------------------------------------------------------- */
const pointers = new Map();
let drag = null;

function local(ev) { const r = overlay.getBoundingClientRect(); return { x: ev.clientX - r.left, y: ev.clientY - r.top }; }
function hitHandle(e, p, touch) {
  if (e.path) return null;
  const tol = touch ? 22 : 12;
  const { knob, cs } = rotKnob(e);
  if (Math.hypot(p.x - knob.x, p.y - knob.y) < tol) return { type: 'rotate' };
  for (let i = 0; i < 4; i++) if (Math.hypot(p.x - cs[i].x, p.y - cs[i].y) < tol) return { type: 'scale', i };
  return null;
}
function topHit(bp) {
  for (let i = els.length - 1; i >= 0; i--) if (contains(els[i], bp)) return els[i];
  return null;
}

overlay.addEventListener('pointerdown', (ev) => {
  if (!P) return;
  overlay.setPointerCapture(ev.pointerId);
  const p = local(ev);
  pointers.set(ev.pointerId, p);
  if (pointers.size === 2) {
    const [a, b] = [...pointers.values()];
    drag = { mode: 'pinch', d0: Math.hypot(a.x - b.x, a.y - b.y), zoom0: cam.zoom };
    return;
  }
  if (camAnim) { camAnim = null; }
  const touch = ev.pointerType !== 'mouse';
  const bp = toBoard(p.x, p.y);
  const sel = getSel();
  if (sel) {
    const h = hitHandle(sel, p, touch);
    if (h && bp) {
      const d0 = Math.hypot(bp.x - sel.x, bp.y - sel.y) || 0.001;
      drag = h.type === 'scale'
        ? { mode: 'scale', e: sel, d0, ipp0: sel.ipp }
        : { mode: 'rotate', e: sel, a0: Math.atan2(bp.y - sel.y, bp.x - sel.x), rot0: sel.rot };
      dragging = true;
      return;
    }
  }
  const hit = bp && topHit(bp);
  if (hit) {
    select(hit.id);
    if (hit.path) {
      const sm = pathSampler(hit);
      drag = { mode: 'slide', e: hit, off: nearestOnPath(sm, bp).s - hit.pathS * sm.total, moved: false };
    } else drag = { mode: 'move', e: hit, ox: bp.x - hit.x, oy: bp.y - hit.y, moved: false };
    dragging = true;
    overlay.style.cursor = 'grabbing';
    return;
  }
  select(null);
  drag = view === '3d' ? { mode: 'orbit', p0: p, th0: cam.theta, ph0: cam.phi } : { mode: 'pan', p0: p, pu0: cam.pu, pv0: cam.pv };
});

overlay.addEventListener('pointermove', (ev) => {
  if (!P) return;
  const p = local(ev);
  if (pointers.has(ev.pointerId)) pointers.set(ev.pointerId, p);
  if (!drag) { updateHover(p, ev.pointerType !== 'mouse'); return; }
  const bp = toBoard(p.x, p.y);
  if (drag.mode === 'pinch') {
    if (pointers.size < 2) return;
    const [a, b] = [...pointers.values()];
    cam.zoom = THREE.MathUtils.clamp(drag.zoom0 * Math.hypot(a.x - b.x, a.y - b.y) / drag.d0, 0.6, 4);
    requestRender();
  } else if (drag.mode === 'orbit') {
    cam.theta = drag.th0 - (p.x - drag.p0.x) * 0.008;
    cam.phi = THREE.MathUtils.clamp(drag.ph0 - (p.y - drag.p0.y) * 0.006, 0.08, 1.5);
    requestRender();
  } else if (drag.mode === 'pan') {
    if (cam.zoom <= 1.001) return;
    const pose = poseFlat();
    const k = pose.pos.distanceTo(pose.target) * Math.tan(THREE.MathUtils.degToRad(camera.fov) / 2) * 2 / H;
    cam.pu = THREE.MathUtils.clamp(drag.pu0 - (p.x - drag.p0.x) * k, -DW / 2, DW / 2);
    cam.pv = THREE.MathUtils.clamp(drag.pv0 - (p.y - drag.p0.y) * k, -DH / 2, DH / 2);
    requestRender();
  } else if (bp) {
    const e = drag.e;
    if (drag.mode === 'slide') {
      const sm = pathSampler(e);
      const s = nearestOnPath(sm, bp).s - drag.off;
      e.pathS = (((s / sm.total) % 1) + 1) % 1;
      buildPathText(e);
    } else if (drag.mode === 'move') {
      let nx = bp.x - drag.ox, ny = bp.y - drag.oy;
      const snap = Math.max(0.06, Math.min(DW, DH) * 0.018);
      guides.x = Math.abs(nx) < snap; guides.y = Math.abs(ny) < snap;
      if (guides.x) nx = 0; if (guides.y) ny = 0;
      e.x = THREE.MathUtils.clamp(nx, -DW / 2, DW / 2);
      e.y = THREE.MathUtils.clamp(ny, -DH / 2, DH / 2);
    } else if (drag.mode === 'scale') {
      const d = Math.hypot(bp.x - e.x, bp.y - e.y);
      const minIpp = Math.min(0.25, Math.min(DW, DH) * 0.04) / Math.min(e.bmp.width, e.bmp.height), maxIpp = (Math.max(DW, DH) * 1.6) / Math.max(e.bmp.width, e.bmp.height);
      e.ipp = THREE.MathUtils.clamp(drag.ipp0 * d / drag.d0, minIpp, maxIpp);
    } else if (drag.mode === 'rotate') {
      let r = drag.rot0 + (Math.atan2(bp.y - e.y, bp.x - e.x) - drag.a0) * 180 / Math.PI;
      r = ((r % 360) + 540) % 360 - 180;
      if (ev.shiftKey) r = Math.round(r / 15) * 15;
      else { const near = Math.round(r / 45) * 45; if (Math.abs(r - near) < 3) r = near; }
      e.rot = r;
    }
    drag.moved = true;
    renderMask();
    syncReadouts();
  }
});

function endPointer(ev) {
  pointers.delete(ev.pointerId);
  if (drag && drag.mode === 'pinch') { drag = null; return; }
  if (drag && drag.moved) commit();
  drag = null; dragging = false;
  guides = { x: false, y: false };
  overlay.style.cursor = 'default';
  if (P) { updateLayers(); requestRender(); }
}
overlay.addEventListener('pointerup', endPointer);
overlay.addEventListener('pointercancel', endPointer);

function updateHover(p, touch) {
  const bp = toBoard(p.x, p.y);
  const sel = getSel();
  let cursor = 'default';
  if (sel) { const h = hitHandle(sel, p, touch); if (h) cursor = h.type === 'rotate' ? 'grab' : (h.i % 2 ? 'nesw-resize' : 'nwse-resize'); }
  const hit = bp && topHit(bp);
  if (cursor === 'default' && hit) cursor = 'move';
  if (cursor === 'default' && view === '3d') cursor = 'grab';
  overlay.style.cursor = cursor;
  const id = hit ? hit.id : null;
  if (id !== hoverId) { hoverId = id; requestRender(); }
}

overlay.addEventListener('wheel', (ev) => {
  if (!P) return;
  ev.preventDefault();
  camAnim = null;
  cam.zoom = THREE.MathUtils.clamp(cam.zoom * Math.exp(-ev.deltaY * 0.0015), 0.6, 4);
  if (cam.zoom <= 1) { cam.pu *= 0.8; cam.pv *= 0.8; }
  requestRender();
}, { passive: false });

window.addEventListener('keydown', (ev) => {
  if (!P || $('designer').hidden) return;
  const tgt = (ev.composedPath && ev.composedPath()[0]) || ev.target;
  const tag = (tgt.tagName || '').toLowerCase();
  if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
  const mod = ev.metaKey || ev.ctrlKey;
  if (mod && ev.key.toLowerCase() === 'z') { ev.preventDefault(); ev.shiftKey ? redo() : undo(); return; }
  if (mod && ev.key.toLowerCase() === 'y') { ev.preventDefault(); redo(); return; }
  const sel = getSel();
  if (!sel) return;
  if (mod && ev.key.toLowerCase() === 'd') { ev.preventDefault(); duplicate(sel); return; }
  if (ev.key === 'Delete' || ev.key === 'Backspace') { ev.preventDefault(); remove(sel); return; }
  if (ev.key === 'Escape') { select(null); return; }
  const step = (ev.shiftKey ? 1 : 0.1) * Math.min(1, Math.min(DW, DH) / 8);
  const moves = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] };
  if (moves[ev.key]) {
    ev.preventDefault();
    sel.x += moves[ev.key][0]; sel.y += moves[ev.key][1];
    renderMask(); syncReadouts(); scheduleCommit();
  }
});

/* ---------------------------------------------------------------
   History (per product)
---------------------------------------------------------------- */
function snapshot() { return { els: els.map((e) => ({ ...e })), selId, border: { ...border } }; }
function commit() {
  hist.stack = hist.stack.slice(0, hist.i + 1);
  hist.stack.push(snapshot());
  if (hist.stack.length > 80) hist.stack.shift();
  hist.i = hist.stack.length - 1;
  updateHistoryButtons();
}
let commitTimer = null;
function scheduleCommit() { clearTimeout(commitTimer); commitTimer = setTimeout(commit, 400); }
function restore(s) {
  els = s.els.map((e) => ({ ...e }));
  selId = els.some((e) => e.id === s.selId) ? s.selId : null;
  border = { ...s.border };
  renderBorderUI();
  renderMask(); updateLayers(); renderProps(); updateHistoryButtons();
}
function undo() { if (hist.i > 0) { hist.i--; restore(hist.stack[hist.i]); } }
function redo() { if (hist.i < hist.stack.length - 1) { hist.i++; restore(hist.stack[hist.i]); } }
function updateHistoryButtons() {
  $('undoBtn').disabled = hist.i <= 0;
  $('redoBtn').disabled = hist.i >= hist.stack.length - 1;
  $('proofBtn').disabled = els.length === 0 && border.style === 'none';
}
$('undoBtn').onclick = undo;
$('redoBtn').onclick = redo;
/* ---------------------------------------------------------------
   Border
---------------------------------------------------------------- */
const BORDER_STYLES = [
  { id: 'single', label: 'Single' },
  { id: 'double', label: 'Double' },
  { id: 'thickthin', label: 'Thick + thin' },
  { id: 'triple', label: 'Triple' },
  { id: 'dashed', label: 'Dashed' },
  { id: 'dotted', label: 'Dotted' },
  { id: 'midcentury', label: 'Mid-century' },
  { id: 'rope', label: 'Rope' },
  { id: 'deco', label: 'Deco', squareOnly: true },
  { id: 'crosshair', label: 'Crosshair', squareOnly: true },
  { id: 'chamfer', label: 'Chamfer', squareOnly: true },
  { id: 'layered', label: 'Layered', squareOnly: true },
];

// Geometric corner ornaments. Coordinates are local to the top-left corner (x and y run inward),
// in inches; every corner gets a mirrored copy.
const sizeK = () => Math.min(1, Math.min(DW, DH) / 9);
const decoU = (t) => Math.min(1, Math.max(t * 9, 0.5)) * sizeK();
function decoSpec(style, u) {
  const sq = (x, y, s, rot = 0) => {
    const cx = x + s / 2, cy = y + s / 2, r = rot * Math.PI / 180;
    return [[-1, -1], [1, -1], [1, 1], [-1, 1]].map(([a, b]) => [cx + (a * Math.cos(r) - b * Math.sin(r)) * s / 2, cy + (a * Math.sin(r) + b * Math.cos(r)) * s / 2]);
  };
  switch (style) {
    case 'deco': return { // tilted double square, offset double line
      rails: [{ a: 0, x0: 1.0 * u }],
      lines: [[1.25 * u, 0.3 * u, 4.2 * u, 0.3 * u]],
      shapes: [{ pts: sq(0.08 * u, 0.08 * u, 0.68 * u, 10) }, { pts: sq(0.25 * u, 0.25 * u, 0.34 * u, 10), thin: true }],
      dots: [],
    };
    case 'crosshair': return { // lines cross at a framed square, dot-tipped accents
      rails: [{ a: 0.75 * u, x0: 0.4 * u }],
      lines: [[1.2 * u, 0.35 * u, 4.0 * u, 0.35 * u]],
      shapes: [{ pts: sq(0, 0, 0.75 * u) }, { pts: sq(0.19 * u, 0.19 * u, 0.37 * u), thin: true }],
      dots: [[0.375 * u, 0.375 * u, 0.075 * u], [4.15 * u, 0.35 * u, 0.1 * u]],
    };
    case 'chamfer': return { // clipped corner, small bracket, angled accent
      rails: [{ a: 0.2 * u, x0: 0.75 * u }],
      lines: [[0, 0, 0.5 * u, 0], [0.75 * u, 0.2 * u, 0.2 * u, 0.75 * u], [1.5 * u, 0.5 * u, 3.8 * u, 0.5 * u], [3.8 * u, 0.5 * u, 4.1 * u, 0.2 * u]],
      shapes: [{ pts: sq(0.55 * u, 0.55 * u, 0.6 * u) }, { pts: sq(0.7 * u, 0.7 * u, 0.3 * u), thin: true }],
      dots: [],
    };
    case 'layered': return { // two overlapping squares at each corner
      rails: [{ a: 0, x0: 0.45 * u }],
      lines: [[1.55 * u, 0.3 * u, 4.2 * u, 0.3 * u]],
      shapes: [{ pts: sq(0.15 * u, 0.15 * u, 0.6 * u) }, { pts: sq(0.42 * u, 0.42 * u, 0.7 * u) }],
      dots: [],
    };
  }
}
function drawDeco(ctx, X, Y, k, b, o, t) {
  const u = decoU(t), sp = decoSpec(b.style, u);
  const hw = DW / 2 - o, hh = DH / 2 - o;
  ctx.lineCap = 'square'; ctx.lineJoin = 'miter';
  const seg = (x1, y1, x2, y2, w) => { ctx.lineWidth = w * k; ctx.beginPath(); ctx.moveTo(X(x1), Y(y1)); ctx.lineTo(X(x2), Y(y2)); ctx.stroke(); };
  for (const r of sp.rails) {
    seg(-hw + r.x0, -hh + r.a, hw - r.x0, -hh + r.a, t); seg(-hw + r.x0, hh - r.a, hw - r.x0, hh - r.a, t);
    seg(-hw + r.a, -hh + r.x0, -hw + r.a, hh - r.x0, t); seg(hw - r.a, -hh + r.x0, hw - r.a, hh - r.x0, t);
  }
  for (const [sx, sy] of [[1, 1], [-1, 1], [1, -1], [-1, -1]]) {
    const P = (x, y) => [-sx * hw + sx * x, -sy * hh + sy * y];
    for (const [x1, y1, x2, y2] of sp.lines) for (const tr of [false, true]) {
      const a = tr ? P(y1, x1) : P(x1, y1), c = tr ? P(y2, x2) : P(x2, y2);
      seg(a[0], a[1], c[0], c[1], t);
    }
    for (const sh of sp.shapes) {
      ctx.lineWidth = (sh.thin ? 0.7 : 0.85) * t * k;
      ctx.beginPath();
      sh.pts.forEach(([x, y], i) => { const q = P(x, y); i ? ctx.lineTo(X(q[0]), Y(q[1])) : ctx.moveTo(X(q[0]), Y(q[1])); });
      ctx.closePath(); ctx.stroke();
    }
    for (const [x, y, r] of sp.dots) for (const tr of [false, true]) {
      const q = tr ? P(y, x) : P(x, y);
      ctx.beginPath(); ctx.arc(X(q[0]), Y(q[1]), r * k, 0, Math.PI * 2); ctx.fill();
    }
  }
}

const bGap = (t) => Math.max(t * 1.2, 0.06);
const mcR = (t) => Math.max(t * 5, 0.34 * sizeK()); // starburst radius
function borderBand(b = border) {
  const t = b.weight;
  switch (b.style) {
    case 'none': return 0;
    case 'single': case 'dashed': return t;
    case 'double': return t * 2 + bGap(t);
    case 'thickthin': return t + bGap(t) * 0.8 + Math.max(t * 0.4, 0.02);
    case 'triple': return t * 3 + bGap(t) * 2;
    case 'dotted': return t * 1.6;
    case 'midcentury': return mcR(t) * 2;
    case 'rope': return Math.max(t * 3, 0.16);
    case 'deco': case 'crosshair': case 'chamfer': case 'layered': return decoU(t) * 1.2 + t / 2;
  }
  return t;
}
function borderLabel(b = border) { const st = BORDER_STYLES.find((s) => s.id === b.style); return st ? st.label : 'None'; }

// Rounded-rectangle path parallel to the board edge, `d` inches inside it.
function rrGeom(d, b, minR = 0) {
  const hw = DW / 2 - d, hh = DH / 2 - d;
  const round = P.round || b.corners === 'match';
  const r = Math.min(Math.max(minR, round ? P.cornerR - d : 0), hw, hh);
  return { hw, hh, r };
}
function rrSampler(d, b, minR = 0) {
  const { hw, hh, r } = rrGeom(d, b, minR);
  const segs = [];
  const line = (x0, y0, x1, y1, nx, ny) => segs.push({ len: Math.hypot(x1 - x0, y1 - y0), at: (u) => ({ x: x0 + (x1 - x0) * u, y: y0 + (y1 - y0) * u, nx, ny }) });
  const arc = (cx, cy, a0) => segs.push({ len: r * Math.PI / 2, at: (u) => { const a = a0 + u * Math.PI / 2; return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a), nx: Math.cos(a), ny: Math.sin(a) }; } });
  line(-hw + r, -hh, hw - r, -hh, 0, -1); arc(hw - r, -hh + r, -Math.PI / 2);
  line(hw, -hh + r, hw, hh - r, 1, 0);    arc(hw - r, hh - r, 0);
  line(hw - r, hh, -hw + r, hh, 0, 1);    arc(-hw + r, hh - r, Math.PI / 2);
  line(-hw, hh - r, -hw, -hh + r, -1, 0); arc(-hw + r, -hh + r, Math.PI);
  const total = segs.reduce((a, s) => a + s.len, 0);
  return {
    total, segs,
    at(s) {
      s = ((s % total) + total) % total;
      for (const g of segs) { if (s <= g.len || g === segs[segs.length - 1]) return g.at(g.len ? Math.min(1, s / g.len) : 0); s -= g.len; }
    },
  };
}

// Draw the border with the context's current colour. `X`/`Y` map board inches to pixels, `k` is pixels per inch.
function drawBorder(ctx, X, Y, k, b = border) {
  if (b.style === 'none') return;
  const o = P.border.inset, t = b.weight;
  const rr = (d) => {
    const { hw, hh, r } = rrGeom(d, b);
    ctx.beginPath();
    ctx.moveTo(X(-hw + r), Y(-hh));
    ctx.lineTo(X(hw - r), Y(-hh));
    if (r) ctx.arc(X(hw - r), Y(-hh + r), r * k, -Math.PI / 2, 0);
    ctx.lineTo(X(hw), Y(hh - r));
    if (r) ctx.arc(X(hw - r), Y(hh - r), r * k, 0, Math.PI / 2);
    ctx.lineTo(X(-hw + r), Y(hh));
    if (r) ctx.arc(X(-hw + r), Y(hh - r), r * k, Math.PI / 2, Math.PI);
    ctx.lineTo(X(-hw), Y(-hh + r));
    if (r) ctx.arc(X(-hw + r), Y(-hh + r), r * k, Math.PI, Math.PI * 1.5);
    ctx.closePath();
  };
  const strokeAt = (d, w) => { rr(d + w / 2); ctx.lineWidth = w * k; ctx.stroke(); };
  const periodic = (total, want) => total / Math.max(1, Math.round(total / want));
  ctx.save();
  ctx.lineJoin = 'round'; ctx.lineCap = 'butt';
  const g = bGap(t);
  switch (b.style) {
    case 'deco': case 'crosshair': case 'chamfer': case 'layered': drawDeco(ctx, X, Y, k, b, o, t); break;
    case 'single': strokeAt(o, t); break;
    case 'double': strokeAt(o, t); strokeAt(o + t + g, t); break;
    case 'triple': strokeAt(o, t); strokeAt(o + t + g, t); strokeAt(o + 2 * (t + g), t); break;
    case 'thickthin': strokeAt(o, t); strokeAt(o + t + g * 0.8, Math.max(t * 0.4, 0.02)); break;
    case 'dashed': {
      const sm = rrSampler(o + t / 2, b);
      const p = periodic(sm.total, Math.max(t * 6, 0.4));
      ctx.setLineDash([p * 0.62 * k, p * 0.38 * k]);
      ctx.lineDashOffset = -p * 0.19 * k;
      strokeAt(o, t);
      break;
    }
    case 'dotted': {
      const rad = t * 0.8, sm = rrSampler(o + rad, b);
      const p = periodic(sm.total, Math.max(t * 2.6, 0.12));
      for (let s = 0; s < sm.total - p / 2; s += p) { const q = sm.at(s); ctx.beginPath(); ctx.arc(X(q.x), Y(q.y), rad * k, 0, Math.PI * 2); ctx.fill(); }
      break;
    }
    case 'midcentury': {
      // Atomic starbursts at the corners, capsule-and-dot rhythm along the sides.
      const R = mcR(t), c = o + R, sm = rrSampler(c, b);
      const dr = t * 0.85, L = R * 1.05, g0 = Math.max(t * 1.6, 0.09);
      ctx.lineCap = 'round';
      sm.segs.forEach((seg, i) => {
        if (i % 2) {
          const q = seg.at(0.5), base = Math.atan2(q.ny, q.nx);
          ctx.lineWidth = Math.max(t * 0.4, 0.016) * k;
          for (let r = 0; r < 12; r++) {
            const a = base + r * Math.PI / 6, len = r % 2 ? R * 0.52 : (r % 3 ? R * 0.8 : R);
            ctx.beginPath();
            ctx.moveTo(X(q.x + Math.cos(a) * dr * 2), Y(q.y + Math.sin(a) * dr * 2));
            ctx.lineTo(X(q.x + Math.cos(a) * len), Y(q.y + Math.sin(a) * len));
            ctx.stroke();
          }
          ctx.beginPath(); ctx.arc(X(q.x), Y(q.y), dr * 1.1 * k, 0, Math.PI * 2); ctx.fill();
          return;
        }
        const clear = R + g0 * 1.2, A = seg.len - clear * 2;
        if (A < L) return;
        const n = Math.max(1, Math.floor((A - L) / (L + 3 * g0 + 4 * dr)));
        const rep = (A - L) / n, g = (rep - L - 4 * dr) / 3;
        const tx = -seg.at(0).ny, ty = seg.at(0).nx;
        const P = (sl) => seg.at((clear + sl) / seg.len);
        ctx.lineWidth = t * k;
        for (let m = 0; m <= n; m++) {
          const s0 = m * rep, a = P(s0), z = P(s0 + L);
          ctx.beginPath(); ctx.moveTo(X(a.x + tx * t / 2), Y(a.y + ty * t / 2)); ctx.lineTo(X(z.x - tx * t / 2), Y(z.y - ty * t / 2)); ctx.stroke();
          if (m === n) break;
          for (const off of [L + g + dr, L + 2 * g + 3 * dr]) { const d = P(s0 + off); ctx.beginPath(); ctx.arc(X(d.x), Y(d.y), dr * k, 0, Math.PI * 2); ctx.fill(); }
        }
      });
      break;
    }
    case 'rope': {
      const bw = Math.max(t * 3, 0.16), mid = o + bw / 2, sm = rrSampler(mid, b, bw * 1.3);
      const p = periodic(sm.total, bw * 0.55);
      ctx.lineWidth = Math.max(t * 0.75, 0.025) * k; ctx.lineCap = 'round';
      const half = bw / 2 - t * 0.4;
      const s0 = sm.segs[0].len / 2; // start mid-side so the seam is hidden
      for (let s = s0; s < s0 + sm.total - p / 2; s += p) {
        const a = sm.at(s - p * 0.7), m = sm.at(s), c = sm.at(s + p * 0.7);
        ctx.beginPath();
        ctx.moveTo(X(a.x - a.nx * half), Y(a.y - a.ny * half));
        ctx.quadraticCurveTo(X(m.x), Y(m.y), X(c.x + c.nx * half), Y(c.y + c.ny * half));
        ctx.stroke();
      }
      break;
    }
  }
  ctx.restore();
}

/* ---------------------------------------------------------------
   Text that follows the border (or runs around a circle)
---------------------------------------------------------------- */
const PATH_RES = 220;   // pixels per inch when drawing path text
const measureCtx = document.createElement('canvas').getContext('2d');

function pathOffset(size) {
  const gap = P.border.gap ?? Math.min(0.25, P.border.inset);
  const edge = border.style !== 'none' ? P.border.inset + borderBand() + gap * 0.8 : Math.max(0.15, Math.min(P.safeMargin, 0.45));
  return edge + size / 2;
}
function pathSampler(e) { return rrSampler(pathOffset(e.pathSize), { corners: 'match' }, e.pathSize); }
function pathDefaults(e) {
  if (e.pathSize == null) e.pathSize = +Math.min(P.text.lineH * 0.85, Math.min(DW, DH) * 0.09).toFixed(2);
  if (e.track == null) e.track = 0.06;
  if (e.pathS == null) { const sm = pathSampler(e); e.pathS = (sm.segs[0].len / 2) / sm.total + (P.family ? 0.5 : 0); }
}
function pathTopS(e) { const sm = pathSampler(e); return (sm.segs[0].len / 2) / sm.total; }

function pathLayout(e) {
  const size = e.pathSize, sm = pathSampler(e);
  const f = FONTS.find((x) => x.id === e.font) || FONTS[0];
  measureCtx.font = `${f.weight} ${size * PATH_RES}px "${f.family}"`;
  const chars = [...(e.text.replace(/\s*\n\s*/g, ' ').trim() || ' ')];
  const cw = chars.map((c) => measureCtx.measureText(c).width / PATH_RES);
  const tr = e.track * size;
  const L = cw.reduce((a, b) => a + b, 0) + tr * (chars.length - 1);
  const sc = e.pathS * sm.total;
  const inward = sm.at(sc).y > 0.001;            // lower half reads upright, tops toward the middle
  let acc = 0;
  const glyphs = chars.map((c, i) => {
    const off = acc + cw[i] / 2; acc += cw[i] + tr;
    const s = inward ? sc + L / 2 - off : sc - L / 2 + off;
    const q = sm.at(s);
    const a = Math.atan2(q.nx, -q.ny) + (inward ? Math.PI : 0);
    return { c, x: q.x, y: q.y, a, w: cw[i] };
  });
  let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
  for (const g of glyphs) {
    const hx = g.w / 2 + size * 0.1, hy = size * 0.62, ca = Math.cos(g.a), sa = Math.sin(g.a);
    for (const [u, v] of [[-hx, -hy], [hx, -hy], [hx, hy], [-hx, hy]]) {
      const X = g.x + u * ca - v * sa, Y = g.y + u * sa + v * ca;
      x0 = Math.min(x0, X); x1 = Math.max(x1, X); y0 = Math.min(y0, Y); y1 = Math.max(y1, Y);
    }
  }
  return { sm, sc, L, inward, glyphs, f, box: { x0, y0, x1, y1 } };
}

function buildPathText(e, res = PATH_RES) {
  const lay = pathLayout(e), b = lay.box, size = e.pathSize;
  const bw = b.x1 - b.x0, bh = b.y1 - b.y0;
  const R = Math.min(res, (res > PATH_RES ? 9000 : 4000) / Math.max(bw, bh, 0.01));
  const c = document.createElement('canvas');
  c.width = Math.max(1, Math.ceil(bw * R)); c.height = Math.max(1, Math.ceil(bh * R));
  const ctx = c.getContext('2d');
  ctx.fillStyle = '#000'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.font = `${lay.f.weight} ${size * R}px "${lay.f.family}"`;
  for (const g of lay.glyphs) {
    ctx.save(); ctx.translate((g.x - b.x0) * R, (g.y - b.y0) * R); ctx.rotate(g.a); ctx.fillText(g.c, 0, 0); ctx.restore();
  }
  Object.assign(e, { bmp: c, ipp: 1 / R, x: (b.x0 + b.x1) / 2, y: (b.y0 + b.y1) / 2, rot: 0, flip: false, pathLen: lay.L, pathKey: borderKey() });
}
function borderKey() { return `${border.style}|${border.weight}|${border.corners}`; }

// Nearest position along the text's path to a point, as a distance along the path.
function nearestOnPath(sm, p) {
  let best = 0, bd = Infinity;
  const n = 480;
  for (let i = 0; i < n; i++) {
    const s = i / n * sm.total, q = sm.at(s), d = Math.hypot(q.x - p.x, q.y - p.y);
    if (d < bd) { bd = d; best = s; }
  }
  return { s: best, d: bd };
}
function containsPath(e, p) {
  const sm = pathSampler(e), { s, d } = nearestOnPath(sm, p);
  if (d > e.pathSize * 0.75) return false;
  const sc = e.pathS * sm.total;
  let ds = Math.abs(s - sc) % sm.total; ds = Math.min(ds, sm.total - ds);
  return ds <= e.pathLen / 2 + e.pathSize * 0.3;
}
function pathBand(e) {
  const sm = pathSampler(e), sc = e.pathS * sm.total, h = e.pathSize * 0.62, L = e.pathLen + e.pathSize * 0.3;
  const outer = [], inner = [], n = 40;
  for (let i = 0; i <= n; i++) {
    const q = sm.at(sc - L / 2 + L * i / n);
    outer.push({ x: q.x + q.nx * h, y: q.y + q.ny * h }); inner.push({ x: q.x - q.nx * h, y: q.y - q.ny * h });
  }
  return outer.concat(inner.reverse());
}
const MAX_SRC = 2048;

function imageToSrc(img, w, h) {
  const k = Math.min(1, MAX_SRC / Math.max(w, h));
  const cw = Math.max(1, Math.round(w * k)), ch = Math.max(1, Math.round(h * k));
  const c = document.createElement('canvas'); c.width = cw; c.height = ch;
  const ctx = c.getContext('2d', { willReadFrequently: true });
  ctx.drawImage(img, 0, 0, cw, ch);
  const d = ctx.getImageData(0, 0, cw, ch).data;
  const n = cw * ch, L = new Uint8ClampedArray(n), A = new Uint8ClampedArray(n);
  let mid = 0, solid = 0;
  for (let i = 0; i < n; i++) {
    const r = d[i * 4], g = d[i * 4 + 1], b = d[i * 4 + 2], a = d[i * 4 + 3];
    const l = 0.299 * r + 0.587 * g + 0.114 * b;
    L[i] = l; A[i] = a;
    if (a > 128) { solid++; if (l > 45 && l < 210) mid++; }
  }
  const trimmed = trimSrc({ w: cw, h: ch, L, A });
  trimmed.photo = solid > 0 && mid / solid > 0.3;
  return trimmed;
}

// Crop away empty margins (transparent or white) so handles hug the artwork.
function trimSrc(src) {
  const { w, h, L, A } = src;
  let x0 = w, y0 = h, x1 = -1, y1 = -1;
  for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
    const i = y * w + x;
    if (A[i] > 20 && L[i] < 245) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
  }
  if (x1 < 0) return src;
  const m = Math.round(Math.max(w, h) * 0.01);
  x0 = Math.max(0, x0 - m); y0 = Math.max(0, y0 - m); x1 = Math.min(w - 1, x1 + m); y1 = Math.min(h - 1, y1 + m);
  const nw = x1 - x0 + 1, nh = y1 - y0 + 1;
  if (nw === w && nh === h) return src;
  const nL = new Uint8ClampedArray(nw * nh), nA = new Uint8ClampedArray(nw * nh);
  for (let y = 0; y < nh; y++) {
    nL.set(L.subarray((y + y0) * w + x0, (y + y0) * w + x0 + nw), y * nw);
    nA.set(A.subarray((y + y0) * w + x0, (y + y0) * w + x0 + nw), y * nw);
  }
  return { w: nw, h: nh, L: nL, A: nA };
}

function makeImageBitmap(e) {
  const { w, h, L, A } = e.src;
  const c = document.createElement('canvas'); c.width = w; c.height = h;
  const ctx = c.getContext('2d');
  const id = ctx.createImageData(w, h); const d = id.data;
  const thr = e.threshold;
  for (let i = 0, n = w * h; i < n; i++) {
    let l = L[i] / 255;
    if (e.invert) l = 1 - l;
    let b = e.style === 'line' ? Math.min(1, Math.max(0, (thr - l) / 0.08 + 0.5)) : 1 - l;
    d[i * 4 + 3] = b * A[i];
  }
  ctx.putImageData(id, 0, 0);
  return c;
}

async function makeTextBitmap(e, fs = 220) {
  const f = FONTS.find((x) => x.id === e.font) || FONTS[0];
  const font = `${f.weight} ${fs}px "${f.family}"`;
  try { await document.fonts.load(font, e.text || 'A'); } catch (_) {}
  const lines = (e.text || ' ').split('\n');
  const lh = fs * 1.2;
  const c = document.createElement('canvas');
  const ctx = c.getContext('2d', { willReadFrequently: true });
  ctx.font = font;
  const widths = lines.map((l) => ctx.measureText(l).width);
  const maxW = Math.max(fs * 0.5, ...widths);
  const padX = fs * 0.5, padY = fs * 0.45;
  c.width = Math.ceil(maxW + padX * 2); c.height = Math.ceil(lines.length * lh + padY * 2);
  ctx.font = font; ctx.textBaseline = 'middle'; ctx.fillStyle = '#000';
  lines.forEach((l, i) => {
    const x = e.align === 'left' ? padX : e.align === 'right' ? padX + maxW - widths[i] : padX + (maxW - widths[i]) / 2;
    ctx.fillText(l, x, padY + lh * (i + 0.5));
  });
  // trim to inked area
  const d = ctx.getImageData(0, 0, c.width, c.height).data;
  let x0 = c.width, y0 = c.height, x1 = -1, y1 = -1;
  for (let y = 0; y < c.height; y++) for (let x = 0; x < c.width; x++) {
    if (d[(y * c.width + x) * 4 + 3] > 10) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
  }
  if (x1 < 0) { const blank = document.createElement('canvas'); blank.width = fs; blank.height = fs * 0.6; return blank; }
  const m = Math.round(8 * fs / 220);
  x0 = Math.max(0, x0 - m); y0 = Math.max(0, y0 - m); x1 = Math.min(c.width - 1, x1 + m); y1 = Math.min(c.height - 1, y1 + m);
  const out = document.createElement('canvas'); out.width = x1 - x0 + 1; out.height = y1 - y0 + 1;
  out.getContext('2d').drawImage(c, -x0, -y0);
  return out;
}

function loadImage(url) {
  return new Promise((res, rej) => { const img = new Image(); img.onload = () => res(img); img.onerror = () => rej(new Error('image')); img.src = url; });
}

async function svgTextToImage(text) {
  const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
  const svg = doc.documentElement;
  if (!svg || svg.nodeName.toLowerCase() !== 'svg' || doc.querySelector('parsererror')) throw new Error('svg');
  let vb = (svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
  const num = (v) => (v && !/%/.test(v)) ? parseFloat(v) : NaN;
  let w = num(svg.getAttribute('width')), h = num(svg.getAttribute('height'));
  if (vb.length !== 4 || vb.some(isNaN)) {
    if (isNaN(w) || isNaN(h)) { w = 1000; h = 1000; }
    vb = [0, 0, w, h];
    svg.setAttribute('viewBox', vb.join(' '));
  }
  const k = MAX_SRC / Math.max(vb[2], vb[3]);
  const outW = Math.round(vb[2] * k), outH = Math.round(vb[3] * k);
  svg.setAttribute('width', outW); svg.setAttribute('height', outH);
  if (!svg.getAttribute('xmlns')) svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  const blob = new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' });
  const url = URL.createObjectURL(blob);
  try { const img = await loadImage(url); return { img, w: outW, h: outH }; }
  finally { URL.revokeObjectURL(url); }
}

function epsToSvg(buf) {
  const bytes = new Uint8Array(buf);
  let start = 0, len = bytes.length;
  if (bytes[0] === 0xC5 && bytes[1] === 0xD0 && bytes[2] === 0xD3 && bytes[3] === 0xC6) {
    const dv = new DataView(buf); start = dv.getUint32(4, true); len = dv.getUint32(8, true);
  }
  let text = '';
  const chunk = bytes.subarray(start, start + len);
  for (let i = 0; i < chunk.length; i += 65536) text += String.fromCharCode.apply(null, chunk.subarray(i, i + 65536));
  if (!/%!PS/.test(text.slice(0, 64))) throw new Error('eps');

  const bbm = text.match(/%%HiResBoundingBox:\s*([-\d.]+)\s+([-\d.]+)\s+([-\d.]+)\s+([-\d.]+)/) ||
              text.match(/%%BoundingBox:\s*([-\d.]+)\s+([-\d.]+)\s+([-\d.]+)\s+([-\d.]+)/);

  let body = text;
  let at = text.indexOf('%%EndSetup');
  if (at < 0) at = text.indexOf('%%EndProlog');
  if (at >= 0) body = text.slice(at);
  const stop = body.search(/%%Trailer|%%EOF|%AI9_PrivateDataBegin/);
  if (stop > 0) body = body.slice(0, stop);
  body = body
    .replace(/%%BeginData[\s\S]*?%%EndData/g, ' ')
    .replace(/%%BeginBinary[\s\S]*?%%EndBinary/g, ' ')
    .replace(/%AI5_BeginPalette[\s\S]*?%AI5_EndPalette/g, ' ')
    .replace(/%%BeginResource[\s\S]*?%%EndResource/g, ' ')
    .replace(/%%BeginDocument[\s\S]*?%%EndDocument/g, ' ');

  const toks = body.match(/%[^\r\n]*|\((?:\\.|[^\\)])*\)|<<|>>|<[0-9A-Fa-f\s]*>|[\[\]{}]|\/?[^\s()<>\[\]{}\/%]+/g) || [];
  const st = [];
  let ctm = [1, 0, 0, 1, 0, 0];
  let fillC = [0, 0, 0], strokeC = [0, 0, 0], lw = 1;
  const gstack = [];
  let path = '', cp = [0, 0], sp = [0, 0];
  let compound = null;
  const shapes = [];
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  const nums = (k) => {
    if (st.length < k) return null;
    const a = st.slice(-k);
    if (a.some((v) => typeof v !== 'number')) { st.length = Math.max(0, st.length - k); return null; }
    st.length -= k; return a;
  };
  const T = (x, y) => {
    const X = ctm[0] * x + ctm[2] * y + ctm[4], Y = ctm[1] * x + ctm[3] * y + ctm[5];
    if (X < minX) minX = X; if (X > maxX) maxX = X; if (Y < minY) minY = Y; if (Y > maxY) maxY = Y;
    return `${+X.toFixed(3)} ${+Y.toFixed(3)}`;
  };
  const mul = (m, n) => [m[0] * n[0] + m[1] * n[2], m[0] * n[1] + m[1] * n[3], m[2] * n[0] + m[3] * n[2], m[2] * n[1] + m[3] * n[3], m[4] * n[0] + m[5] * n[2] + n[4], m[4] * n[1] + m[5] * n[3] + n[5]];
  const concat = (m) => { ctm = mul(m, ctm); };
  const cmyk = (c, m, y, k) => [(1 - c) * (1 - k), (1 - m) * (1 - k), (1 - y) * (1 - k)];
  const rgb = (c) => `rgb(${c.map((v) => Math.round(Math.max(0, Math.min(1, v)) * 255)).join(',')})`;
  const scaleW = () => Math.sqrt(Math.abs(ctm[0] * ctm[3] - ctm[1] * ctm[2])) || 1;

  const moveTo = (x, y) => { path += 'M' + T(x, y); cp = [x, y]; sp = [x, y]; };
  const lineTo = (x, y) => { path += 'L' + T(x, y); cp = [x, y]; };
  const curveTo = (a, b, c, d, e, f) => { path += 'C' + T(a, b) + ' ' + T(c, d) + ' ' + T(e, f); cp = [e, f]; };
  const close = () => { if (path) path += 'Z'; cp = sp.slice(); };
  const paint = (doFill, doStroke, rule) => {
    if (path) {
      if (compound) { compound.d += path; compound.fill = compound.fill || (doFill ? rgb(fillC) : null); compound.stroke = compound.stroke || (doStroke ? { c: rgb(strokeC), w: lw * scaleW() } : null); }
      else shapes.push({ d: path, fill: doFill ? rgb(fillC) : null, stroke: doStroke ? { c: rgb(strokeC), w: lw * scaleW() } : null, rule });
    }
    path = '';
  };

  const ops = {
    m: () => { const a = nums(2); if (a) moveTo(...a); }, moveto: () => ops.m(),
    l: () => { const a = nums(2); if (a) lineTo(...a); }, L: () => ops.l(), lineto: () => ops.l(),
    c: () => { const a = nums(6); if (a) curveTo(...a); }, C: () => ops.c(), curveto: () => ops.c(),
    v: () => { const a = nums(4); if (a) curveTo(cp[0], cp[1], ...a); }, V: () => ops.v(),
    y: () => { const a = nums(4); if (a) curveTo(a[0], a[1], a[2], a[3], a[2], a[3]); }, Y: () => ops.y(),
    rmoveto: () => { const a = nums(2); if (a) moveTo(cp[0] + a[0], cp[1] + a[1]); },
    rlineto: () => { const a = nums(2); if (a) lineTo(cp[0] + a[0], cp[1] + a[1]); },
    rcurveto: () => { const a = nums(6); if (a) curveTo(cp[0] + a[0], cp[1] + a[1], cp[0] + a[2], cp[1] + a[3], cp[0] + a[4], cp[1] + a[5]); },
    h: close, H: close, closepath: close,
    re: () => { const a = nums(4); if (a) { const [x, y, w, h] = a; moveTo(x, y); lineTo(x + w, y); lineTo(x + w, y + h); lineTo(x, y + h); close(); } },
    rectfill: () => { ops.re(); paint(true, false, 'nonzero'); },
    n: () => { if (compound) compound.d += path; path = ''; }, N: () => { if (compound) { close(); compound.d += path; } path = ''; }, newpath: () => { path = ''; },
    f: () => paint(true, false, 'nonzero'), F: () => paint(true, false, 'nonzero'), fill: () => paint(true, false, 'nonzero'),
    'f*': () => paint(true, false, 'evenodd'), eofill: () => paint(true, false, 'evenodd'),
    S: () => paint(false, true, 'nonzero'), stroke: () => paint(false, true, 'nonzero'),
    s: () => { close(); paint(false, true, 'nonzero'); },
    B: () => paint(true, true, 'nonzero'), b: () => { close(); paint(true, true, 'nonzero'); },
    'B*': () => paint(true, true, 'evenodd'), 'b*': () => { close(); paint(true, true, 'evenodd'); },
    '*u': () => { compound = { d: '', fill: null, stroke: null }; },
    '*U': () => { if (compound && compound.d) shapes.push({ d: compound.d, fill: compound.fill, stroke: compound.stroke, rule: 'evenodd' }); compound = null; },
    q: () => gstack.push({ ctm: ctm.slice(), fillC: fillC.slice(), strokeC: strokeC.slice(), lw }),
    gsave: () => ops.q(),
    Q: () => { const g = gstack.pop(); if (g) ({ ctm, fillC, strokeC, lw } = g); }, grestore: () => ops.Q(),
    cm: () => { const a = nums(6); if (a) concat(a); },
    concat: () => { const a = st.pop(); if (Array.isArray(a) && a.length === 6) concat(a); },
    translate: () => { const a = nums(2); if (a) concat([1, 0, 0, 1, a[0], a[1]]); },
    scale: () => { const a = nums(2); if (a) concat([a[0], 0, 0, a[1], 0, 0]); },
    rotate: () => { const a = nums(1); if (a) { const r = a[0] * Math.PI / 180; concat([Math.cos(r), Math.sin(r), -Math.sin(r), Math.cos(r), 0, 0]); } },
    w: () => { const a = nums(1); if (a) lw = a[0]; }, setlinewidth: () => ops.w(),
    g: () => { const a = nums(1); if (a) fillC = [a[0], a[0], a[0]]; },
    G: () => { const a = nums(1); if (a) strokeC = [a[0], a[0], a[0]]; },
    setgray: () => { const a = nums(1); if (a) fillC = strokeC = [a[0], a[0], a[0]]; },
    rg: () => { const a = nums(3); if (a) fillC = a; }, RG: () => { const a = nums(3); if (a) strokeC = a; },
    Xa: () => ops.rg(), XA: () => ops.RG(),
    setrgbcolor: () => { const a = nums(3); if (a) fillC = strokeC = a; },
    k: () => { const a = nums(4); if (a) fillC = cmyk(...a); }, K: () => { const a = nums(4); if (a) strokeC = cmyk(...a); },
    setcmykcolor: () => { const a = nums(4); if (a) fillC = strokeC = cmyk(...a); },
    x: () => { st.pop(); st.pop(); const a = nums(4); if (a) fillC = cmyk(...a); },
    X: () => { st.pop(); st.pop(); const a = nums(4); if (a) strokeC = cmyk(...a); },
  };

  let depth = 0, mark = [];
  for (const t of toks) {
    if (t[0] === '%') continue;
    if (t === '{') { depth++; continue; }
    if (t === '}') { depth = Math.max(0, depth - 1); if (!depth) st.push('{proc}'); continue; }
    if (depth) continue;
    if (t === '[') { mark.push(st.length); continue; }
    if (t === ']') { const i = mark.pop() ?? st.length; st.push(st.splice(i).filter((v) => typeof v === 'number')); continue; }
    const n = Number(t);
    if (t !== '' && !isNaN(n) && /^[-+.\d]/.test(t)) { st.push(n); continue; }
    if (t[0] === '/' || t[0] === '(' || t[0] === '<') { st.push(t); continue; }
    const op = Object.prototype.hasOwnProperty.call(ops, t) ? ops[t] : null;
    if (op) op();
    else if (t === 'pop') st.pop();
    else if (t === 'def') { st.pop(); st.pop(); }
    if (st.length > 5000) st.splice(0, st.length - 1000);
  }
  if (!shapes.length) throw new Error('eps-empty');

  let x0, y0, x1, y1;
  if (bbm) [x0, y0, x1, y1] = bbm.slice(1).map(Number);
  if (!bbm || !(x1 > x0) || !(y1 > y0)) [x0, y0, x1, y1] = [minX, minY, maxX, maxY];
  const out = shapes.map((s) => `<path d="${s.d}" fill="${s.fill || 'none'}" fill-rule="${s.rule}"${s.stroke ? ` stroke="${s.stroke.c}" stroke-width="${+s.stroke.w.toFixed(3)}" stroke-linejoin="round" stroke-linecap="round"` : ''}/>`).join('');
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${x0} ${y0} ${x1 - x0} ${y1 - y0}"><g transform="matrix(1 0 0 -1 0 ${y0 + y1})">${out}</g></svg>`;
}

/* ---------------------------------------------------------------
   Border UI
---------------------------------------------------------------- */
function borderPreview(style) {
  const c = document.createElement('canvas');
  const showW = Math.min(DW, 3.4 * Math.max(1, DW / 15)), showH = showW * 2.2 / 3.4;
  const k = 68 / showW, dpr = 2;
  c.width = 68 * dpr; c.height = Math.round(showH * k) * dpr;
  c.style.width = '68px'; c.style.height = `${Math.round(showH * k)}px`;
  const ctx = c.getContext('2d');
  ctx.scale(dpr, dpr);
  const X = (x) => (x + DW / 2) * k + 3, Y = (y) => (y + DH / 2) * k + 3;
  const R = P.round ? P.cornerR : P.cornerR;
  ctx.fillStyle = wood.swatch;
  ctx.beginPath();
  if (P.round) { ctx.arc(X(0), Y(0), R * k, 0, Math.PI * 2); }
  else {
    ctx.moveTo(X(-DW / 2 + R), Y(-DH / 2)); ctx.lineTo(X(DW / 2), Y(-DH / 2)); ctx.lineTo(X(DW / 2), Y(DH / 2)); ctx.lineTo(X(-DW / 2), Y(DH / 2));
    ctx.lineTo(X(-DW / 2), Y(-DH / 2 + R)); if (R) ctx.arc(X(-DW / 2 + R), Y(-DH / 2 + R), R * k, Math.PI, Math.PI * 1.5);
  }
  ctx.fill();
  ctx.fillStyle = ctx.strokeStyle = 'rgba(40,20,8,0.9)';
  drawBorder(ctx, X, Y, k, { style, weight: Math.min(P.border.max, Math.max(P.border.weight, showW / 38)), corners: border.corners });
  return c;
}

function renderBorderUI() {
  const on = border.style !== 'none';
  $('borderSwitch').setAttribute('aria-checked', on);
  $('borderBody').hidden = !on;
  const grid = $('borders');
  grid.innerHTML = '';
  if (on) {
    for (const st of BORDER_STYLES.filter((s) => P.border.styles.includes(s.id))) {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-pressed', border.style === st.id);
      b.appendChild(borderPreview(st.id));
      const l = document.createElement('span'); l.textContent = st.label; b.appendChild(l);
      b.onclick = () => { border.style = lastBorderStyle = st.id; renderBorderUI(); renderMask(); updateLayers(); commit(); };
      grid.appendChild(b);
    }
  }
  const style = BORDER_STYLES.find((st) => st.id === border.style);
  $('bCornersField').hidden = P.round || P.cornerR === 0 || !style || !!style.squareOnly;
  const wr = $('bWeight');
  wr.min = 0.02; wr.max = P.border.max; wr.value = border.weight;
  $('bWeightOut').textContent = `${border.weight.toFixed(2)} in`;
  [...$('bCorners').children].forEach((c) => c.setAttribute('aria-pressed', c.dataset.v === border.corners));
  $('borderHint').textContent = `Borders start ${fracIn(P.border.inset)} inside the edge.`;
}
function fracIn(v) {
  const map = { 0.125: '1/8', 0.25: '1/4', 0.5: '1/2', 0.75: '3/4', 0.375: '3/8' };
  return `${map[v] || v} in`;
}

$('borderSwitch').onclick = () => {
  if (border.style === 'none') border.style = P.border.styles.includes(lastBorderStyle) ? lastBorderStyle : P.border.styles[0];
  else border.style = 'none';
  renderBorderUI(); renderMask(); updateLayers(); commit();
};
$('bWeight').addEventListener('input', (ev) => {
  border.weight = +ev.target.value;
  $('bWeightOut').textContent = `${border.weight.toFixed(2)} in`;
  renderMask(); updateNote();
});
$('bWeight').addEventListener('change', () => { updateLayers(); commit(); });
[...$('bCorners').children].forEach((c) => { c.onclick = () => { border.corners = c.dataset.v; renderBorderUI(); renderMask(); commit(); }; });

/* ---------------------------------------------------------------
   Adding / editing elements
---------------------------------------------------------------- */
function placeDefault(e, fitW = 0.5, fitH = 0.6) {
  e.ipp = Math.min((DW * fitW) / e.bmp.width, (DH * fitH) / e.bmp.height);
  const step = Math.min(DW, DH) * 0.04;
  e.x = (els.length % 4) * step; e.y = (els.length % 4) * step;
  if (P.family) {
    e.ipp = Math.min((DW * 0.5) / e.bmp.width, 0.55 / e.bmp.height);
    e.x = 0; e.y = 1.2;
  } else if (P.photo) {
    const rail = DH / 2 - P.keepOut.y1 - P.safeMargin * 2;
    e.ipp = Math.min((DW * 0.4) / e.bmp.width, rail / e.bmp.height);
    e.x = 0; e.y = (P.keepOut.y1 + DH / 2) / 2;
  }
}

/* ---------------------------------------------------------------
   Background removal: automatic (runs in the browser) or plain color
---------------------------------------------------------------- */
function toCanvas(img, max) {
  const w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
  if (!w || !h) return null;
  const k = Math.min(1, max / Math.max(w, h));
  const c = document.createElement('canvas');
  c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
  c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
  return c;
}
// Plain color: flood fill inward from the edges through pixels close to the edge color.
function removePlainBackground(orig, tol) {
  const w = orig.width, h = orig.height;
  const c = document.createElement('canvas'); c.width = w; c.height = h;
  const ctx = c.getContext('2d', { willReadFrequently: true });
  ctx.drawImage(orig, 0, 0);
  const id = ctx.getImageData(0, 0, w, h), d = id.data;
  const rs = [], gs = [], bs = [];
  const sample = (x, y) => { const p = (y * w + x) * 4; if (d[p + 3] > 20) { rs.push(d[p]); gs.push(d[p + 1]); bs.push(d[p + 2]); } };
  for (let x = 0; x < w; x++) { sample(x, 0); sample(x, h - 1); }
  for (let y = 0; y < h; y++) { sample(0, y); sample(w - 1, y); }
  if (!rs.length) return c;
  const med = (a) => { a.sort((p, q) => p - q); return a[a.length >> 1]; };
  const R = med(rs), G = med(gs), B = med(bs);
  const lim = 12 + tol * 140, lim2 = lim * lim;
  const bg = new Uint8Array(w * h), stack = new Int32Array(w * h);
  let sp = 0;
  const near = (i) => { const p = i * 4; if (d[p + 3] <= 20) return true; const dr = d[p] - R, dg = d[p + 1] - G, db = d[p + 2] - B; return dr * dr + dg * dg + db * db <= lim2; };
  const seed = (i) => { if (!bg[i] && near(i)) { bg[i] = 1; stack[sp++] = i; } };
  for (let x = 0; x < w; x++) { seed(x); seed((h - 1) * w + x); }
  for (let y = 0; y < h; y++) { seed(y * w); seed(y * w + w - 1); }
  while (sp) {
    const i = stack[--sp], x = i % w, y = (i - x) / w;
    if (x > 0) seed(i - 1); if (x < w - 1) seed(i + 1); if (y > 0) seed(i - w); if (y < h - 1) seed(i + w);
  }
  const keep = new Float32Array(w * h); for (let i = 0; i < w * h; i++) keep[i] = bg[i] ? 0 : 1;
  const soft = boxBlur(keep, w, h, 1);
  for (let i = 0; i < w * h; i++) {
    const a = bg[i] ? 0 : Math.min(1, soft[i] * 1.6);
    d[i * 4 + 3] = Math.round(d[i * 4 + 3] * a);
  }
  ctx.putImageData(id, 0, 0);
  return c;
}
// Automatic: a small portrait-matting model (MODNet, Apache-2.0) run in the browser with
// transformers.js. Loaded only the first time a customer asks for it.
const BG_LIB = 'https://cdn.jsdelivr.net/npm/@huggingface/transformers@3.8.1';
let bgModel = null;
function loadBgModel() {
  if (!bgModel) bgModel = (async () => {
    const T = await import(BG_LIB);
    T.env.allowLocalModels = false;
    const model = await T.AutoModel.from_pretrained('Xenova/modnet', { dtype: 'fp32' });
    const processor = await T.AutoProcessor.from_pretrained('Xenova/modnet');
    return { T, model, processor };
  })().catch((err) => { bgModel = null; throw err; });
  return bgModel;
}
// Fallback people detector: MediaPipe Selfie Segmentation (Apache-2.0), loaded from jsDelivr.
const MP_BASE = 'https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation@0.1.1675465747/';
let mpSeg = null;
function loadScriptOnce(src) {
  return new Promise((res, rej) => {
    if ([...document.scripts].some((s) => s.src === src)) { res(); return; }
    const s = document.createElement('script'); s.src = src; s.crossOrigin = 'anonymous';
    s.onload = () => res(); s.onerror = () => rej(new Error(`Couldn't load ${src}`));
    document.head.appendChild(s);
  });
}
async function removePeopleMediaPipe(orig) {
  if (!mpSeg) mpSeg = (async () => {
    await loadScriptOnce(`${MP_BASE}selfie_segmentation.js`);
    const ss = new window.SelfieSegmentation({ locateFile: (f) => MP_BASE + f });
    ss.setOptions({ modelSelection: 0 });
    await ss.initialize();
    return ss;
  })().catch((err) => { mpSeg = null; throw err; });
  const ss = await mpSeg;
  const mask = await new Promise((resolve, reject) => {
    ss.onResults((r) => resolve(r.segmentationMask));
    ss.send({ image: orig }).catch(reject);
  });
  const c = document.createElement('canvas'); c.width = orig.width; c.height = orig.height;
  const ctx = c.getContext('2d');
  ctx.filter = 'blur(1px)';
  ctx.drawImage(mask, 0, 0, c.width, c.height);
  ctx.filter = 'none';
  ctx.globalCompositeOperation = 'source-in';
  ctx.drawImage(orig, 0, 0);
  return c;
}
async function removeAutoBackground(orig) {
  try { return await removePeopleModnet(orig); }
  catch (err) {
    console.warn('Main people detector unavailable, trying MediaPipe', err);
    return await removePeopleMediaPipe(orig);
  }
}
async function removePeopleModnet(orig) {
  const { T, model, processor } = await loadBgModel();
  const image = T.RawImage.fromCanvas ? T.RawImage.fromCanvas(orig) : await T.RawImage.fromURL(orig.toDataURL('image/png'));
  const { pixel_values } = await processor(image);
  const { output } = await model({ input: pixel_values });
  const mask = await T.RawImage.fromTensor(output[0].mul(255).to('uint8')).resize(orig.width, orig.height);
  const c = document.createElement('canvas'); c.width = orig.width; c.height = orig.height;
  const ctx = c.getContext('2d', { willReadFrequently: true });
  ctx.drawImage(orig, 0, 0);
  const id = ctx.getImageData(0, 0, c.width, c.height), d = id.data, m = mask.data, ch = mask.channels || 1;
  for (let i = 0, n = c.width * c.height; i < n; i++) d[i * 4 + 3] = Math.round(d[i * 4 + 3] * m[i * ch] / 255);
  ctx.putImageData(id, 0, 0);
  return c;
}
// Re-make an image layer from its original upload with the chosen background setting.
async function applyBackground(e) {
  if (!e.orig) return;
  let out = e.orig;
  if (e.bg === 'auto') { if (!e.bgAuto) e.bgAuto = await removeAutoBackground(e.orig); out = e.bgAuto; }
  else if (e.bg === 'color') out = removePlainBackground(e.orig, e.bgTol ?? 0.35);
  if (e.type === 'cutout') {
    const cut = makeCutout(out);
    if (!cut) throw new Error('empty');
    e.ipp = e.ipp * cut.ipp0 / e.cut.ipp0;
    e.cut = cut; e.bmp = cut.etch; if (P) P.cutKey = null;
  } else {
    const photo = e.src.photo;
    e.src = imageToSrc(out, out.width, out.height);
    e.src.photo = photo;
    e.bmp = makeImageBitmap(e);
  }
  renderMask(); updateLayers(); syncReadouts();
}
function bgField(e) {
  const state = e.bg || 'keep';
  const f = el(`<div class="field"><span class="label">Background</span><div style="display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap"><span class="hint" style="margin:0"></span><button class="btn btn-small" type="button" style="white-space:nowrap;flex:none"></button></div></div>`);
  f.querySelector('.hint').textContent = { keep: 'Original background', auto: 'Background removed', color: 'Plain color removed' }[state];
  const b = f.querySelector('button');
  b.textContent = state === 'keep' ? 'Remove background…' : 'Edit background…';
  b.onclick = () => openBgDialog(e, state === 'keep' ? 'auto' : state);
  return f;
}
function hasAlpha(c) {
  const g = c.getContext('2d', { willReadFrequently: true });
  const d = g.getImageData(0, 0, c.width, c.height).data;
  for (let i = 3; i < d.length; i += 16) if (d[i] < 200) return true;
  return false;
}
// Pop-up with the original image beside the result. Nothing changes on the design until "Use this".
function openBgDialog(e, preset = 'auto') {
  if (!e.orig || $('bgdWrap')) return;
  const back = DOC.activeElement;
  const wrap = document.createElement('div');
  wrap.className = 'bgd-wrap'; wrap.id = 'bgdWrap';
  wrap.innerHTML = `<section class="bgd" role="dialog" aria-modal="true" aria-labelledby="bgdTitle">
    <header class="bgd-head"><h2 id="bgdTitle">Remove background</h2><button type="button" class="bgd-x" aria-label="Close">×</button></header>
    <div class="bgd-pics">
      <figure><figcaption>Original</figcaption><div class="bgd-box"><img class="bgd-orig" alt="Your original image"></div></figure>
      <figure><figcaption>Result</figcaption><div class="bgd-box bgd-checker"><img class="bgd-res" alt="Your image with the background setting applied"><div class="bgd-busy" hidden><span class="bgd-spin" aria-hidden="true"></span><span class="bgd-busy-t">Removing the background…</span></div></div></figure>
    </div>
    <div class="seg bgd-seg" role="group" aria-label="Background"></div>
    <p class="hint bgd-hint"></p>
    <div class="bgd-tol" hidden><div class="range-row"><label for="bgdTol">Strength</label><span></span></div><input id="bgdTol" type="range" min="0" max="1" step="0.01"></div>
    <footer class="bgd-foot"><button type="button" class="btn bgd-cancel">Cancel</button><button type="button" class="btn btn-primary bgd-use">Use this</button></footer>
  </section>`;
  $('designer').appendChild(wrap);
  const q = (s) => wrap.querySelector(s);
  const PREV = 900;
  const prevSrc = toCanvas(e.orig, PREV) || e.orig;
  q('.bgd-orig').src = prevSrc.toDataURL('image/png');
  let mode = preset, tolV = e.bgTol ?? 0.35, autoPrev = null, runId = 0;
  const hints = {
    keep: 'Use the whole picture, background included.',
    auto: 'Finds the people in your photo and removes everything around them. Best for portraits and family photos.',
    color: 'Removes a solid color around your picture, like a white or plain backdrop. Best for logos and objects.',
  };
  const seg = q('.bgd-seg'), tolBox = q('.bgd-tol'), tol = tolBox.querySelector('input'), tolOut = tolBox.querySelector('span');
  tol.value = tolV; tolOut.textContent = `${Math.round(tolV * 100)}%`;
  const busy = (on, msg) => { q('.bgd-busy').hidden = !on; if (msg) q('.bgd-busy-t').textContent = msg; q('.bgd-use').disabled = on; };
  async function preview() {
    const my = ++runId;
    [...seg.children].forEach((b) => b.setAttribute('aria-pressed', b.dataset.v === mode));
    q('.bgd-hint').textContent = hints[mode];
    tolBox.hidden = mode !== 'color';
    let out = prevSrc;
    try {
      if (mode === 'auto') {
        if (!autoPrev) {
          busy(true, e.bgAuto || bgModel ? 'Removing the background…' : 'Removing the background… The first time takes a few seconds while the tool loads.');
          if (!e.bgAuto) e.bgAuto = await removeAutoBackground(e.orig);
          autoPrev = toCanvas(e.bgAuto, PREV) || e.bgAuto;
        }
        out = autoPrev;
      } else if (mode === 'color') out = removePlainBackground(prevSrc, tolV);
      if (my !== runId) return;
      q('.bgd-res').src = out.toDataURL('image/png');
      busy(false);
    } catch (err) {
      console.warn('Background removal failed', err);
      if (my !== runId) return;
      busy(false);
      q('.bgd-use').disabled = true;
      q('.bgd-hint').textContent = window.ENGRAVE_SHOPIFY || MOUNT
        ? 'People detection couldn’t load. Check your connection and try again, or choose “Plain color” if your picture has a solid background.'
        : 'People detection needs to download a small model, and this preview page blocks downloads. It works on your store. Here, use “Plain color” for pictures with a solid background.';
    }
  }
  for (const [v, label] of [['keep', 'Keep'], ['auto', 'Detect people'], ['color', 'Plain color']]) {
    const b = document.createElement('button'); b.type = 'button'; b.textContent = label; b.dataset.v = v;
    b.onclick = () => { if (mode !== v) { mode = v; preview(); } };
    seg.appendChild(b);
  }
  let t;
  tol.addEventListener('input', () => { tolV = +tol.value; tolOut.textContent = `${Math.round(tolV * 100)}%`; clearTimeout(t); t = setTimeout(preview, 60); });
  const close = () => { runId++; wrap.remove(); if (back && back.focus) back.focus(); };
  q('.bgd-x').onclick = close; q('.bgd-cancel').onclick = close;
  wrap.addEventListener('click', (ev) => { if (ev.target === wrap) close(); });
  wrap.addEventListener('keydown', (ev) => { if (ev.key === 'Escape') { ev.stopPropagation(); close(); } });
  q('.bgd-use').onclick = async () => {
    busy(true, 'Applying…');
    const prev = { bg: e.bg, bgTol: e.bgTol };
    e.bg = mode; e.bgTol = tolV;
    try {
      await applyBackground(e);
      if (e.type === 'cutout') fitInside(e);
      renderMask(); updateLayers(); renderProps(); commit();
      close();
    } catch (err) {
      console.warn(err); Object.assign(e, prev); busy(false);
      q('.bgd-hint').textContent = 'That didn’t work on this picture. Try another option.';
    }
  };
  preview();
  setTimeout(() => (seg.querySelector('[aria-pressed="true"]') || q('.bgd-use')).focus(), 30);
}

async function addFile(file) {

  if (P.family) { await addCutoutFile(file); return; }
  const name = file.name.replace(/\.[^.]+$/, '') || 'Artwork';
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  let src, orig = null;
  try {
    if (ext === 'eps' || ext === 'ps' || file.type === 'application/postscript') {
      let svgText;
      try { svgText = epsToSvg(await file.arrayBuffer()); }
      catch (err) {
        toast(`We couldn't preview “${file.name}”. EPS files with photos inside or text that hasn't been outlined can't be shown here. Export the artwork as SVG or PNG and upload that instead.`);
        return;
      }
      const { img, w, h } = await svgTextToImage(svgText);
      src = imageToSrc(img, w, h); orig = toCanvas(img, MAX_SRC);
    } else if (ext === 'svg' || file.type === 'image/svg+xml') {
      const { img, w, h } = await svgTextToImage(await file.text());
      src = imageToSrc(img, w, h); orig = toCanvas(img, MAX_SRC);
    } else if (['jpg', 'jpeg', 'png'].includes(ext) || /image\/(jpeg|png)/.test(file.type)) {
      const url = URL.createObjectURL(file);
      try { const img = await loadImage(url); src = imageToSrc(img, img.naturalWidth, img.naturalHeight); orig = toCanvas(img, MAX_SRC); }
      finally { URL.revokeObjectURL(url); }
    } else {
      toast(`“${file.name}” isn't a supported file. Upload a JPG, PNG, SVG or EPS.`);
      return;
    }
  } catch (err) {
    toast(`“${file.name}” couldn't be opened. Check that the file isn't damaged, then try again.`);
    return;
  }
  const e = {
    id: nextId++, type: 'image', name, file: file.name,
    x: 0, y: 0, rot: 0, ipp: 0.01, flip: false, darkness: 0.9,
    src, style: src.photo ? 'photo' : 'line', threshold: 0.55, invert: false,
    orig, bg: 'keep', bgTol: 0.35, mask: true,
  };
  e.bmp = makeImageBitmap(e);
  placeDefault(e);
  els.push(e);
  selId = e.id;
  renderMask(); updateLayers(); renderProps(); commit();
}

async function newTextElement(value = P.text.value) {
  const e = {
    id: nextId++, type: 'text', name: 'Text',
    x: 0, y: P.text.y, rot: 0, ipp: 0.01, flip: false, darkness: 0.95,
    text: value, font: P.text.font, align: 'center',
  };
  e.bmp = await makeTextBitmap(e);
  e.ipp = P.text.lineH / (220 * 1.2);
  if (P.photo && P.keepOut) e.y = (P.keepOut.y1 + safeShape().hh) / 2;   // middle of the bottom rail
  return e;
}
async function addText() {
  const e = await newTextElement();
  if (els.length && !P.family) { const step = Math.min(DW, DH) * 0.05; e.x += step; e.y += step; }
  els.push(e);
  fitInside(e);
  selId = e.id;
  renderMask(); updateLayers(); renderProps(); commit();
  const ta = DOC.querySelector('#props textarea');
  if (ta && matchMedia('(pointer: fine)').matches) { ta.focus(); ta.select(); }
}

function select(id) {
  if (selId === id) return;
  selId = id;
  updateLayers(); renderProps(); requestRender();
}
function remove(e) {
  els = els.filter((x) => x !== e);
  if (selId === e.id) selId = null;
  renderMask(); updateLayers(); renderProps(); commit();
}
function duplicate(e) {
  if (e.type === 'cutout') return;
  const step = Math.min(DW, DH) * 0.05;
  const c = { ...e, id: nextId++, x: e.x + step, y: e.y + step };
  els.push(c); selId = c.id;
  renderMask(); updateLayers(); renderProps(); commit();
}
async function rebuild(e) {
  if (e.type === 'text' && e.path) {
    const f = FONTS.find((x) => x.id === e.font) || FONTS[0];
    try { await document.fonts.load(`${f.weight} 40px "${f.family}"`, e.text || 'A'); } catch (_) {}
    buildPathText(e);
  } else e.bmp = e.type === 'text' ? await makeTextBitmap(e) : makeImageBitmap(e);
  renderMask(); updateLayers(); syncReadouts();
}

/* ---------------------------------------------------------------
   Panel
---------------------------------------------------------------- */
const money = (n) => `$${n % 1 ? n.toFixed(2) : n}`;
function productWoods(p = P) { return WOODS.filter((w) => p && p.price && p.price[w.id] != null); }
function priceNow() { return P && P.price ? P.price[wood.id] : 0; }
function setWood(w) {
  wood = w;
  WOOD_U.uBurn.value.set(...w.burn); WOOD_U.uTint.value.set(...w.tint); WOOD_U.uSat.value = w.sat;
}
function buildWoods() {
  const box = $('woods');
  box.innerHTML = '';
  if (!P) return;
  const list = productWoods();
  if (!list.includes(wood)) setWood(list.find((w) => w.id === 'cherry') || list[0]);
  const base = Math.min(...list.map((w) => P.price[w.id]));
  for (const w of list) {
    const b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-pressed', w === wood);
    const delta = P.price[w.id] - base;
    b.innerHTML = `<span class="wood-name"><span class="swatch" style="background:${w.swatch}"></span>${w.label}</span><span class="wood-delta">${delta ? `+${money(delta)}` : 'Base price'}</span>`;
    b.setAttribute('aria-label', `${w.label}, ${money(P.price[w.id])}`);
    b.onclick = () => {
      setWood(w);
      [...box.children].forEach((c) => c.setAttribute('aria-pressed', c === b));
      renderBorderUI(); updateLayers(); updatePrice(); renderSizeUI();
      requestRender();
    };
    box.appendChild(b);
  }
  updatePrice();
}
function renderSizeUI() {
  const blk = $('sizeBlock');
  blk.hidden = !P || !P.sizes;
  if (blk.hidden) return;
  const grid = $('sizes');
  grid.innerHTML = '';
  let matched = false;
  for (const [w, h] of (P.presets || SIGN_PRICING.presets)) {
    const b = document.createElement('button'); b.type = 'button';
    const on = w === P.sizeW && h === P.sizeH; matched = matched || on;
    b.setAttribute('aria-pressed', on);
    b.innerHTML = `<span>${w} × ${h} in</span><span class="wood-delta">${money(signPrices(w, h, P.layered)[wood.id])}</span>`;
    b.onclick = () => { if (!on) resizeProduct(w, h); };
    grid.appendChild(b);
  }
  const allowCustom = typeof SHOPIFY === 'undefined' || !SHOPIFY;   // the store sells listed sizes only
  if (allowCustom) {
    const cb = document.createElement('button'); cb.type = 'button';
    cb.setAttribute('aria-pressed', !matched);
    cb.innerHTML = `<span>Custom</span><span class="wood-delta">Any size</span>`;
    cb.onclick = () => { $('customSize').hidden = false; $('cW').focus(); };
    grid.appendChild(cb);
  }
  $('customSize').hidden = matched || !allowCustom;
  $('cW').value = P.sizeW; $('cH').value = P.sizeH;
  const [mw, mh] = SIGN_PRICING.min, [xw, xh] = SIGN_PRICING.max;
  $('cW').min = mw; $('cW').max = xw; $('cH').min = mh; $('cH').max = xh;
  $('sizeHint').textContent = allowCustom ? `Widths ${mw}–${xw} in, heights ${mh}–${xh} in. Priced by size.` : 'Priced by size. Contact us for other sizes.';
}
function applyCustomSize() {
  const [mw, mh] = SIGN_PRICING.min, [xw, xh] = SIGN_PRICING.max;
  const w = Math.round(THREE.MathUtils.clamp(parseFloat($('cW').value) || P.sizeW, mw, xw) * 4) / 4;
  const h = Math.round(THREE.MathUtils.clamp(parseFloat($('cH').value) || P.sizeH, mh, xh) * 4) / 4;
  if (w !== P.sizeW || h !== P.sizeH) resizeProduct(w, h); else renderSizeUI();
}
$('cW').addEventListener('change', applyCustomSize);
$('cH').addEventListener('change', applyCustomSize);

function updatePrice() {
  if (!P) return;
  $('priceNow').textContent = money(priceNow());
  $('priceWood').textContent = `${P.name}, ${wood.label}`;
}

function thumbFor(e) {
  const c = document.createElement('canvas');
  const k = 34 / Math.max(e.bmp.width, e.bmp.height);
  c.width = Math.max(1, Math.round(e.bmp.width * k)); c.height = Math.max(1, Math.round(e.bmp.height * k));
  const ctx = c.getContext('2d');
  ctx.globalAlpha = 0.85;
  ctx.drawImage(e.bmp, 0, 0, c.width, c.height);
  return c;
}

function updateLayers() {
  const ul = $('layers');
  $('layersBlock').hidden = els.length === 0;
  ul.innerHTML = '';
  for (const e of [...els].reverse()) {
    const li = document.createElement('li');
    const b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-current', e.id === selId);
    const th = document.createElement('span'); th.className = 'thumb'; th.style.background = wood.swatch;
    th.appendChild(thumbFor(e));
    const nm = document.createElement('span'); nm.className = 'layer-name';
    nm.textContent = e.type === 'text' ? (e.text.split('\n')[0] || 'Text') : e.name;
    const { w, h } = dims(e);
    const sz = document.createElement('span'); sz.className = 'layer-size'; sz.textContent = `${fmt(w)} × ${fmt(h)} in`;
    b.append(th, nm);
    if (problem(e)) { const dot = document.createElement('span'); dot.className = 'warn-dot'; dot.title = 'Needs adjusting'; b.append(dot); }
    b.append(sz);
    b.onclick = () => select(e.id);
    li.appendChild(b); ul.appendChild(li);
  }
  updateNote();
  updateHistoryButtons();
}

function updateNote() {
  const note = $('note');
  const probs = els.map(problem).filter(Boolean);
  if (!els.length) {
    note.hidden = false; note.className = 'stage-note';
    note.textContent = 'Upload artwork or add text to see it engraved';
  } else if (probs.length) {
    note.hidden = false; note.className = 'stage-note warn';
    note.textContent = probs.includes('under') ? 'Part of your text is hidden under the raised image. Move it into the open area of the plate.'
      : probs.includes('photo') ? 'Part of your design covers the photo opening. Move it onto the frame.'
      : (probs.length === 1 ? 'Part of your design runs past the engraving area. Move it inside the dashed line.' : `${probs.length} items run past the engraving area. Move them inside the dashed line.`);
  } else note.hidden = true;
}

function el(html) { const t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }

function renderProps() {
  const box = $('props');
  const e = getSel();
  if (!e) { box.hidden = true; box.innerHTML = ''; return; }
  box.hidden = false;
  box.innerHTML = '';
  const head = el(`<div class="props-head"><h2></h2><button class="btn btn-small" type="button">Done</button></div>`);
  head.querySelector('h2').textContent = e.type === 'text' ? 'Text' : e.type === 'cutout' ? 'Image' : e.name;
  head.querySelector('button').onclick = () => select(null);
  box.appendChild(head);

  if (e.type === 'cutout') {
    const f = el(`<div class="field"><button class="btn" type="button">Replace image</button><p class="hint">Raised layer, cut around your picture and etched on top.</p></div>`);
    f.querySelector('button').onclick = () => $('imgInput').click();
    box.appendChild(f);
  } else if (e.type === 'text') {
    const f = el(`<div class="field"><label for="txt">Your text</label><textarea id="txt" rows="3" spellcheck="true"></textarea>${e.path ? '' : '<p class="hint">Tip: double-click your text on the preview to edit it there.</p>'}</div>`);
    const ta = f.querySelector('textarea');
    ta.value = e.text;
    let t;
    ta.addEventListener('input', () => { e.text = ta.value; clearTimeout(t); t = setTimeout(() => rebuild(e), 120); });
    ta.addEventListener('change', () => commit());
    box.appendChild(f);

    const shapeF = el(`<div class="field"><span class="label" id="tsLbl">Text shape</span><div class="seg" role="group" aria-labelledby="tsLbl"></div><p class="hint"></p></div>`);
    const tseg = shapeF.querySelector('.seg');
    shapeF.querySelector('.hint').textContent = e.path ? (P.round ? 'Drag the text to slide it around the circle. Line breaks become spaces.' : 'Drag the text to slide it along the border. Line breaks become spaces.') : '';
    shapeF.querySelector('.hint').hidden = !e.path;
    for (const [id, label] of [[false, 'Straight'], [true, P.round ? 'Around the circle' : 'Follow border']]) {
      const b = document.createElement('button'); b.type = 'button'; b.textContent = label;
      b.setAttribute('aria-pressed', !!e.path === id);
      b.onclick = async () => {
        if (!!e.path === id) return;
        if (id) { e.straight = { x: e.x, y: e.y, rot: e.rot, ipp: e.ipp, flip: e.flip }; e.path = true; pathDefaults(e); }
        else { e.path = false; Object.assign(e, e.straight || { x: 0, y: P.text.y, rot: 0, flip: false }); }
        const keepIpp = e.straight && !id ? e.straight.ipp : null;
        await rebuild(e);
        if (keepIpp) e.ipp = keepIpp;
        renderMask(); renderProps(); updateLayers(); commit();
      };
      tseg.appendChild(b);
    }
    box.appendChild(shapeF);

    if (e.path) {
      const pos = el(`<div class="field"><span class="label" id="posLbl">Position</span><div class="seg" role="group" aria-labelledby="posLbl"></div></div>`);
      const pseg = pos.querySelector('.seg');
      for (const [label, k] of [['Top', 0], ['Bottom', 0.5]]) {
        const b = document.createElement('button'); b.type = 'button'; b.textContent = label;
        b.onclick = () => { e.pathS = (pathTopS(e) + k) % 1; buildPathText(e); renderMask(); updateLayers(); commit(); };
        pseg.appendChild(b);
      }
      box.appendChild(pos);
      const maxSize = +(Math.min(DW, DH) * 0.16).toFixed(2);
      const sz = el(`<div class="field"><div class="range-row"><label for="psz">Text size</label><span></span></div><input id="psz" type="range" min="0.12" step="0.01"></div>`);
      const si = sz.querySelector('input'), so = sz.querySelector('span');
      si.max = Math.max(0.2, maxSize); si.value = e.pathSize; so.textContent = `${e.pathSize.toFixed(2)} in`;
      si.addEventListener('input', () => { e.pathSize = +si.value; so.textContent = `${e.pathSize.toFixed(2)} in`; buildPathText(e); renderMask(); });
      si.addEventListener('change', () => { updateLayers(); commit(); });
      box.appendChild(sz);
      const tk = el(`<div class="field"><div class="range-row"><label for="ptk">Letter spacing</label><span></span></div><input id="ptk" type="range" min="0" max="0.6" step="0.01"></div>`);
      const ti = tk.querySelector('input'), to = tk.querySelector('span');
      ti.value = e.track; to.textContent = `${Math.round(e.track * 100)}%`;
      ti.addEventListener('input', () => { e.track = +ti.value; to.textContent = `${Math.round(e.track * 100)}%`; buildPathText(e); renderMask(); });
      ti.addEventListener('change', () => { updateLayers(); commit(); });
      box.appendChild(tk);
    }

    const ff = el(`<div class="field"><span class="label" id="fontLbl">Font</span><div class="fonts" role="group" aria-labelledby="fontLbl"></div></div>`);
    const grid = ff.querySelector('.fonts');
    for (const font of FONTS) {
      const b = document.createElement('button');
      b.type = 'button'; b.textContent = font.label;
      b.style.fontFamily = `"${font.family}", serif`; b.style.fontWeight = font.weight;
      b.setAttribute('aria-pressed', e.font === font.id);
      b.onclick = async () => { e.font = font.id; [...grid.children].forEach((c) => c.setAttribute('aria-pressed', c === b)); await rebuild(e); commit(); };
      grid.appendChild(b);
    }
    box.appendChild(ff);

    const al = el(`<div class="field"><span class="label" id="alLbl">Line alignment</span><div class="seg" role="group" aria-labelledby="alLbl"></div></div>`);
    const seg = al.querySelector('.seg');
    for (const [id, label] of [['left', 'Left'], ['center', 'Center'], ['right', 'Right']]) {
      const b = document.createElement('button'); b.type = 'button'; b.textContent = label;
      b.setAttribute('aria-pressed', e.align === id);
      b.onclick = async () => { e.align = id; [...seg.children].forEach((c) => c.setAttribute('aria-pressed', c === b)); await rebuild(e); commit(); };
      seg.appendChild(b);
    }
    if (!e.path) box.appendChild(al);
  } else {
    const st = el(`<div class="field"><span class="label" id="stLbl">Engrave as</span><div class="seg" role="group" aria-labelledby="stLbl"></div><p class="hint"></p></div>`);
    const seg = st.querySelector('.seg'), hint = st.querySelector('.hint');
    const setHint = () => { hint.textContent = e.style === 'photo' ? 'Shades of gray become lighter and darker burns. Best for photos.' : 'Everything is burned at one depth. Best for logos, line art and text.'; };
    setHint();
    const thrField = el(`<div class="field"><div class="range-row"><label for="thr">Detail</label><span></span></div><input id="thr" type="range" min="0.15" max="0.95" step="0.01"></div>`);
    for (const [id, label] of [['line', 'Line art'], ['photo', 'Photo']]) {
      const b = document.createElement('button'); b.type = 'button'; b.textContent = label;
      b.setAttribute('aria-pressed', e.style === id);
      b.onclick = () => { e.style = id; [...seg.children].forEach((c) => c.setAttribute('aria-pressed', c === b)); setHint(); thrField.hidden = id !== 'line'; rebuild(e); commit(); };
      seg.appendChild(b);
    }
    box.appendChild(st);
    const thr = thrField.querySelector('input'), thrOut = thrField.querySelector('span');
    thr.value = e.threshold; thrOut.textContent = `${Math.round(e.threshold * 100)}%`;
    thrField.hidden = e.style !== 'line';
    thr.addEventListener('input', () => { e.threshold = +thr.value; thrOut.textContent = `${Math.round(e.threshold * 100)}%`; rebuild(e); });
    thr.addEventListener('change', commit);
    box.appendChild(thrField);
    const inv = el(`<div class="field"><label class="check"><input type="checkbox"> Swap light and dark</label></div>`);
    const cb = inv.querySelector('input'); cb.checked = e.invert;
    cb.onchange = () => { e.invert = cb.checked; rebuild(e); commit(); };
    box.appendChild(inv);
  }

  if ((e.type === 'image' || e.type === 'text') && !e.path) {
    const mf = el(`<div class="field"><label class="check"><input type="checkbox"> Crop at the edge</label><p class="hint">Lets it run past the edge of the engraving area. Anything outside is trimmed off.</p></div>`);
    const mcb = mf.querySelector('input'); mcb.checked = isMasked(e);
    mcb.onchange = () => { e.mask = mcb.checked; renderMask(); updateLayers(); updateNote(); commit(); };
    box.appendChild(mf);
  }

  const dk = el(`<div class="field"><div class="range-row"><label for="dk">Burn darkness</label><span></span></div><input id="dk" type="range" min="0.3" max="1" step="0.01"></div>`);
  const dki = dk.querySelector('input'), dko = dk.querySelector('span');
  dki.value = e.darkness; dko.textContent = `${Math.round(e.darkness * 100)}%`;
  dki.addEventListener('input', () => { e.darkness = +dki.value; dko.textContent = `${Math.round(e.darkness * 100)}%`; renderMask(); });
  dki.addEventListener('change', commit);
  box.appendChild(dk);

  const sz = el(`<div class="field"><span class="label">Size and angle</span><div class="dims">
    <div><label for="wIn">Width (in)</label><input id="wIn" type="number" step="0.1" min="0.1" inputmode="decimal"></div>
    <div><label for="hIn">Height (in)</label><input id="hIn" type="number" step="0.1" min="0.1" inputmode="decimal"></div>
    <div><label for="rDeg">Angle (°)</label><input id="rDeg" type="number" step="1" inputmode="numeric"></div></div></div>`);
  if (!e.path) box.appendChild(sz);
  const wIn = sz.querySelector('#wIn'), hIn = sz.querySelector('#hIn'), rDeg = sz.querySelector('#rDeg');
  wIn.onchange = () => { const v = parseFloat(wIn.value); if (v > 0.05) { e.ipp = v / e.bmp.width; renderMask(); syncReadouts(); updateLayers(); commit(); } };
  hIn.onchange = () => { const v = parseFloat(hIn.value); if (v > 0.05) { e.ipp = v / e.bmp.height; renderMask(); syncReadouts(); updateLayers(); commit(); } };
  rDeg.onchange = () => { const v = parseFloat(rDeg.value); if (!isNaN(v)) { e.rot = ((v % 360) + 540) % 360 - 180; renderMask(); syncReadouts(); commit(); } };

  const acts = el(`<div class="actions"></div>`);
  const mk = (label, fn, cls = '') => { const b = document.createElement('button'); b.type = 'button'; b.className = `btn btn-small ${cls}`; b.textContent = label; b.onclick = fn; acts.appendChild(b); };
  if (!e.path) mk('Center', () => { e.x = 0; if (e.type === 'cutout') e.y = P.fam.box.cy; else if (!P.keepOut) e.y = 0; renderMask(); updateLayers(); commit(); });
  if (!e.path) {
    mk('Straighten', () => { e.rot = 0; renderMask(); syncReadouts(); commit(); });
    mk('Mirror', () => { e.flip = !e.flip; renderMask(); commit(); });
  }
  if (e.type !== 'cutout') mk('Duplicate', () => duplicate(e));
  mk('Remove', () => remove(e), 'btn-danger');
  box.appendChild(acts);
  syncReadouts();
}

function syncReadouts() {
  const e = getSel();
  if (!e) return;
  const { w, h } = dims(e);
  const set = (id, v) => { const i = $(id); if (i && DOC.activeElement !== i) i.value = v; };
  set('wIn', fmt(w)); set('hIn', fmt(h)); set('rDeg', Math.round(e.rot));
  updateNote();
}

/* ---------------------------------------------------------------
   Photo in the frame
---------------------------------------------------------------- */
const photoCache = {};
async function setFramePhoto(src) {
  const img = await loadImage(src);
  const k = P.keepOut, aspect = (k.x1 - k.x0) / (k.y1 - k.y0);
  const c = document.createElement('canvas');
  c.height = 1200; c.width = Math.round(1200 * aspect);
  const s = Math.max(c.width / img.naturalWidth, c.height / img.naturalHeight);
  c.getContext('2d').drawImage(img, (c.width - img.naturalWidth * s) / 2, (c.height - img.naturalHeight * s) / 2, img.naturalWidth * s, img.naturalHeight * s);
  const t = new THREE.CanvasTexture(c);
  t.encoding = THREE.sRGBEncoding; t.anisotropy = ANISO;
  if (P.photoMat.map) P.photoMat.map.dispose();
  P.photoMat.map = t; P.photoMat.needsUpdate = true;
  requestRender();
}
$('photoBtn').onclick = () => $('photoInput').click();
$('photoInput').onchange = async (ev) => {
  const f = ev.target.files[0];
  ev.target.value = '';
  if (!f) return;
  const url = URL.createObjectURL(f);
  try { await setFramePhoto(url); photoCache[P.id] = true; }
  catch (_) { toast('That photo couldn’t be opened. Try a JPG or PNG.'); }
  finally { URL.revokeObjectURL(url); }
};

// Shrink a new item until it sits inside the engraving area.
function fitInside(e) {
  for (let i = 0; i < 25 && problem(e) === 'edge'; i++) e.ipp *= 0.94;
  return e;
}

/* ---------------------------------------------------------------
   Image layer (two-layer ornament): JPG or PNG, background removed in the browser
---------------------------------------------------------------- */
async function addCutoutFile(file) {
  const okType = /\.(png|jpe?g)$/i.test(file.name) || /image\/(png|jpeg)/.test(file.type);
  if (!okType) { toast(`“${file.name}” isn't a supported photo. Upload a JPG or PNG.`); return; }
  const url = URL.createObjectURL(file);
  let img;
  try { img = await loadImage(url); }
  catch (_) { toast(`“${file.name}” couldn't be opened. Check that the file isn't damaged, then try again.`); return; }
  finally { URL.revokeObjectURL(url); }
  const old = els.find((x) => x.type === 'cutout');
  const e = newCutoutElement(img, file.name.replace(/\.[^.]+$/, '') || 'Image', file.name);
  if (!e) { toast('That image looks empty. Choose a PNG with a visible picture.'); return; }
  e.orig = toCanvas(img, 1600); e.bg = 'keep'; e.bgTol = 0.35;
  if (old) { e.x = old.x; e.y = old.y; e.rot = old.rot; els = els.filter((x) => x !== old); }
  els.push(e);
  fitInside(e);
  selId = e.id;
  renderMask(); updateLayers(); renderProps(); commit();
}
$('imgBtn').onclick = () => $('imgInput').click();
(() => {
  const inp = $('imgInput'); if (inp) inp.accept = '.png,.jpg,.jpeg,image/png,image/jpeg';
  const btn = $('imgBtn'); if (!btn) return;
  const tn = [...btn.childNodes].reverse().find((n) => n.nodeType === 3 && n.textContent.trim());
  if (tn) tn.textContent = ' Upload a photo ';
  const hint = btn.nextElementSibling;
  if (hint && hint.classList.contains('hint')) hint.textContent = 'JPG or PNG. For a cut that follows your family, use a PNG with the background already removed (transparent).';
})();
$('imgInput').onchange = async (ev) => {
  const f = ev.target.files[0];
  ev.target.value = '';
  if (f) await addCutoutFile(f);
};
$('textBtn2').onclick = () => addText();

/* ---------------------------------------------------------------
   Files: picker and drag-and-drop
---------------------------------------------------------------- */
$('uploadBtn').onclick = () => $('fileInput').click();
$('fileInput').onchange = async (ev) => {
  for (const f of ev.target.files) await addFile(f);
  ev.target.value = '';
};
$('textBtn').onclick = addText;

let dragDepth = 0;
const canDrop = () => P && !$('designer').hidden;
window.addEventListener('dragenter', (ev) => { if (canDrop() && [...(ev.dataTransfer?.types || [])].includes('Files')) { dragDepth++; $('drop').hidden = false; ev.preventDefault(); } });
window.addEventListener('dragleave', () => { dragDepth = Math.max(0, dragDepth - 1); if (!dragDepth) $('drop').hidden = true; });
window.addEventListener('dragover', (ev) => ev.preventDefault());
window.addEventListener('drop', async (ev) => {
  ev.preventDefault(); dragDepth = 0; $('drop').hidden = true;
  if (!canDrop()) return;
  for (const f of ev.dataTransfer?.files || []) await addFile(f);
});

let toastTimer;
function toast(msg) {
  const t = $('toast');
  t.textContent = msg; t.hidden = false;
  clearTimeout(toastTimer); toastTimer = setTimeout(() => { t.hidden = true; }, 7000);
}

$('viewFlat').onclick = () => setView('flat');
$('view3d').onclick = () => setView('3d');
$('fitBtn').onclick = () => setView(view);

/* ---------------------------------------------------------------
   Products: building, switching, catalog
---------------------------------------------------------------- */
const BUILT = {};
function ensureBuilt(p) {
  if (!BUILT[p.id]) BUILT[p.id] = Object.assign({}, p, p.build());
  return BUILT[p.id];
}
function syncDims() {
  DW = P.surf.hw * 2; DH = P.surf.hh * 2;
  MW = P.mask.canvas.width; MH = P.mask.canvas.height; PPI = MW / DW;
  if (P.sizes) {
    P.price = signPrices(P.sizeW, P.sizeH, P.layered);
    P.size = signSizeText(P);
    P.text = { ...P.text, lineH: +(DH * P.text.lineFrac).toFixed(2), y: +(DH * P.text.yFrac).toFixed(2) };
  }
  placeLights();
}
// Rebuild a sized product at a new size, keeping the design.
function resizeProduct(w, h) {
  const base = PRODUCTS.find((x) => x.id === P.id);
  scene.remove(P.group);
  if (P.cutMesh) P.cutMesh = null;
  Object.assign(P, base.build(w, h), { sizeW: w, sizeH: h, cutMesh: null, cutKey: null });
  scene.add(P.group);
  syncDims();
  $('boardSize').textContent = P.size;
  resize(); setView(view, false);
  renderBorderUI(); renderMask(); updateLayers(); renderSizeUI(); updatePrice();
}

function activate(p) {
  if (P) STORE[P.id] = { els, selId, border, hist, lastBorderStyle };
  if (P) scene.remove(P.group);
  P = ensureBuilt(p);
  scene.add(P.group);
  syncDims();
  const s = STORE[P.id];
  if (s) ({ els, selId, border, hist, lastBorderStyle } = s);
  else {
    els = []; selId = null; border = { style: 'none', weight: P.border.weight, corners: 'match' }; hist = { stack: [], i: -1 }; lastBorderStyle = P.border.styles[0];
    if (P.family) { els.push(newCutoutElement(placeholderFamily(), 'Sample family')); P.needsSeed = true; }
  }
}

// Layered products start with an example: names on top, the family below, a double border.
async function seedExample() {
  P.needsSeed = false;
  if (P.seedBorder) border.style = lastBorderStyle = P.seedBorder;
  const t = await newTextElement();
  els.push(t);
}
async function openProduct(p) {
  activate(p);
  if (P.needsSeed) await seedExample();
  $('catalog').hidden = true;
  $('designer').hidden = false;
  if (!MOUNT) document.title = `${P.name} | Engraving Designer`;
  $('pTitle').textContent = `Personalize your ${P.name.toLowerCase()}`;
  $('boardSize').textContent = P.size;
  $('pNote').textContent = P.note || '';
  $('pNote').hidden = !P.note;
  buildWoods();
  renderSizeUI();
  $('photoBlock').hidden = !P.photo;
  $('plateHead').hidden = $('plateText').hidden = $('imgBlock').hidden = !P.family;
  $('addBlock').hidden = !!P.family;
  if ($('addTextBlock')) $('addTextBlock').hidden = !!P.family;
  $('borderTitle').textContent = P.family ? 'Plate border' : 'Border';
  if (P.photo && !photoCache[P.id] && !P.photoMat.map) setFramePhoto(ASSETS.frame.dog);
  resize();
  setView('flat', false);
  renderBorderUI();
  renderMask(); updateLayers(); renderProps();
  if (!hist.stack.length) commit(); else updateHistoryButtons();
  if (!MOUNT) window.scrollTo(0, 0);
}

function showCatalog() {
  if (P) select(null);
  $('designer').hidden = true;
  $('catalog').hidden = false;
  if (!MOUNT) document.title = 'Engraving Designer';
}

function route() {
  if (MOUNT) {
    const p = PRODUCTS.find((x) => x.id === (window.ENGRAVE_SHOPIFY || {}).product);
    if (p && READY) openProduct(p);
    return;
  }
  const m = location.hash.match(/^#\/([\w-]+)/);
  const p = m && PRODUCTS.find((x) => x.id === m[1]);
  if (p && READY) openProduct(p); else showCatalog();
}
if (!MOUNT) window.addEventListener('hashchange', route);
$('backBtn').onclick = () => { location.hash = ''; };

function buildCatalog() {
  const wrap = $('products');
  wrap.innerHTML = '';
  const cats = [...new Set(PRODUCTS.map((p) => p.cat))];
  for (const cat of cats) {
    const sec = el(`<section class="cat-sec"><h2></h2><div class="products"></div></section>`);
    sec.querySelector('h2').textContent = cat;
    const grid = sec.querySelector('.products');
    for (const p of PRODUCTS.filter((x) => x.cat === cat)) {
      const a = el(`<a class="card" href="#/${p.id}"><span class="card-img"><span class="card-wait">Preparing preview…</span></span><span class="card-body"><span class="card-name"></span><span class="card-size"></span><span class="card-blurb"></span><span class="card-price"></span></span></a>`);
      a.querySelector('.card-name').textContent = p.name;
      a.querySelector('.card-size').textContent = p.size;
      a.querySelector('.card-blurb').textContent = p.blurb;
      const fromPrice = p.sizes ? Math.min(...(p.presets || SIGN_PRICING.presets).map(([w, h]) => Math.min(...Object.values(signPrices(w, h, p.layered))))) : Math.min(...Object.values(p.price));
      a.querySelector('.card-price').textContent = `From ${money(fromPrice)}`;
      a.dataset.id = p.id;
      grid.appendChild(a);
    }
    wrap.appendChild(sec);
  }
}

// Render a product with its example text, for the catalog cards.
async function renderThumb(p) {
  activate(p);
  const e = await newTextElement();
  const keepEls = els; els = [e];
  const prevBorder = border; border = { style: P.thumbBorder || 'none', weight: P.border.weight, corners: 'match' };
  if (P.photo && !P.photoMat.map) await setFramePhoto(ASSETS.frame.dog);
  if (P.family) { els = [newCutoutElement(placeholderFamily(), 'Sample family'), e]; P.cutKey = null; }
  renderMask();
  const w = 720, h = 540;
  renderer.setPixelRatio(1); renderer.setSize(w, h, false);
  camera.aspect = w / h; camera.updateProjectionMatrix();
  const pose = pose3d(P.preset.theta, P.preset.phi, 1.12);
  setPose(pose);
  renderer.render(scene, camera);
  const c = document.createElement('canvas'); c.width = w; c.height = h;
  const g = c.getContext('2d');
  g.fillStyle = '#fffcf5'; g.fillRect(0, 0, w, h);
  g.drawImage(glCanvas, 0, 0);
  els = keepEls; border = prevBorder;
  renderMask();
  return c.toDataURL('image/jpeg', 0.86);
}

/* ---------------------------------------------------------------
   Proof image
---------------------------------------------------------------- */
let downloads;
const inClaude = !!(window.claude && typeof window.claude.use === 'function');
if (inClaude) {
  window.claude.use('downloads').then((d) => { downloads = d; if (!d) $('proofBtn').hidden = true; }).catch(() => { downloads = null; $('proofBtn').hidden = true; });
}

function renderShot(pose, w, h) {
  renderer.setPixelRatio(1); renderer.setSize(w, h, false);
  camera.aspect = w / h; camera.updateProjectionMatrix();
  setPose(pose);
  renderer.render(scene, camera);
  const c = document.createElement('canvas'); c.width = w; c.height = h;
  c.getContext('2d').drawImage(glCanvas, 0, 0);
  return c;
}

function makeProof() {
  const pw = 1100, ph = 760;
  const savedW = W, savedH = H;
  W = pw; H = ph; camera.aspect = pw / ph;
  const flat = renderShot(poseFlat(1, 0, 0), pw, ph);
  const angle = renderShot(pose3d(P.preset.theta, P.preset.phi, 1), pw, ph);
  W = savedW; H = savedH;
  resize();
  const pad = 56, rows = els.length + (border.style !== 'none' ? 1 : 0) + (P.note ? 1 : 0), listH = 60 + rows * 34;
  const out = document.createElement('canvas');
  out.width = pw * 2 + pad * 3; out.height = ph + pad * 2 + 90 + listH;
  const g = out.getContext('2d');
  g.fillStyle = '#fffcf5'; g.fillRect(0, 0, out.width, out.height);
  g.fillStyle = '#1d2326';
  g.font = '600 42px Poppins, system-ui, sans-serif';
  g.fillText(`${P.name} engraving proof`, pad, pad + 40);
  g.font = '400 24px Poppins, system-ui, sans-serif';
  g.fillStyle = '#5a6469';
  g.fillText(`${wood.label}, ${P.size}. ${money(priceNow())}. Saved ${new Date().toLocaleDateString()}`, pad, pad + 80);
  const top = pad + 110;
  g.drawImage(flat, pad, top); g.drawImage(angle, pad * 2 + pw, top);
  let y = top + ph + 60;
  g.font = '600 24px Poppins, system-ui, sans-serif'; g.fillStyle = '#1d2326';
  g.fillText('Design details', pad, y);
  g.font = '400 22px Poppins, system-ui, sans-serif'; g.fillStyle = '#3a4246';
  if (P.note) { g.fillText(P.note, pad, y + 40); y += 34; }
  if (border.style !== 'none') {
    g.fillText(`Border: ${borderLabel()}, ${border.weight.toFixed(2)} in lines, ${fracIn(P.border.inset)} inside the edge`, pad, y + 40);
    y += 34;
  }
  els.forEach((e, i) => {
    const { w, h } = dims(e);
    if (e.path) { g.fillText(`${i + 1}. Text “${e.text.replace(/\n/g, ' ')}” in ${FONTS.find((f) => f.id === e.font).label}, ${e.pathSize.toFixed(2)} in tall, ${P.round ? 'around the circle' : 'following the border'}`, pad, y + 40 + i * 34); return; }
    const what = e.type === 'text' ? `Text “${e.text.replace(/\n/g, ' / ')}” in ${FONTS.find((f) => f.id === e.font).label}` : `${e.file} (${e.style === 'photo' ? 'photo' : 'line art'})`;
    const centred = Math.abs(e.x) < 0.05 && Math.abs(e.y) < 0.05;
    const where = centred ? 'centered' : `center ${fmt(Math.abs(e.x))} in ${e.x >= 0 ? 'right' : 'left'} and ${fmt(Math.abs(e.y))} in ${e.y >= 0 ? 'below' : 'above'} the middle`;
    g.fillText(`${i + 1}. ${what}: ${fmt(w)} × ${fmt(h)} in, ${Math.round(e.rot)}°, ${where}`, pad, y + 40 + i * 34);
  });
  return out;
}

$('proofBtn').onclick = async () => {
  const btn = $('proofBtn');
  btn.disabled = true;
  try {
    const canvas = makeProof();
    const blob = await new Promise((r) => canvas.toBlob(r, 'image/png'));
    const filename = `${P.id}-engraving-proof.png`;
    if (inClaude) {
      if (!downloads) { toast('Saving isn’t available in this view.'); return; }
      try { await downloads.save({ filename, data: blob }); toast('Proof saved.'); }
      catch (err) { if (err && err.code !== 'declined') toast('The proof couldn’t be saved. Try again in a moment.'); }
    } else {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob); a.download = filename;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 2000);
      toast('Proof saved.');
    }
  } finally {
    updateHistoryButtons();
  }
};

/* ---------------------------------------------------------------
   Start
---------------------------------------------------------------- */
let READY = false;
buildWoods();
buildCatalog();
route();
(async () => {
  await loadTextures();
  try { await document.fonts.ready; } catch (_) {}
  if (MOUNT) { READY = true; resize(); route(); return; }   // product page: just this product
  for (const p of PRODUCTS) {
    try {
      const url = await renderThumb(p);
      const card = DOC.querySelector(`.card[data-id="${p.id}"] .card-img`);
      card.innerHTML = '';
      const img = new Image(); img.alt = `${p.name} preview`; img.src = url;
      card.appendChild(img);
    } catch (err) { console.error(err); }
  }
  // thumbnails are done: start every product with a clean design
  if (P) scene.remove(P.group);
  P = null;
  for (const id in STORE) delete STORE[id];
  READY = true;
  resize();
  route();
})();
/* ---------------------------------------------------------------
   Orders: where "Add to cart" sends a design.
   Paste a webhook URL here (for example from Zapier or Make) to have
   every order emailed to you with its SVG. Leave it empty to only
   offer the SVG download. Sending only works when this page is hosted
   on your own site; inside Claude the page can't reach other sites.
---------------------------------------------------------------- */
const SHOP = { orderWebhook: '' };

/* ---------------------------------------------------------------
   Laser settings per wood (xTool S1 40W). Starting points: test on
   an offcut and update these as you dial each wood in.
   fill = text, borders and line art. photo = grayscale photos.
   power %, speed mm/s, lpc = lines per cm.
---------------------------------------------------------------- */
const LASER = {
  machine: 'xTool S1 40W',
  cherry: { fill: { power: 25, speed: 200, lpc: 80 }, photo: { power: 20, speed: 300, lpc: 110 } },
  maple:  { fill: { power: 30, speed: 200, lpc: 80 }, photo: { power: 22, speed: 300, lpc: 110 } },
  birch:  { fill: { power: 30, speed: 200, lpc: 80 }, photo: { power: 22, speed: 300, lpc: 110 } },
  poplar: { fill: { power: 20, speed: 250, lpc: 70 }, photo: { power: 15, speed: 350, lpc: 100 } },
  walnut: { fill: { power: 35, speed: 180, lpc: 80 }, photo: { power: 25, speed: 250, lpc: 110 } },
};
const laserText = (k) => { const s = (LASER[wood.id] || LASER.cherry)[k]; return `${s.power}% power, ${s.speed} mm/s, ${s.lpc} lines/cm`; };

/* ---------------------------------------------------------------
   SVG export: real size in inches. Border as vector paths,
   text and artwork as a 300 DPI image, product outline in red.
---------------------------------------------------------------- */
const f4 = (n) => +n.toFixed(4);

function esc(s) { return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }

function rasterLayer(list, dpi) {
  const c = document.createElement('canvas');
  c.width = Math.round(DW * dpi); c.height = Math.round(DH * dpi);
  const ctx = c.getContext('2d');
  let any = false;
  for (const e of list) {
    const { w, h } = dims(e);
    ctx.save();
    if (isMasked(e)) clipToMask(ctx, (x) => (x + DW / 2) * dpi, (y) => (y + DH / 2) * dpi);
    ctx.globalAlpha = e.darkness;
    ctx.translate((e.x + DW / 2) * dpi, (e.y + DH / 2) * dpi);
    ctx.rotate(e.rot * Math.PI / 180);
    if (e.flip) ctx.scale(-1, 1);
    ctx.drawImage(e.bmp, -w * dpi / 2, -h * dpi / 2, w * dpi, h * dpi);
    ctx.restore();
    any = true;
  }
  return any ? c.toDataURL('image/png') : null;
}

function outlinePath(d, b) {
  const sm = rrSampler(d, b), n = 900, pts = [];
  for (let i = 0; i < n; i++) { const q = sm.at(i / n * sm.total); pts.push(`${f4(q.x + DW / 2)} ${f4(q.y + DH / 2)}`); }
  return `M${pts.join('L')}Z`;
}

async function exportSVG(details) {
  const dpi = Math.min(300, 6000 / Math.max(DW, DH));
  const parts = [];
  // product outline (alignment only)
  let outline = `<path d="${outlinePath(0, { corners: 'match' })}"/>`;
  if (P.keepOut) { const k = P.keepOut; outline += `<rect x="${f4(k.x0 + DW / 2)}" y="${f4(k.y0 + DH / 2)}" width="${f4(k.x1 - k.x0)}" height="${f4(k.y1 - k.y0)}"/>`; }
  parts.push(`<g id="outline" inkscape:label="Product outline (alignment only)" fill="none" stroke="#ff0000" stroke-width="0.01">${outline}</g>`);
  // border, as vectors
  if (border.style !== 'none') {
    parts.push(`<g id="engrave-border" inkscape:label="Engrave: border (fill: ${laserText('fill')})"><path d="${borderCompoundPath()}" fill="#000" fill-rule="evenodd"/></g>`);
  }
  // text and line art as vectors, photos as an image
  const vec = els.filter((e) => e.type === 'text' || (e.type === 'image' && e.style === 'line'));
  if (vec.length) parts.push(`<g id="engrave-text" inkscape:label="Engrave: text and line art (fill: ${laserText('fill')})"><path d="${await textCompoundPath(vec)}" fill="#000" fill-rule="evenodd"/></g>`);
  const photos = els.filter((e) => e.type === 'image' && e.style === 'photo');
  const art = rasterLayer(photos, dpi);
  if (art) parts.push(`<image id="engrave-photo" inkscape:label="Engrave: photos, ${Math.round(dpi)} DPI (grayscale: ${laserText('photo')})" x="0" y="0" width="${f4(DW)}" height="${f4(DH)}" preserveAspectRatio="none" xlink:href="${art}" href="${art}"/>`);
  // raised layer on the family ornaments
  const cut = els.find((e) => e.type === 'cutout');
  if (cut) {
    const all = cutoutClipped(cut).map((p) => `${f4(p.x + DW / 2)} ${f4(p.y + DH / 2)}`);
    parts.push(`<g id="top-layer-cut" inkscape:label="Top layer: cut line" fill="none" stroke="#0000ff" stroke-width="0.01">${all.length > 2 ? `<path d="M${all.join('L')}Z"/>` : ''}</g>`);
    const top = rasterLayer([cut], dpi);
    if (top) parts.push(`<image id="top-layer-engrave" inkscape:label="Top layer: engrave photo, ${Math.round(dpi)} DPI (grayscale: ${laserText('photo')})" x="0" y="0" width="${f4(DW)}" height="${f4(DH)}" preserveAspectRatio="none" xlink:href="${top}" href="${top}"/>`);
  }
  const desc = details.join('\n');
  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" width="${f4(DW)}in" height="${f4(DH)}in" viewBox="0 0 ${f4(DW)} ${f4(DH)}">
<title>${esc(P.name)} engraving</title>
<desc>${esc(desc)}</desc>
${parts.join('\n')}
</svg>`;
}

function orderDetails() {
  const lines = [`Product: ${P.name} (${P.size})`, `Wood: ${wood.label}`, `Price: ${money(priceNow())}`,
    `Laser (${LASER.machine}): text, borders and line art at ${laserText('fill')}; photos at ${laserText('photo')}`];
  if (border.style !== 'none') lines.push(`Border: ${borderLabel()}, ${border.weight.toFixed(2)} in lines, ${fracIn(P.border.inset)} inside the edge`);
  els.forEach((e, i) => {
    const { w, h } = dims(e);
    if (e.type === 'text') lines.push(`${i + 1}. Text "${e.text.replace(/\n/g, e.path ? ' ' : ' / ')}" in ${FONTS.find((f) => f.id === e.font).label}${e.path ? `, ${P.round ? 'around the circle' : 'following the border'}` : `, ${fmt(w)} × ${fmt(h)} in, ${Math.round(e.rot)}°`}`);
    else if (e.type === 'cutout') lines.push(`${i + 1}. Raised image ${e.file || e.name}, ${fmt(w)} × ${fmt(h)} in`);
    else lines.push(`${i + 1}. Artwork ${e.file} (${e.style === 'photo' ? 'photo' : 'line art'}), ${fmt(w)} × ${fmt(h)} in, ${Math.round(e.rot)}°`);
  });
  return lines;
}

/* ---------------------------------------------------------------
   Cart
---------------------------------------------------------------- */
const cart = [];
let cartSeq = 1;

function smallShot() {
  const savedW = W, savedH = H;
  W = 320; H = 240; camera.aspect = W / H;
  const c = renderShot(pose3d(P.preset.theta, P.preset.phi, 1.05), 320, 240);
  W = savedW; H = savedH; resize();
  const out = document.createElement('canvas'); out.width = 320; out.height = 240;
  const g = out.getContext('2d');
  g.fillStyle = '#fffcf5'; g.fillRect(0, 0, 320, 240); g.drawImage(c, 0, 0);
  return out.toDataURL('image/jpeg', 0.85);
}

async function saveFile(filename, data) {
  if (inClaude) {
    if (!downloads) { toast('Downloads aren’t available in this view.'); return false; }
    try { await downloads.save({ filename, data }); return true; }
    catch (err) { if (err && err.code !== 'declined') toast(err && err.code === 'extension_not_enabled' ? 'SVG downloads aren’t available in this view.' : 'The file couldn’t be saved. Try again in a moment.'); return false; }
  }
  const blob = data instanceof Blob ? data : new Blob([data]);
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  return true;
}

async function sendOrder(item) {
  if (!SHOP.orderWebhook || inClaude) return false;
  try {
    const res = await fetch(SHOP.orderWebhook, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product: item.product, wood: item.wood, price: item.price, details: item.details.join('\n'), filename: item.filename, svg: item.svg, created: new Date().toISOString() }),
    });
    return res.ok;
  } catch (_) { return false; }
}

$('cartAddBtn').onclick = async () => {
  if (!els.length && border.style === 'none') { toast('Add text, artwork or a border first.'); return; }
  const blocking = els.map(problem).filter(Boolean);
  if (blocking.length) { toast('Fix the highlighted items first, then add to cart.'); return; }
  const btn = $('cartAddBtn'); btn.disabled = true; btn.textContent = 'Preparing your design…';
  await new Promise((r) => setTimeout(r, 30));
  try {
    select(null);
    const details = orderDetails();
    const id = cartSeq++;
    const item = { id, product: P.name, productId: P.id, wood: wood.label, price: priceNow(), details, svg: await exportSVG(details), thumb: smallShot(), filename: `order-${id}-${P.id}.svg`, sent: false };
    if (SHOPIFY) { await shopifyAdd(item); return; }
    cart.push(item);
    item.sent = await sendOrder(item);
    renderCart(); openCart();
  } finally { btn.disabled = false; btn.textContent = 'Add to cart'; }
};

function renderCart() {
  $('cartCount').textContent = cart.length;
  $('cartCount').hidden = cart.length === 0;
  const list = $('cartList');
  list.innerHTML = '';
  $('cartTotal').hidden = cart.length === 0;
  $('cartTotalNum').textContent = money(cart.reduce((t, it) => t + it.price, 0));
  $('cartEmpty').hidden = cart.length > 0;
  for (const it of cart) {
    const li = el(`<li class="cart-item"><img alt=""><div class="ci-body"><div class="ci-name"></div><div class="ci-meta"></div><div class="ci-sent"></div><div class="ci-actions"><button class="btn btn-small" type="button" data-a="svg">Download design (SVG)</button><button class="btn btn-small btn-danger" type="button" data-a="rm">Remove</button></div></div></li>`);
    li.querySelector('img').src = it.thumb;
    li.querySelector('.ci-name').textContent = `${it.product}, ${money(it.price)}`;
    li.querySelector('.ci-meta').textContent = it.details.filter((d) => !d.startsWith('Laser') && !d.startsWith('Price')).slice(1).join(' · ').slice(0, 220);
    li.querySelector('.ci-sent').textContent = it.sent ? 'Sent to the shop.' : '';
    li.querySelector('[data-a="svg"]').onclick = () => saveFile(it.filename, new Blob([it.svg], { type: 'image/svg+xml' }));
    li.querySelector('[data-a="rm"]').onclick = () => { cart.splice(cart.indexOf(it), 1); renderCart(); };
    list.appendChild(li);
  }
}
function openCart() { $('cart').hidden = false; $('cartClose').focus(); }
function closeCart() { $('cart').hidden = true; }
$('cartBtn').onclick = openCart;
$('cartClose').onclick = closeCart;
$('cart').addEventListener('click', (ev) => { if (ev.target.id === 'cart') closeCart(); });
window.addEventListener('keydown', (ev) => { if (ev.key === 'Escape' && !$('cart').hidden) closeCart(); });
renderCart();
/* ---------------------------------------------------------------
   Border → one compound shape. The border is drawn at high
   resolution, then traced (marching squares with sub-pixel edges)
   so overlapping lines merge into filled outlines with holes.
---------------------------------------------------------------- */
function traceAll(alpha, w, h) {
  const v = (x, y) => (x < 0 || y < 0 || x >= w || y >= h) ? 0 : alpha[y * w + x];
  const W2 = w + 2;
  const hKey = (x, y) => ((y + 1) * W2 + (x + 1)) * 2;       // edge between (x,y) and (x+1,y)
  const vKey = (x, y) => ((y + 1) * W2 + (x + 1)) * 2 + 1;   // edge between (x,y) and (x,y+1)
  const pts = new Map(), adj = new Map();
  const point = (k, x, y, horiz) => {
    if (pts.has(k)) return;
    if (horiz) { const a = v(x, y), b = v(x + 1, y); pts.set(k, [x + (128 - a) / ((b - a) || 1), y]); }
    else { const a = v(x, y), b = v(x, y + 1); pts.set(k, [x, y + (128 - a) / ((b - a) || 1)]); }
  };
  const link = (a, b) => {
    if (!adj.has(a)) adj.set(a, []); if (!adj.has(b)) adj.set(b, []);
    adj.get(a).push(b); adj.get(b).push(a);
  };
  const rowAny = new Uint8Array(h);
  for (let y = 0; y < h; y++) { for (let x = 0, o = y * w; x < w; x++) if (alpha[o + x] >= 128) { rowAny[y] = 1; break; } }
  for (let y = -1; y < h; y++) {
    if (!(y >= 0 && rowAny[y]) && !(y + 1 < h && rowAny[y + 1])) continue;
    for (let x = -1; x < w; x++) {
    const a = v(x, y) >= 128, b = v(x + 1, y) >= 128, c = v(x + 1, y + 1) >= 128, d = v(x, y + 1) >= 128;
    const idx = (a << 3) | (b << 2) | (c << 1) | d;
    if (idx === 0 || idx === 15) continue;
    const T = hKey(x, y), B = hKey(x, y + 1), L = vKey(x, y), R = vKey(x + 1, y);
    const segs = [null, [[L, B]], [[B, R]], [[L, R]], [[T, R]], [[T, L], [B, R]], [[T, B]], [[T, L]], [[T, L]], [[T, B]], [[T, R], [L, B]], [[T, R]], [[L, R]], [[B, R]], [[L, B]]][idx];
    for (const [p, q] of segs) {
      point(p, p === T ? x : p === B ? x : p === L ? x : x + 1, p === T ? y : p === B ? y + 1 : y, p === T || p === B);
      point(q, q === T ? x : q === B ? x : q === L ? x : x + 1, q === T ? y : q === B ? y + 1 : y, q === T || q === B);
      link(p, q);
    }
    }
  }
  const seen = new Set(), loops = [];
  for (const k0 of adj.keys()) {
    if (seen.has(k0)) continue;
    const loop = []; let prev = -1, k = k0;
    while (k !== undefined && !seen.has(k)) {
      seen.add(k); loop.push(pts.get(k));
      const nx = adj.get(k).find((m) => m !== prev && !seen.has(m));
      prev = k; k = nx;
    }
    if (loop.length > 2) loops.push(loop);
  }
  return loops;
}

// Draw something at `dpi` in strips, then trace it into one compound path (inches).
function traceToPath(dpi, draw) {
  const w = Math.ceil(DW * dpi), h = Math.ceil(DH * dpi);
  const alpha = new Uint8Array(w * h);
  const stripH = Math.max(64, Math.floor(3e6 / w));
  const c = document.createElement('canvas'); c.width = w; c.height = stripH;
  const ctx = c.getContext('2d', { willReadFrequently: true });
  for (let y0 = 0; y0 < h; y0 += stripH) {
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, w, stripH);
    ctx.fillStyle = ctx.strokeStyle = '#000'; ctx.globalAlpha = 1;
    draw(ctx, (x) => (x + DW / 2) * dpi - 0.5, (y) => (y + DH / 2) * dpi - 0.5 - y0, y0);
    const rows = Math.min(stripH, h - y0), d = ctx.getImageData(0, 0, w, rows).data;
    for (let i = 0, n = w * rows; i < n; i++) alpha[y0 * w + i] = d[i * 4 + 3];
  }
  return traceAll(alpha, w, h).map((l) => 'M' + simplify(l, 0.3).map(([x, y]) => `${f4((x + 0.5) / dpi)} ${f4((y + 0.5) / dpi)}`).join('L') + 'Z').join('');
}

function borderCompoundPath() {
  const dpi = Math.min(400, 7000 / Math.max(DW, DH));
  return traceToPath(dpi, (ctx, X, Y) => drawBorder(ctx, X, Y, dpi));
}

// Text (straight or along the border) and line-art artwork, traced into one compound path.
async function textCompoundPath(list) {
  const dpi = Math.min(600, 7000 / Math.max(DW, DH));
  const hi = [];
  for (const e of list) {
    const c = { ...e };
    if (e.type === 'text' && e.path) buildPathText(c, dpi);
    else if (e.type === 'text') {
      const fs = Math.min(1400, Math.max(220, Math.round(220 * dpi * e.ipp)));
      c.bmp = await makeTextBitmap(e, fs);
      c.ipp = e.ipp * 220 / fs;
    }
    hi.push(c);
  }
  return traceToPath(dpi, (ctx, X, Y) => {
    for (const e of hi) {
      const { w, h } = dims(e);
      ctx.save();
      if (isMasked(e)) clipToMask(ctx, (x) => X(x) + 0.5, (y) => Y(y) + 0.5);
      ctx.translate(X(e.x) + 0.5, Y(e.y) + 0.5);
      ctx.rotate(e.rot * Math.PI / 180);
      if (e.flip) ctx.scale(-1, 1);
      ctx.drawImage(e.bmp, -w * dpi / 2, -h * dpi / 2, w * dpi, h * dpi);
      ctx.restore();
    }
  });
}

/* ---------------------------------------------------------------
   Shopify: when this page runs inside your store (the page.designer
   template sets window.ENGRAVE_SHOPIFY), Add to cart puts the exact
   product variant in the Shopify cart with the design attached.
---------------------------------------------------------------- */
const SHOPIFY = window.ENGRAVE_SHOPIFY || null;
const VARIANTS = {"cutting-board": {"birch": 67678533124341, "maple": 67678533157109, "cherry": 67678533189877, "walnut": 67678533222645}, "charcuterie-board": {"birch": 67678534697205, "maple": 67678534729973, "cherry": 67678534762741, "walnut": 67678534795509}, "cutting-board-end-grain": {"birch": 67678535057653, "maple": 67678535090421, "cherry": 67678535123189, "walnut": 67678535155957}, "coasters": {"poplar": 67678535319797, "birch": 67678535352565, "maple": 67678535385333, "cherry": 67678535418101, "walnut": 67678535450869}, "coaster-rounded": {"poplar": 67678535614709, "birch": 67678535647477, "maple": 67678535680245, "cherry": 67678535713013, "walnut": 67678535745781}, "coaster-round": {"poplar": 67678535942389, "birch": 67678535975157, "maple": 67678536007925, "cherry": 67678536040693, "walnut": 67678536073461}, "photo-frame": {"poplar": 67678536237301, "birch": 67678536270069, "maple": 67678536302837, "cherry": 67678536335605, "walnut": 67678536368373}, "photo-frame-rounded": {"poplar": 67678536564981, "birch": 67678536597749, "maple": 67678536630517, "cherry": 67678536663285, "walnut": 67678536696053}, "ornament": {"poplar": 67678536892661, "birch": 67678536925429, "maple": 67678536958197, "cherry": 67678536990965, "walnut": 67678537023733}, "ornament-family": {"poplar": 67678537220341, "birch": 67678537253109, "maple": 67678537285877, "cherry": 67678537318645, "walnut": 67678537351413}, "ornament-family-rect": {"poplar": 67678537515253, "birch": 67678537548021, "maple": 67678537580789, "cherry": 67678537613557, "walnut": 67678537646325}, "keepsake-box": {"poplar": 67678542364917, "birch": 67678542397685, "maple": 67678542430453, "cherry": 67678542463221, "walnut": 67678542495989}, "family-sign": {"18x7.25": {"poplar": 67678538563829, "birch": 67678538596597, "maple": 67678538629365, "cherry": 67678538662133, "walnut": 67678538694901}, "12x8": {"poplar": 67678538727669, "birch": 67678538760437, "maple": 67678538793205, "cherry": 67678538825973, "walnut": 67678538858741}, "18x12": {"poplar": 67678538891509, "birch": 67678538924277, "maple": 67678538957045, "cherry": 67678538989813, "walnut": 67678539022581}, "24x12": {"poplar": 67678539055349, "birch": 67678539088117, "maple": 67678539120885, "cherry": 67678539153653, "walnut": 67678539186421}, "24x18": {"poplar": 67678539219189, "birch": 67678539251957, "maple": 67678539284725, "cherry": 67678539317493, "walnut": 67678539350261}, "36x12": {"poplar": 67678539383029, "birch": 67678539415797, "maple": 67678539448565, "cherry": 67678539481333, "walnut": 67678539514101}}, "custom-sign": {"12x8": {"poplar": 67678540038389, "birch": 67678540071157, "maple": 67678540103925, "cherry": 67678540136693, "walnut": 67678540169461}, "18x12": {"poplar": 67678540202229, "birch": 67678540234997, "maple": 67678540267765, "cherry": 67678540300533, "walnut": 67678540333301}, "24x12": {"poplar": 67678540366069, "birch": 67678540398837, "maple": 67678540431605, "cherry": 67678540464373, "walnut": 67678540497141}, "24x18": {"poplar": 67678540529909, "birch": 67678540562677, "maple": 67678540595445, "cherry": 67678540628213, "walnut": 67678540660981}, "36x12": {"poplar": 67678540693749, "birch": 67678540726517, "maple": 67678540759285, "cherry": 67678540792053, "walnut": 67678540824821}}, "custom-sign-layered": {"12x8": {"poplar": 67678541381877, "birch": 67678541414645, "maple": 67678541447413, "cherry": 67678541480181, "walnut": 67678541512949}, "18x12": {"poplar": 67678541545717, "birch": 67678541578485, "maple": 67678541611253, "cherry": 67678541644021, "walnut": 67678541676789}, "24x12": {"poplar": 67678541709557, "birch": 67678541742325, "maple": 67678541775093, "cherry": 67678541807861, "walnut": 67678541840629}, "24x18": {"poplar": 67678541873397, "birch": 67678541906165, "maple": 67678541938933, "cherry": 67678541971701, "walnut": 67678542004469}, "36x12": {"poplar": 67678542037237, "birch": 67678542070005, "maple": 67678542102773, "cherry": 67678542135541, "walnut": 67678542168309}}};

function variantFor() {
  const m = VARIANTS[P.id];
  if (!m) return null;
  if (P.sizes) { const s = m[`${P.sizeW}x${P.sizeH}`]; return s ? s[wood.id] : null; }
  return m[wood.id] || null;
}
function dataUrlToFile(url, name) {
  const [head, data] = url.split(','), mime = head.match(/:(.*?);/)[1];
  const bin = atob(data), u8 = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
  return new File([u8], name, { type: mime });
}
async function shopifyAdd(item) {
  const id = variantFor();
  if (!id) { toast('That size and wood can’t be ordered online yet. Pick one of the listed sizes.'); return false; }
  const build = (withFiles) => {
    const fd = new FormData();
    fd.append('id', String(id));
    fd.append('quantity', '1');
    fd.append('properties[Wood]', wood.label);
    if (P.sizes) fd.append('properties[Size]', `${P.sizeW} × ${P.sizeH} in`);
    item.details.filter((d) => /^\d+\.|^Border/.test(d)).forEach((d, i) => fd.append(`properties[Design ${i + 1}]`, d.replace(/^\d+\.\s*/, '')));
    fd.append('properties[_Laser]', item.details.find((d) => d.startsWith('Laser')) || '');
    if (withFiles) {
      fd.append('properties[_Design file]', new File([item.svg], item.filename, { type: 'image/svg+xml' }));
      fd.append('properties[_Preview]', dataUrlToFile(item.thumb, item.filename.replace(/\.svg$/, '.jpg')));
    }
    return fd;
  };
  const post = (fd) => fetch(`${SHOPIFY.root || '/'}cart/add.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
  try {
    let res = await post(build(true));
    if (!res.ok) {
      res = await post(build(false));
      if (!res.ok) throw new Error(await res.text());
      toast('Added to your cart, but the design file couldn’t be attached. We’ll contact you for it.');
      await new Promise((r) => setTimeout(r, 2500));
    }
    try { (EMBED ? window.top : window).location.href = SHOPIFY.cart || '/cart'; } catch (_) { location.href = SHOPIFY.cart || '/cart'; }
    return true;
  } catch (err) {
    console.error(err);
    toast('This couldn’t be added to your cart. Please try again in a moment.');
    return false;
  }
}
if (SHOPIFY) $('cartBtn').hidden = true;
// Embedded on a product page (iframe with ?embed=1): one product only, cart opens in the main window.
const EMBED = !!MOUNT || new URLSearchParams(location.search).has('embed');
if (EMBED) {
  $('backBtn').hidden = true;
  document.documentElement.classList.add('embedded');
}

/* ---------------------------------------------------------------
   Decorations: 20 line-art graphics customers can add with a tap,
   plus styles for the background pop-up.
---------------------------------------------------------------- */
const DECOR = [{"name": "Heart", "vb": "0 0 100 100", "body": "<path d=\"M50 84C20 64 10 46 18 32C25 20 42 20 50 34C58 20 75 20 82 32C90 46 80 64 50 84Z\"/>"}, {"name": "Wedding rings", "vb": "0 0 100 100", "body": "<circle cx=\"38\" cy=\"56\" r=\"22\"/><circle cx=\"62\" cy=\"56\" r=\"22\"/><path d=\"M56 26 62 18 68 26 62 32Z\"/>"}, {"name": "Mountains", "vb": "0 0 100 100", "body": "<path d=\"M8 80 36 38 52 60 64 46 92 80Z\"/><path d=\"M28 50 36 38 44 50\"/><circle cx=\"72\" cy=\"24\" r=\"8\"/>"}, {"name": "Pine tree", "vb": "0 0 100 100", "body": "<path d=\"M50 8 31 36H42L24 60H40L20 84H80L60 60H76L58 36H69Z\"/><path d=\"M50 84V94\"/>"}, {"name": "Leafy sprig", "vb": "0 0 100 100", "body": "<path d=\"M50 94C50 70 51 40 50 14\"/><path d=\"M50 76C38 72 32 64 32 56C42 58 50 66 50 76Z\"/><path d=\"M50 76C62 72 68 64 68 56C58 58 50 66 50 76Z\"/><path d=\"M50 56C39.2 52.4 33.8 45.2 33.8 38C42.8 39.8 50 47 50 56Z\"/><path d=\"M50 56C60.8 52.4 66.2 45.2 66.2 38C57.2 39.8 50 47 50 56Z\"/><path d=\"M50 36C41 33 36.5 27 36.5 21C44 22.5 50 28.5 50 36Z\"/><path d=\"M50 36C59 33 63.5 27 63.5 21C56 22.5 50 28.5 50 36Z\"/><path d=\"M50 6C45 12 45 20 50 26C55 20 55 12 50 6Z\"/>"}, {"name": "Wheat", "vb": "0 0 100 100", "body": "<path d=\"M50 94V24\"/><path d=\"M50 38C43 37 38 31 39 24C45 26 50 31 50 38Z\"/><path d=\"M50 38C57 37 62 31 61 24C55 26 50 31 50 38Z\"/><path d=\"M50 50C43 49 38 43 39 36C45 38 50 43 50 50Z\"/><path d=\"M50 50C57 49 62 43 61 36C55 38 50 43 50 50Z\"/><path d=\"M50 62C43 61 38 55 39 48C45 50 50 55 50 62Z\"/><path d=\"M50 62C57 61 62 55 61 48C55 50 50 55 50 62Z\"/><path d=\"M50 74C43 73 38 67 39 60C45 62 50 67 50 74Z\"/><path d=\"M50 74C57 73 62 67 61 60C55 62 50 67 50 74Z\"/><path d=\"M50 30C45 24 45 16 50 8C55 16 55 24 50 30Z\"/>"}, {"name": "Star", "vb": "0 0 100 100", "body": "<path d=\"M50 12 60.6 39.4 89.9 41 67.1 59.6 74.7 88 50 72 25.3 88 32.9 59.6 10.1 41 39.4 39.4Z\"/>"}, {"name": "Sunburst", "vb": "0 0 100 100", "body": "<circle cx=\"50\" cy=\"50\" r=\"14\"/><path d=\"M72 50L90 50\"/><path d=\"M69.1 61L77.7 66\"/><path d=\"M61 69.1L70 84.6\"/><path d=\"M50 72L50 82\"/><path d=\"M39 69.1L30 84.6\"/><path d=\"M30.9 61L22.3 66\"/><path d=\"M28 50L10 50\"/><path d=\"M30.9 39L22.3 34\"/><path d=\"M39 30.9L30 15.4\"/><path d=\"M50 28L50 18\"/><path d=\"M61 30.9L70 15.4\"/><path d=\"M69.1 39L77.7 34\"/>"}, {"name": "Moon and stars", "vb": "0 0 100 100", "body": "<path d=\"M60 14A36 36 0 1 0 86 68A30 30 0 1 1 60 14Z\"/><path d=\"M24 14L26.4 19.6L32 22L26.4 24.4L24 30L21.6 24.4L16 22L21.6 19.6Z\"/><path d=\"M80 24L81.8 28.2L86 30L81.8 31.8L80 36L78.2 31.8L74 30L78.2 28.2Z\"/>"}, {"name": "Snowflake", "vb": "0 0 100 100", "body": "<path d=\"M50 50L90 50\"/><path d=\"M81 41L72 50L81 59\"/><path d=\"M89 43L82 50L89 57\"/><path d=\"M50 50L70 84.6\"/><path d=\"M73.3 72.3L61 69.1L57.7 81.3\"/><path d=\"M75.6 80.3L66 77.7L63.4 87.3\"/><path d=\"M50 50L30 84.6\"/><path d=\"M42.3 81.3L39 69.1L26.7 72.3\"/><path d=\"M36.6 87.3L34 77.7L24.4 80.3\"/><path d=\"M50 50L10 50\"/><path d=\"M19 59L28 50L19 41\"/><path d=\"M11 57L18 50L11 43\"/><path d=\"M50 50L30 15.4\"/><path d=\"M26.7 27.7L39 30.9L42.3 18.7\"/><path d=\"M24.4 19.7L34 22.3L36.6 12.7\"/><path d=\"M50 50L70 15.4\"/><path d=\"M57.7 18.7L61 30.9L73.3 27.7\"/><path d=\"M63.4 12.7L66 22.3L75.6 19.7\"/>"}, {"name": "Anchor", "vb": "0 0 100 100", "body": "<circle cx=\"50\" cy=\"16\" r=\"7\"/><path d=\"M50 23V88\"/><path d=\"M34 36H66\"/><path d=\"M16 62C18 78 32 88 50 88C68 88 82 78 84 62\"/><path d=\"M10 68 16 60 24 66\"/><path d=\"M90 68 84 60 76 66\"/>"}, {"name": "Paw print", "vb": "0 0 100 100", "body": "<g fill=\"currentColor\" stroke=\"none\"><ellipse cx=\"50\" cy=\"66\" rx=\"20\" ry=\"17\"/><ellipse cx=\"25\" cy=\"44\" rx=\"8\" ry=\"11\" transform=\"rotate(-20 25 44)\"/><ellipse cx=\"41\" cy=\"28\" rx=\"8\" ry=\"11\"/><ellipse cx=\"59\" cy=\"28\" rx=\"8\" ry=\"11\"/><ellipse cx=\"75\" cy=\"44\" rx=\"8\" ry=\"11\" transform=\"rotate(20 75 44)\"/></g>"}, {"name": "House", "vb": "0 0 100 100", "body": "<path d=\"M12 50 50 16 88 50\"/><path d=\"M22 42V86H78V42\"/><path d=\"M42 86V62H58V86\"/><path d=\"M66 30V18H74V37\"/>"}, {"name": "Palm tree", "vb": "0 0 100 100", "body": "<path d=\"M54 92C51 74 48 58 52 40\"/><path d=\"M52 40C40 28 26 28 12 36\"/><path d=\"M52 40C46 24 36 16 22 14\"/><path d=\"M52 40C56 22 66 15 80 16\"/><path d=\"M52 40C66 30 80 32 90 42\"/><path d=\"M52 40C61 45 67 55 67 64\"/><path d=\"M30 92H76\"/>"}, {"name": "Fork and knife", "vb": "0 0 100 100", "body": "<g transform=\"rotate(-32 50 52)\"><path d=\"M50 94V46\"/><path d=\"M41 10V30C41 40 59 40 59 30V10\"/><path d=\"M50 10V36\"/></g><g transform=\"rotate(32 50 52)\"><path d=\"M50 94V58\"/><path d=\"M50 58V8C59 12 62 34 59 58Z\"/></g>"}, {"name": "Wave", "vb": "0 0 100 100", "body": "<path d=\"M8 66C16 44 30 32 46 38C60 44 60 62 48 64C40 65 38 56 44 52\"/><path d=\"M8 66C30 66 44 72 60 66C72 62 80 56 92 58\"/><path d=\"M8 82C22 76 34 88 50 82C66 76 78 88 92 82\"/>"}, {"name": "Daisy", "vb": "0 0 100 100", "body": "<ellipse cx=\"50\" cy=\"26\" rx=\"7\" ry=\"15\" transform=\"rotate(0 50 50)\"/><ellipse cx=\"50\" cy=\"26\" rx=\"7\" ry=\"15\" transform=\"rotate(36 50 50)\"/><ellipse cx=\"50\" cy=\"26\" rx=\"7\" ry=\"15\" transform=\"rotate(72 50 50)\"/><ellipse cx=\"50\" cy=\"26\" rx=\"7\" ry=\"15\" transform=\"rotate(108 50 50)\"/><ellipse cx=\"50\" cy=\"26\" rx=\"7\" ry=\"15\" transform=\"rotate(144 50 50)\"/><ellipse cx=\"50\" cy=\"26\" rx=\"7\" ry=\"15\" transform=\"rotate(180 50 50)\"/><ellipse cx=\"50\" cy=\"26\" rx=\"7\" ry=\"15\" transform=\"rotate(216 50 50)\"/><ellipse cx=\"50\" cy=\"26\" rx=\"7\" ry=\"15\" transform=\"rotate(252 50 50)\"/><ellipse cx=\"50\" cy=\"26\" rx=\"7\" ry=\"15\" transform=\"rotate(288 50 50)\"/><ellipse cx=\"50\" cy=\"26\" rx=\"7\" ry=\"15\" transform=\"rotate(324 50 50)\"/><circle cx=\"50\" cy=\"50\" r=\"9\"/>"}, {"name": "Compass", "vb": "0 0 100 100", "body": "<circle cx=\"50\" cy=\"50\" r=\"42\"/><path d=\"M50 12 57 43 88 50 57 57 50 88 43 57 12 50 43 43Z\"/><path d=\"M50 50 64 36M50 50 36 64\"/><circle cx=\"50\" cy=\"50\" r=\"4\"/>"}, {"name": "Wreath", "vb": "0 0 100 100", "body": "<path d=\"M50 86C30 86 14 70 14 50C14 36 20 26 28 19\"/><path d=\"M50 86C70 86 86 70 86 50C86 36 80 26 72 19\"/><ellipse cx=\"26.2\" cy=\"83\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-100 26.2 83)\"/><ellipse cx=\"30.3\" cy=\"75.4\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-24 30.3 75.4)\"/><ellipse cx=\"15.6\" cy=\"71.7\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-78 15.6 71.7)\"/><ellipse cx=\"22.2\" cy=\"66.1\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-2 22.2 66.1)\"/><ellipse cx=\"10\" cy=\"57.2\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-56 10 57.2)\"/><ellipse cx=\"18.2\" cy=\"54.5\" rx=\"3.5\" ry=\"8\" transform=\"rotate(20 18.2 54.5)\"/><ellipse cx=\"10.2\" cy=\"41.7\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-34 10.2 41.7)\"/><ellipse cx=\"18.8\" cy=\"42.3\" rx=\"3.5\" ry=\"8\" transform=\"rotate(42 18.8 42.3)\"/><ellipse cx=\"16.2\" cy=\"27.4\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-12 16.2 27.4)\"/><ellipse cx=\"23.9\" cy=\"31.2\" rx=\"3.5\" ry=\"8\" transform=\"rotate(64 23.9 31.2)\"/><ellipse cx=\"27.1\" cy=\"16.4\" rx=\"3.5\" ry=\"8\" transform=\"rotate(10 27.1 16.4)\"/><ellipse cx=\"32.9\" cy=\"22.8\" rx=\"3.5\" ry=\"8\" transform=\"rotate(86 32.9 22.8)\"/><ellipse cx=\"69.7\" cy=\"75.4\" rx=\"3.5\" ry=\"8\" transform=\"rotate(24 69.7 75.4)\"/><ellipse cx=\"73.8\" cy=\"83\" rx=\"3.5\" ry=\"8\" transform=\"rotate(100 73.8 83)\"/><ellipse cx=\"77.8\" cy=\"66.1\" rx=\"3.5\" ry=\"8\" transform=\"rotate(2 77.8 66.1)\"/><ellipse cx=\"84.4\" cy=\"71.7\" rx=\"3.5\" ry=\"8\" transform=\"rotate(78 84.4 71.7)\"/><ellipse cx=\"81.8\" cy=\"54.5\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-20 81.8 54.5)\"/><ellipse cx=\"90\" cy=\"57.2\" rx=\"3.5\" ry=\"8\" transform=\"rotate(56 90 57.2)\"/><ellipse cx=\"81.2\" cy=\"42.3\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-42 81.2 42.3)\"/><ellipse cx=\"89.8\" cy=\"41.7\" rx=\"3.5\" ry=\"8\" transform=\"rotate(34 89.8 41.7)\"/><ellipse cx=\"76.1\" cy=\"31.2\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-64 76.1 31.2)\"/><ellipse cx=\"83.8\" cy=\"27.4\" rx=\"3.5\" ry=\"8\" transform=\"rotate(12 83.8 27.4)\"/><ellipse cx=\"67.1\" cy=\"22.8\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-86 67.1 22.8)\"/><ellipse cx=\"72.9\" cy=\"16.4\" rx=\"3.5\" ry=\"8\" transform=\"rotate(-10 72.9 16.4)\"/><path d=\"M50 86 41 95M50 86 59 95\"/><circle cx=\"50\" cy=\"86\" r=\"3\"/>"}, {"name": "Flourish", "vb": "0 0 160 60", "body": "<path d=\"M80 30H120M80 30H40\"/><path d=\"M120 30C132 30 136 18 146 20C154 22 154 34 146 36C140 37 138 30 142 28\"/><path d=\"M40 30C28 30 24 18 14 20C6 22 6 34 14 36C20 37 22 30 18 28\"/><path d=\"M80 22 88 30 80 38 72 30Z\"/>"}, {"name": "Leaf", "vb": "0 0 100 100", "body": "<path d=\"M18 82C18 42 44 18 84 16C84 56 58 82 18 82Z\"/><path d=\"M18 82 64 36\"/><path d=\"M40 60H56M50 50V34\"/>"}, {"name": "Oak leaf", "vb": "0 0 100 100", "body": "<path d=\"M50 12C58 16 60 24 56 30C64 30 70 36 64 44C72 46 74 56 64 60C70 66 66 74 56 72C56 80 52 84 50 86C48 84 44 80 44 72C34 74 30 66 36 60C26 56 28 46 36 44C30 36 36 30 44 30C40 24 42 16 50 12Z\"/><path d=\"M50 26V94\"/>"}, {"name": "Maple leaf", "vb": "0 0 100 100", "body": "<path d=\"M50 10 56 28 70 22 66 40 84 36 74 50 84 58 64 60 68 76 52 66 50 88 48 66 32 76 36 60 16 58 26 50 16 36 34 40 30 22 44 28Z\"/><path d=\"M50 66V94\"/>"}, {"name": "Fern", "vb": "0 0 100 100", "body": "<path d=\"M50 94C50 70 46 40 34 12\"/><path d=\"M50 88C40.4 82 30.8 82 26 76\"/><path d=\"M50 88C59.6 80 69.2 78 74 70\"/><path d=\"M49.3 77.4C40.5 71.4 31.7 71.4 27.3 65.4\"/><path d=\"M49.3 77.4C58.1 69.4 66.8 67.4 71.2 59.4\"/><path d=\"M47.8 66.9C39.9 60.9 31.9 60.9 28 54.9\"/><path d=\"M47.8 66.9C55.8 58.9 63.8 56.9 67.7 48.9\"/><path d=\"M45.9 56.3C38.7 50.3 31.6 50.3 28 44.3\"/><path d=\"M45.9 56.3C53 48.3 60.1 46.3 63.7 38.3\"/><path d=\"M43.5 45.7C37.2 39.7 30.8 39.7 27.7 33.7\"/><path d=\"M43.5 45.7C49.8 37.7 56.1 35.7 59.2 27.7\"/><path d=\"M40.7 35.1C35.2 29.1 29.7 29.1 26.9 23.1\"/><path d=\"M40.7 35.1C46.1 27.1 51.6 25.1 54.4 17.1\"/><path d=\"M37.5 24.6C32.8 18.6 28.2 18.6 25.8 12.6\"/><path d=\"M37.5 24.6C42.2 16.6 46.8 14.6 49.2 6.6\"/>"}, {"name": "Tulip", "vb": "0 0 100 100", "body": "<path d=\"M50 56V92\"/><path d=\"M50 80C40 70 30 70 24 58C38 58 46 66 50 80Z\"/><path d=\"M50 84C60 74 70 72 76 62C62 62 54 70 50 84Z\"/><path d=\"M34 22C32 42 40 56 50 56C60 56 68 42 66 22L58 32 50 18 42 32Z\"/>"}, {"name": "Cactus", "vb": "0 0 100 100", "body": "<path d=\"M42 90V28C42 20 58 20 58 28V90\"/><path d=\"M42 62H34C28 62 26 58 26 52V42C26 36 34 36 34 42V52H42\"/><path d=\"M58 54H66C72 54 74 50 74 44V36C74 30 66 30 66 36V46H58\"/><path d=\"M24 90H76\"/>"}, {"name": "Mushroom", "vb": "0 0 100 100", "body": "<path d=\"M14 52C14 28 32 16 50 16C68 16 86 28 86 52Z\"/><path d=\"M38 52V82C38 88 62 88 62 82V52\"/><circle cx=\"34\" cy=\"38\" r=\"5\"/><circle cx=\"56\" cy=\"30\" r=\"4\"/><circle cx=\"68\" cy=\"42\" r=\"4\"/>"}, {"name": "Acorn", "vb": "0 0 100 100", "body": "<path d=\"M24 42C24 30 36 24 50 24C64 24 76 30 76 42Z\"/><path d=\"M50 24C50 18 54 14 60 12\"/><path d=\"M28 42C28 64 40 82 50 88C60 82 72 64 72 42\"/><path d=\"M34 34H66\"/>"}, {"name": "Pinecone", "vb": "0 0 100 100", "body": "<path d=\"M50 12C68 22 74 44 70 62C66 80 56 90 50 90C44 90 34 80 30 62C26 44 32 22 50 12Z\"/><path d=\"M32 30L50 38L68 30\"/><path d=\"M26 44L50 52L74 44\"/><path d=\"M26 58L50 66L74 58\"/><path d=\"M32 72L50 80L68 72\"/><path d=\"M50 12V6\"/>"}, {"name": "Cloud", "vb": "0 0 100 100", "body": "<path d=\"M28 72C16 72 12 60 18 52C22 44 32 44 36 48C38 34 52 28 62 34C72 38 74 46 72 52C82 52 88 60 84 68C82 72 78 72 74 72Z\"/>"}, {"name": "Lightning bolt", "vb": "0 0 100 100", "body": "<path d=\"M56 8 24 56H48L40 92 76 40H52Z\"/>"}, {"name": "Rainbow", "vb": "0 0 100 100", "body": "<path d=\"M12 76A38 38 0 0 1 88 76\"/><path d=\"M22 76A28 28 0 0 1 78 76\"/><path d=\"M32 76A18 18 0 0 1 68 76\"/>"}, {"name": "Oak tree", "vb": "0 0 100 100", "body": "<path d=\"M50 14C60 14 66 20 68 26C78 26 84 36 80 44C86 50 82 62 72 62C68 68 58 70 50 66C42 70 32 68 28 62C18 62 14 50 20 44C16 36 22 26 32 26C34 20 40 14 50 14Z\"/><path d=\"M50 66V90M50 78 40 70M50 74 60 66\"/><path d=\"M30 90H70\"/>"}, {"name": "Potted plant", "vb": "0 0 100 100", "body": "<path d=\"M30 62H70L64 90H36Z\"/><path d=\"M26 62H74\"/><path d=\"M50 62V36\"/><path d=\"M50 48C40 46 30 38 30 26C42 28 50 36 50 48Z\"/><path d=\"M50 40C58 36 68 28 70 16C58 18 50 28 50 40Z\"/>"}, {"name": "Lotus", "vb": "0 0 100 100", "body": "<path d=\"M50 70C42 60 40 40 50 24C60 40 58 60 50 70Z\"/><path d=\"M48 70C36 66 26 54 26 38C38 42 46 54 48 70Z\"/><path d=\"M52 70C64 66 74 54 74 38C62 42 54 54 52 70Z\"/><path d=\"M46 72C30 74 16 66 12 54C26 52 38 60 46 72Z\"/><path d=\"M54 72C70 74 84 66 88 54C74 52 62 60 54 72Z\"/><path d=\"M24 82H76\"/>"}, {"name": "Blossom", "vb": "0 0 100 100", "body": "<path d=\"M50 50C40 40 38 24 46 18C50 16 50 22 50 22C50 22 50 16 54 18C62 24 60 40 50 50Z\" transform=\"rotate(0 50 50)\"/><path d=\"M50 50C40 40 38 24 46 18C50 16 50 22 50 22C50 22 50 16 54 18C62 24 60 40 50 50Z\" transform=\"rotate(72 50 50)\"/><path d=\"M50 50C40 40 38 24 46 18C50 16 50 22 50 22C50 22 50 16 54 18C62 24 60 40 50 50Z\" transform=\"rotate(144 50 50)\"/><path d=\"M50 50C40 40 38 24 46 18C50 16 50 22 50 22C50 22 50 16 54 18C62 24 60 40 50 50Z\" transform=\"rotate(216 50 50)\"/><path d=\"M50 50C40 40 38 24 46 18C50 16 50 22 50 22C50 22 50 16 54 18C62 24 60 40 50 50Z\" transform=\"rotate(288 50 50)\"/><circle cx=\"50\" cy=\"50\" r=\"5\"/>"}, {"name": "Butterfly", "vb": "0 0 100 100", "body": "<path d=\"M50 30C40 14 16 12 16 30C16 44 32 50 48 50\"/><path d=\"M50 30C60 14 84 12 84 30C84 44 68 50 52 50\"/><path d=\"M48 52C34 54 24 64 30 76C36 84 46 74 50 60\"/><path d=\"M52 52C66 54 76 64 70 76C64 84 54 74 50 60\"/><path d=\"M50 26V74\"/><path d=\"M50 26 42 14M50 26 58 14\"/>"}, {"name": "Birds", "vb": "0 0 100 100", "body": "<path d=\"M12 42C20 34 28 34 34 42C40 34 48 34 56 42\"/><path d=\"M50 64C56 58 62 58 66 64C70 58 76 58 82 64\"/><path d=\"M24 74C28 70 32 70 34 74C36 70 40 70 44 74\"/>"}, {"name": "Feather", "vb": "0 0 100 100", "body": "<path d=\"M24 90C40 70 56 46 76 12\"/><path d=\"M76 12C86 30 80 54 64 70C54 80 42 82 34 78\"/><path d=\"M76 12C58 18 42 34 34 52C28 64 28 72 34 78\"/><path d=\"M52 50 66 44M44 62 58 58M60 36 72 28\"/>"}, {"name": "Fish", "vb": "0 0 100 100", "body": "<path d=\"M16 50C28 30 62 30 74 50C62 70 28 70 16 50Z\"/><path d=\"M74 50 90 36V64Z\"/><circle cx=\"30\" cy=\"46\" r=\"3\"/><path d=\"M44 38C48 44 48 56 44 62\"/>"}, {"name": "Whale tail", "vb": "0 0 100 100", "body": "<path d=\"M50 84C50 66 48 54 42 46C34 36 20 34 10 40C22 42 32 48 38 56\"/><path d=\"M50 84C50 66 52 54 58 46C66 36 80 34 90 40C78 42 68 48 62 56\"/><path d=\"M10 88C22 82 34 94 50 88C66 82 78 94 90 88\"/>"}, {"name": "Seashell", "vb": "0 0 100 100", "body": "<path d=\"M50 86 16 48C20 28 36 14 50 14C64 14 80 28 84 48Z\"/><path d=\"M50 86L23.8 27.1\"/><path d=\"M50 86L37.5 16.5\"/><path d=\"M50 86L50 14\"/><path d=\"M50 86L62.5 16.5\"/><path d=\"M50 86L76.2 27.1\"/><path d=\"M42 86H58\"/>"}, {"name": "Starfish", "vb": "0 0 100 100", "body": "<path d=\"M50 12 60 40.2 89.9 41 66.2 59.3 74.7 88 50 71 25.3 88 33.8 59.3 10.1 41 40 40.2Z\"/><circle cx=\"50\" cy=\"54\" r=\"3\"/><circle cx=\"50\" cy=\"36\" r=\"2\"/><circle cx=\"66\" cy=\"50\" r=\"2\"/><circle cx=\"34\" cy=\"50\" r=\"2\"/><circle cx=\"60\" cy=\"68\" r=\"2\"/><circle cx=\"40\" cy=\"68\" r=\"2\"/>"}, {"name": "Bone", "vb": "0 0 100 100", "body": "<path d=\"M26 50C18 50 16 42 22 38C24 32 32 32 34 40H66C68 32 76 32 78 38C84 42 82 50 74 50C82 50 84 58 78 62C76 68 68 68 66 60H34C32 68 24 68 22 62C16 58 18 50 26 50Z\"/>"}, {"name": "Cat", "vb": "0 0 100 100", "body": "<path d=\"M22 36 26 14 42 26C48 24 52 24 58 26L74 14 78 36C84 46 82 62 70 72C62 80 38 80 30 72C18 62 16 46 22 36Z\"/><circle cx=\"38\" cy=\"48\" r=\"3\"/><circle cx=\"62\" cy=\"48\" r=\"3\"/><path d=\"M46 58H54L50 62Z\"/><path d=\"M50 62V66M50 66C46 70 42 68 40 66M50 66C54 70 58 68 60 66\"/><path d=\"M16 56H34M18 64 34 60M84 56H66M82 64 66 60\"/>"}, {"name": "Dog", "vb": "0 0 100 100", "body": "<path d=\"M32 30C34 22 66 22 68 30V60C68 74 60 82 50 82C40 82 32 74 32 60Z\"/><path d=\"M32 30C22 30 14 42 16 58C18 64 26 64 32 56\"/><path d=\"M68 30C78 30 86 42 84 58C82 64 74 64 68 56\"/><circle cx=\"42\" cy=\"48\" r=\"3\"/><circle cx=\"58\" cy=\"48\" r=\"3\"/><path d=\"M44 62C44 58 56 58 56 62C56 66 52 68 50 68C48 68 44 66 44 62Z\"/><path d=\"M50 68V74\"/>"}, {"name": "Chef hat", "vb": "0 0 100 100", "body": "<path d=\"M30 60C18 60 14 44 24 38C24 26 38 22 44 28C48 16 64 18 66 30C76 26 88 36 80 48C78 54 74 58 70 60Z\"/><path d=\"M30 60V82H70V60\"/><path d=\"M30 72H70\"/>"}, {"name": "Coffee mug", "vb": "0 0 100 100", "body": "<path d=\"M22 36H64V70C64 80 56 86 46 86H40C30 86 22 80 22 70Z\"/><path d=\"M64 46H70C80 46 80 64 70 64H64\"/><path d=\"M36 28C32 22 40 18 36 12M50 28C46 22 54 18 50 12\"/>"}, {"name": "Wine glass", "vb": "0 0 100 100", "body": "<path d=\"M32 12H68C68 38 62 52 50 52C38 52 32 38 32 12Z\"/><path d=\"M50 52V84\"/><path d=\"M36 88H64\"/><path d=\"M34 28H66\"/>"}, {"name": "Cheers", "vb": "0 0 100 100", "body": "<g transform=\"rotate(-14 41 50)\"><path d=\"M30 20H52C52 40 48 50 41 50C34 50 30 40 30 20Z\"/><path d=\"M41 50V76M32 78H50\"/></g><g transform=\"translate(28 4) rotate(14 41 50)\"><path d=\"M30 20H52C52 40 48 50 41 50C34 50 30 40 30 20Z\"/><path d=\"M41 50V76M32 78H50\"/></g><path d=\"M50 12 54 4M56 14 62 8M44 12 42 4\"/>"}, {"name": "Beer mug", "vb": "0 0 100 100", "body": "<path d=\"M24 32H62V86H24Z\"/><path d=\"M62 42H70C78 42 78 72 70 72H62\"/><path d=\"M22 32C18 24 26 18 32 22C34 14 46 14 48 22C52 16 62 18 62 26C66 28 64 32 62 32\"/><path d=\"M34 44V76M44 44V76M54 44V76\"/>"}, {"name": "Pizza slice", "vb": "0 0 100 100", "body": "<path d=\"M50 90 16 24C38 12 62 12 84 24Z\"/><path d=\"M20 32C40 22 60 22 80 32\"/><circle cx=\"44\" cy=\"42\" r=\"5\"/><circle cx=\"60\" cy=\"50\" r=\"5\"/><circle cx=\"50\" cy=\"66\" r=\"4\"/>"}, {"name": "Cupcake", "vb": "0 0 100 100", "body": "<path d=\"M28 56H72L64 88H36Z\"/><path d=\"M42 56 44 88M58 56 56 88M50 56V88\"/><path d=\"M24 56C18 48 26 40 32 42C32 30 46 26 50 34C54 26 68 30 68 42C74 40 82 48 76 56Z\"/><circle cx=\"50\" cy=\"20\" r=\"5\"/><path d=\"M50 15C52 10 56 8 58 8\"/>"}, {"name": "Apple", "vb": "0 0 100 100", "body": "<path d=\"M50 32C40 24 20 26 20 50C20 72 34 90 50 84C66 90 80 72 80 50C80 26 60 24 50 32Z\"/><path d=\"M50 32C50 24 52 18 56 12\"/><path d=\"M53 22C58 14 68 14 72 18C66 24 58 25 53 22Z\"/>"}, {"name": "Citrus slice", "vb": "0 0 100 100", "body": "<circle cx=\"50\" cy=\"50\" r=\"38\"/><circle cx=\"50\" cy=\"50\" r=\"30\"/><path d=\"M50 50L76 50\"/><path d=\"M50 50L68.4 68.4\"/><path d=\"M50 50L50 76\"/><path d=\"M50 50L31.6 68.4\"/><path d=\"M50 50L24 50\"/><path d=\"M50 50L31.6 31.6\"/><path d=\"M50 50L50 24\"/><path d=\"M50 50L68.4 31.6\"/>"}, {"name": "Pumpkin", "vb": "0 0 100 100", "body": "<path d=\"M50 26C30 26 14 40 14 58C14 76 30 86 50 86C70 86 86 76 86 58C86 40 70 26 50 26Z\"/><path d=\"M50 26C38 40 38 72 50 86M50 26C62 40 62 72 50 86\"/><path d=\"M30 34C22 46 22 70 32 82M70 34C78 46 78 70 68 82\"/><path d=\"M50 26C50 18 54 12 62 12\"/>"}, {"name": "Teapot", "vb": "0 0 100 100", "body": "<path d=\"M26 44H74V66C74 78 64 86 50 86C36 86 26 78 26 66Z\"/><path d=\"M26 50C16 46 10 40 10 30L22 40\"/><path d=\"M74 52H80C88 52 88 70 80 70H74\"/><path d=\"M34 44C34 34 66 34 66 44\"/><circle cx=\"50\" cy=\"32\" r=\"4\"/>"}, {"name": "Cooking pot", "vb": "0 0 100 100", "body": "<path d=\"M18 40H82\"/><path d=\"M22 40V76C22 82 28 86 34 86H66C72 86 78 82 78 76V40\"/><path d=\"M22 52H12M78 52H88\"/><path d=\"M36 40C36 30 64 30 64 40\"/><path d=\"M42 26C40 20 46 18 44 12M56 26C54 20 60 18 58 12\"/>"}, {"name": "Key", "vb": "0 0 100 100", "body": "<circle cx=\"30\" cy=\"50\" r=\"16\"/><circle cx=\"30\" cy=\"50\" r=\"6\"/><path d=\"M46 50H88M76 50V62M66 50V60\"/>"}, {"name": "Heart home", "vb": "0 0 100 100", "body": "<path d=\"M14 50 50 16 86 50\"/><path d=\"M24 42V86H76V42\"/><path d=\"M50 74C40 66 34 60 36 54C38 48 46 48 50 54C54 48 62 48 64 54C66 60 60 66 50 74Z\"/>"}, {"name": "Padlock heart", "vb": "0 0 100 100", "body": "<path d=\"M34 46V34C34 22 66 22 66 34V46\"/><path d=\"M50 90C28 78 18 66 20 56C22 46 36 44 50 56C64 44 78 46 80 56C82 66 72 78 50 90Z\"/><circle cx=\"50\" cy=\"66\" r=\"4\"/><path d=\"M50 70V76\"/>"}, {"name": "Candle", "vb": "0 0 100 100", "body": "<path d=\"M38 46H62V90H38Z\"/><path d=\"M50 14C44 22 42 30 50 38C58 30 56 22 50 14Z\"/><path d=\"M50 38V46\"/><path d=\"M44 46V56M44 56C44 60 48 60 48 56\"/><path d=\"M30 90H70\"/>"}, {"name": "Two hearts", "vb": "0 0 100 100", "body": "<path d=\"M38 70C9.4 52.4 11.6 30.4 24.8 28.2C32.5 27.1 38 34.8 38 39.2C38 34.8 43.5 27.1 51.2 28.2C64.4 30.4 66.6 52.4 38 70Z\"/><path d=\"M64 76C40.6 61.6 42.4 43.6 53.2 41.8C59.5 40.9 64 47.2 64 50.8C64 47.2 68.5 40.9 74.8 41.8C85.6 43.6 87.4 61.6 64 76Z\"/>"}, {"name": "Heart with arrow", "vb": "0 0 100 100", "body": "<path d=\"M50 80C13.6 57.6 16.4 29.6 33.2 26.8C43 25.4 50 35.2 50 40.8C50 35.2 57 25.4 66.8 26.8C83.6 29.6 86.4 57.6 50 80Z\"/><path d=\"M12 80 86 22\"/><path d=\"M76 22H86V32\"/><path d=\"M12 80 14 70M12 80 22 78M18 76 20 66M18 76 28 74\"/>"}, {"name": "Infinity", "vb": "0 0 100 100", "body": "<path d=\"M50 50C40 34 16 34 16 50C16 66 40 66 50 50C60 34 84 34 84 50C84 66 60 66 50 50Z\"/>"}, {"name": "Crown", "vb": "0 0 100 100", "body": "<path d=\"M14 72 20 30 38 50 50 22 62 50 80 30 86 72Z\"/><path d=\"M16 84H84\"/><circle cx=\"20\" cy=\"26\" r=\"4\"/><circle cx=\"50\" cy=\"18\" r=\"4\"/><circle cx=\"80\" cy=\"26\" r=\"4\"/>"}, {"name": "Diamond", "vb": "0 0 100 100", "body": "<path d=\"M28 18H72L88 38 50 88 12 38Z\"/><path d=\"M12 38H88M28 18 38 38 50 88 62 38 72 18M38 38 50 18 62 38\"/>"}, {"name": "Bow", "vb": "0 0 100 100", "body": "<path d=\"M50 46C38 30 18 28 16 40C14 52 34 54 50 46Z\"/><path d=\"M50 46C62 30 82 28 84 40C86 52 66 54 50 46Z\"/><path d=\"M46 48 34 84 42 78 48 88 50 50\"/><path d=\"M54 48 66 84 58 78 52 88 50 50\"/><circle cx=\"50\" cy=\"46\" r=\"5\"/>"}, {"name": "Gift", "vb": "0 0 100 100", "body": "<path d=\"M16 40H84V54H16Z\"/><path d=\"M22 54V88H78V54\"/><path d=\"M50 40V88\"/><path d=\"M50 40C40 26 26 28 30 36C34 42 44 40 50 40C56 40 66 42 70 36C74 28 60 26 50 40Z\"/>"}, {"name": "Balloon", "vb": "0 0 100 100", "body": "<path d=\"M50 10C34 10 24 24 24 40C24 58 38 70 50 72C62 70 76 58 76 40C76 24 66 10 50 10Z\"/><path d=\"M46 72 50 78 54 72\"/><path d=\"M50 78C46 84 54 88 50 94\"/><path d=\"M36 30C38 24 42 20 48 18\"/>"}, {"name": "Birthday cake", "vb": "0 0 100 100", "body": "<path d=\"M20 60H80V88H20Z\"/><path d=\"M28 40H72V60H28Z\"/><path d=\"M20 70C30 76 40 64 50 70C60 76 70 64 80 70\"/><path d=\"M40 40V30M50 40V30M60 40V30\"/><path d=\"M40 24C38 20 42 18 40 14M50 24C48 20 52 18 50 14M60 24C58 20 62 18 60 14\"/>"}, {"name": "Baby onesie", "vb": "0 0 100 100", "body": "<path d=\"M36 14C40 22 60 22 64 14L84 26 76 40 68 36V64C68 74 60 82 54 84H46C40 82 32 74 32 64V36L24 40 16 26Z\"/><path d=\"M44 84V90H56V84\"/>"}, {"name": "Baby feet", "vb": "0 0 100 100", "body": "<g fill=\"currentColor\" stroke=\"none\"><g transform=\"translate(36 58) rotate(-12)\"><ellipse cx=\"0\" cy=\"0\" rx=\"9\" ry=\"15\"/><circle cx=\"-8\" cy=\"-21\" r=\"3\"/><circle cx=\"-2\" cy=\"-24\" r=\"3\"/><circle cx=\"4\" cy=\"-23\" r=\"2.6\"/><circle cx=\"9\" cy=\"-19\" r=\"2.2\"/></g><g transform=\"translate(64 50) rotate(12) scale(-1 1)\"><ellipse cx=\"0\" cy=\"0\" rx=\"9\" ry=\"15\"/><circle cx=\"-8\" cy=\"-21\" r=\"3\"/><circle cx=\"-2\" cy=\"-24\" r=\"3\"/><circle cx=\"4\" cy=\"-23\" r=\"2.6\"/><circle cx=\"9\" cy=\"-19\" r=\"2.2\"/></g></g>"}, {"name": "Christmas tree", "vb": "0 0 100 100", "body": "<path d=\"M50 20 28 48H40L22 72H40L18 88H82L60 72H78L60 48H72Z\"/><path d=\"M50 4 53 12H61L55 17 57 25 50 20 43 25 45 17 39 12H47Z\"/><path d=\"M44 88V96H56V88\"/>"}, {"name": "Ornament", "vb": "0 0 100 100", "body": "<circle cx=\"50\" cy=\"58\" r=\"30\"/><path d=\"M42 22H58V30H42Z\"/><path d=\"M50 22C46 14 54 10 50 6\"/><path d=\"M22 52C32 46 42 58 50 52C58 46 68 58 78 52\"/><path d=\"M24 68C34 62 42 74 50 68C58 62 66 74 76 68\"/>"}, {"name": "Candy cane", "vb": "0 0 100 100", "body": "<path d=\"M60 92V34C60 20 52 12 42 12C30 12 24 20 24 32\" stroke-width=\"12\" stroke-dasharray=\"9 6\"/>"}, {"name": "Snowman", "vb": "0 0 100 100", "body": "<circle cx=\"50\" cy=\"70\" r=\"20\"/><circle cx=\"50\" cy=\"36\" r=\"14\"/><path d=\"M38 22H62M42 22V8H58V22\"/><circle cx=\"45\" cy=\"34\" r=\"1.5\"/><circle cx=\"55\" cy=\"34\" r=\"1.5\"/><path d=\"M50 38 58 41\"/><path d=\"M32 60 16 48M68 60 84 48\"/><circle cx=\"50\" cy=\"64\" r=\"2\"/><circle cx=\"50\" cy=\"74\" r=\"2\"/>"}, {"name": "Gingerbread man", "vb": "0 0 100 100", "body": "<path d=\"M50 10C40 10 36 18 38 26C30 28 20 30 16 36C14 42 22 44 30 42H34C32 52 28 62 24 72C20 80 28 86 36 80L50 66 64 80C72 86 80 80 76 72C72 62 68 52 66 42H70C78 44 86 42 84 36C80 30 70 28 62 26C64 18 60 10 50 10Z\"/><circle cx=\"46\" cy=\"20\" r=\"1.5\"/><circle cx=\"54\" cy=\"20\" r=\"1.5\"/><circle cx=\"50\" cy=\"40\" r=\"2\"/><circle cx=\"50\" cy=\"50\" r=\"2\"/><path d=\"M45 26C48 28 52 28 55 26\"/>"}, {"name": "Stocking", "vb": "0 0 100 100", "body": "<path d=\"M40 24H64V54C64 54 76 62 76 74C76 86 62 92 50 86L28 76C18 70 20 58 30 56L40 52Z\"/><path d=\"M36 10H68V24H36Z\"/>"}, {"name": "Bell", "vb": "0 0 100 100", "body": "<path d=\"M50 18C34 18 28 32 28 48V62L20 72H80L72 62V48C72 32 66 18 50 18Z\"/><path d=\"M44 72C44 80 56 80 56 72\"/><path d=\"M46 18C46 12 54 12 54 18\"/>"}, {"name": "Easter egg", "vb": "0 0 100 100", "body": "<path d=\"M50 10C32 10 20 40 20 60C20 78 34 90 50 90C66 90 80 78 80 60C80 40 68 10 50 10Z\"/><path d=\"M22 52 32 44 42 52 50 44 58 52 68 44 78 52\"/><path d=\"M22 66 32 74 42 66 50 74 58 66 68 74 78 66\"/><circle cx=\"50\" cy=\"30\" r=\"4\"/>"}, {"name": "Sparkles", "vb": "0 0 100 100", "body": "<path d=\"M40 14C42 34 46 38 66 40C46 42 42 46 40 66C38 46 34 42 14 40C34 38 38 34 40 14Z\"/><path d=\"M72 56C73 66 75 68 86 70C75 72 73 74 72 84C71 74 69 72 58 70C69 68 71 66 72 56Z\"/>"}, {"name": "Graduation cap", "vb": "0 0 100 100", "body": "<path d=\"M50 20 90 36 50 52 10 36Z\"/><path d=\"M28 44V62C28 70 72 70 72 62V44\"/><path d=\"M90 36V60\"/><path d=\"M86 60H94L90 70Z\"/>"}, {"name": "Circle frame", "vb": "0 0 100 100", "body": "<circle cx=\"50\" cy=\"50\" r=\"42\"/><circle cx=\"50\" cy=\"50\" r=\"34\" stroke-dasharray=\"2 7\"/>"}, {"name": "Banner", "vb": "0 0 100 100", "body": "<path d=\"M18 36H82V62H18Z\"/><path d=\"M18 42H6L12 52 6 62H18M82 42H94L88 52 94 62H82\"/><path d=\"M18 62 24 68V62M82 62 76 68V62\"/>"}, {"name": "Shield", "vb": "0 0 100 100", "body": "<path d=\"M50 10 84 22V48C84 70 68 84 50 92C32 84 16 70 16 48V22Z\"/><path d=\"M50 20 76 29V48C76 64 64 76 50 82C36 76 24 64 24 48V29Z\"/>"}, {"name": "Ornate frame", "vb": "0 0 100 100", "body": "<path d=\"M24 12H76C76 18 82 24 88 24V76C82 76 76 82 76 88H24C24 82 18 76 12 76V24C18 24 24 18 24 12Z\"/><path d=\"M22 22H78V78H22Z\" stroke-dasharray=\"1 6\"/>"}, {"name": "Arrow", "vb": "0 0 100 100", "body": "<path d=\"M12 50H84\"/><path d=\"M70 38 86 50 70 62\"/><path d=\"M12 50 22 40M12 50 22 60M22 50 32 40M22 50 32 60\"/>"}, {"name": "Dots divider", "vb": "0 0 160 60", "body": "<path d=\"M6 30H58M102 30H154\"/><circle cx=\"66\" cy=\"30\" r=\"2.5\"/><circle cx=\"80\" cy=\"30\" r=\"5\"/><circle cx=\"94\" cy=\"30\" r=\"2.5\"/>"}, {"name": "Heart divider", "vb": "0 0 160 60", "body": "<path d=\"M6 32H62M98 32H154\"/><path d=\"M80 46C68 38 64 32 66 26C68 20 76 20 80 26C84 20 92 20 94 26C96 32 92 38 80 46Z\"/>"}, {"name": "Tent", "vb": "0 0 100 100", "body": "<path d=\"M10 84 50 18 90 84Z\"/><path d=\"M50 18V84M36 84 50 56 64 84\"/><path d=\"M4 84H96\"/>"}, {"name": "Campfire", "vb": "0 0 100 100", "body": "<path d=\"M50 16C40 30 30 40 34 56C36 66 44 70 50 70C56 70 64 66 66 56C70 40 60 30 50 16Z\"/><path d=\"M50 40C44 48 44 58 50 62C56 58 56 48 50 40Z\"/><path d=\"M20 86 80 70M20 70 80 86\"/>"}, {"name": "Ship wheel", "vb": "0 0 100 100", "body": "<circle cx=\"50\" cy=\"50\" r=\"28\"/><circle cx=\"50\" cy=\"50\" r=\"9\"/><path d=\"M59 50L92 50\"/><path d=\"M56.4 56.4L79.7 79.7\"/><path d=\"M50 59L50 92\"/><path d=\"M43.6 56.4L20.3 79.7\"/><path d=\"M41 50L8 50\"/><path d=\"M43.6 43.6L20.3 20.3\"/><path d=\"M50 41L50 8\"/><path d=\"M56.4 43.6L79.7 20.3\"/>"}, {"name": "Lighthouse", "vb": "0 0 100 100", "body": "<path d=\"M40 34H60L66 88H34Z\"/><path d=\"M38 34H62V26H38Z\"/><path d=\"M42 26V18H58V26\"/><path d=\"M46 18 50 12 54 18\"/><path d=\"M37 54H63M35 72H65\"/><path d=\"M62 22 86 14M62 26 86 32M38 22 14 14M38 26 14 32\"/><path d=\"M24 88H76\"/>"}, {"name": "Airplane", "vb": "0 0 100 100", "body": "<path d=\"M50 8C54 8 56 14 56 20V40L88 58V66L56 56V76L66 84V90L50 86 34 90V84L44 76V56L12 66V58L44 40V20C44 14 46 8 50 8Z\"/>"}, {"name": "Bicycle", "vb": "0 0 100 100", "body": "<circle cx=\"24\" cy=\"64\" r=\"16\"/><circle cx=\"76\" cy=\"64\" r=\"16\"/><path d=\"M24 64 40 38H66L76 64M40 38 52 64H24M52 64 66 38M36 30H46M66 38 62 26H70\"/>"}, {"name": "Music notes", "vb": "0 0 100 100", "body": "<path d=\"M36 76C36 84 20 84 20 78C20 72 34 70 36 76V24L78 16V68C78 76 62 76 62 70C62 64 76 62 78 68\"/><path d=\"M36 36 78 28\"/>"}, {"name": "Camera", "vb": "0 0 100 100", "body": "<rect x=\"12\" y=\"30\" width=\"76\" height=\"52\" rx=\"8\"/><path d=\"M34 30 40 18H60L66 30\"/><circle cx=\"50\" cy=\"56\" r=\"16\"/><circle cx=\"50\" cy=\"56\" r=\"7\"/><circle cx=\"76\" cy=\"40\" r=\"3\"/>"}, {"name": "Open book", "vb": "0 0 100 100", "body": "<path d=\"M50 28C40 20 24 18 10 22V80C24 76 40 78 50 86C60 78 76 76 90 80V22C76 18 60 20 50 28Z\"/><path d=\"M50 28V86\"/><path d=\"M18 36C26 34 34 34 42 38M18 48C26 46 34 46 42 50M58 38C66 34 74 34 82 36M58 50C66 46 74 46 82 48\"/>"}, {"name": "Mountain moon", "vb": "0 0 100 100", "body": "<path d=\"M6 84 34 44 48 62 64 38 94 84Z\"/><path d=\"M28 52 34 44 40 52M58 46 64 38 70 46\"/><path d=\"M76 14A12 12 0 1 0 88 30A10 10 0 0 1 76 14Z\"/>"}];
function decorSvg(d, color, size) {
  const [, , vw, vh] = d.vb.split(' ').map(Number);
  const k = size / Math.max(vw, vh);
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${d.vb}" width="${Math.round(vw * k)}" height="${Math.round(vh * k)}" fill="none" stroke="${color}" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" color="${color}">${d.body}</svg>`;
}
async function addDecor(d) {
  if (!P) return;
  const { img, w, h } = await svgTextToImage(decorSvg(d, '#000', 800));
  const src = imageToSrc(img, w, h); src.photo = false;
  const e = {
    id: nextId++, type: 'image', name: d.name, file: `${d.name}.svg`,
    x: 0, y: 0, rot: 0, ipp: 0.01, flip: false, darkness: 0.9,
    src, style: 'line', threshold: 0.55, invert: false, orig: null, bg: 'keep', bgTol: 0.35, mask: true,
  };
  e.bmp = makeImageBitmap(e);
  placeDefault(e, 0.28, 0.32);
  if (els.length) { const step = Math.min(DW, DH) * 0.06; e.x += step; e.y -= step; }
  els.push(e); fitInside(e); selId = e.id;
  renderMask(); updateLayers(); renderProps(); commit();
}
(() => {
  const css = `
.deco-grid{ display:grid; grid-template-columns:repeat(5, 1fr); gap:6px; }
.deco-grid button{ aspect-ratio:1; border:1px solid var(--line); background:var(--panel); color:var(--ink); border-radius:var(--radius-s); padding:8px; cursor:pointer; display:grid; place-items:center; }
.deco-grid button:hover{ border-color:var(--accent); color:var(--accent); }
.deco-grid svg{ width:100%; height:100%; display:block; }
.deco-pager{ display:flex; align-items:center; justify-content:space-between; gap:8px; margin-top:10px; }
.deco-page{ font-size:.82rem; color:var(--ink-2); font-variant-numeric:tabular-nums; }
.bgd-wrap{ position:fixed; inset:0; z-index:60; background:rgba(10,14,16,.5); display:grid; place-items:center; padding:16px; }
.bgd{ width:min(760px, 100%); max-height:calc(100vh - 32px); overflow-y:auto; background:var(--panel); color:var(--ink); border-radius:14px; box-shadow:0 20px 60px rgba(0,0,0,.35); padding:18px 20px 16px; font:15px/1.45 var(--ui); }
.bgd-head{ display:flex; align-items:center; justify-content:space-between; margin-bottom:12px; }
.bgd-head h2{ margin:0; font:600 1.25rem/1.2 var(--display); }
.bgd-x{ border:0; background:transparent; color:inherit; width:40px; height:40px; border-radius:8px; font-size:1.5rem; line-height:1; cursor:pointer; }
.bgd-x:hover{ background:var(--panel-2); }
.bgd-pics{ display:grid; grid-template-columns:1fr 1fr; gap:12px; margin-bottom:14px; }
.bgd-pics figure{ margin:0; }
.bgd-pics figcaption{ font-size:.8rem; font-weight:600; color:var(--ink-2); margin-bottom:6px; text-transform:uppercase; letter-spacing:.06em; }
.bgd-box{ position:relative; aspect-ratio:4/3; border:1px solid var(--line); border-radius:10px; overflow:hidden; display:grid; place-items:center; background:var(--panel-2); }
.bgd-box img{ max-width:100%; max-height:100%; object-fit:contain; display:block; }
.bgd-checker{ background-color:#fff; background-image:linear-gradient(45deg,#e4e4e4 25%,transparent 25%,transparent 75%,#e4e4e4 75%),linear-gradient(45deg,#e4e4e4 25%,transparent 25%,transparent 75%,#e4e4e4 75%); background-size:18px 18px; background-position:0 0,9px 9px; }
.bgd-busy{ position:absolute; inset:0; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:10px; background:rgba(255,255,255,.82); color:#1d2326; font-size:.9rem; text-align:center; padding:12px; }
.bgd-busy[hidden]{ display:none; }
.bgd-spin{ width:26px; height:26px; border-radius:50%; border:3px solid rgba(0,0,0,.15); border-top-color:var(--accent); animation:bgdspin .8s linear infinite; }
@keyframes bgdspin{ to{ transform:rotate(360deg); } }
.bgd .hint{ min-height:2.6em; }
.bgd-tol{ margin-top:6px; }
.bgd-foot{ display:flex; justify-content:flex-end; gap:8px; margin-top:14px; }
@media (max-width:600px){ .bgd-pics{ grid-template-columns:1fr 1fr; gap:8px; } .bgd{ padding:14px; } }
`;
  const style = document.createElement('style'); style.textContent = css;
  (MOUNT ? DOC : document.head).appendChild(style);
  const blk = document.createElement('div');
  blk.className = 'block'; blk.id = 'decoBlock';
  blk.innerHTML = '<h2 id="decoLbl">Decorations</h2><p class="hint" style="margin:0 0 10px">Tap one to add it to your design, then move and resize it.</p><div class="deco-grid" role="group" aria-labelledby="decoLbl"></div>';
  const grid = blk.querySelector('.deco-grid');
  const PER = 20, pages = Math.ceil(DECOR.length / PER);
  let page = 0;
  const pager = document.createElement('div');
  pager.className = 'deco-pager';
  pager.innerHTML = '<button type="button" class="btn btn-small deco-prev">‹ Previous</button><span class="deco-page" aria-live="polite"></span><button type="button" class="btn btn-small deco-next">Next ›</button>';
  const prev = pager.querySelector('.deco-prev'), next = pager.querySelector('.deco-next'), label = pager.querySelector('.deco-page');
  function showPage(n) {
    page = (n + pages) % pages;
    grid.innerHTML = '';
    for (const d of DECOR.slice(page * PER, page * PER + PER)) {
      const b = document.createElement('button');
      b.type = 'button'; b.title = d.name; b.setAttribute('aria-label', `Add ${d.name.toLowerCase()}`);
      b.innerHTML = decorSvg(d, 'currentColor', 40);
      b.onclick = () => addDecor(d);
      grid.appendChild(b);
    }
    label.textContent = `Page ${page + 1} of ${pages}`;
  }
  prev.onclick = () => showPage(page - 1);
  next.onclick = () => showPage(page + 1);
  grid.after(pager);
  showPage(0);
  $('layersBlock').before(blk);
})();

/* ---------------------------------------------------------------
   Design helper: a small built-in chat that explains how to use the
   designer (moving, rotating, resizing, text, wood, images and more).
   Its answers live in HELP_RULES below; edit them to change what it says.
   It also offers an email link for custom design help.
---------------------------------------------------------------- */
const DESIGN_EMAIL = 'customdesign@boardsnstuff.co';
function designMailHref() {
  const name = P ? P.name.toLowerCase() : 'piece';
  const subject = `Design help: ${P ? P.name : 'custom piece'}`;
  const body = `Hi! I'd like help with my design for a ${name}.\n\nWhat I have in mind:\n\n\nWood:\nNames, dates or text:\nAnything else:\n`;
  return `mailto:${DESIGN_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
(() => {
  const css = `
.hlp-launch{ position:absolute; right:14px; bottom:14px; z-index:3; display:inline-flex; align-items:center; gap:8px; border:1px solid rgba(60,45,30,.14); background:var(--accent); color:var(--accent-ink); border-radius:999px; padding:10px 16px 10px 13px; font:600 .9rem/1 var(--ui); cursor:pointer; box-shadow:0 4px 14px rgba(0,0,0,.18); }
.hlp-launch:hover{ background:var(--accent-2); }
.hlp-launch svg{ width:18px; height:18px; }
.hlp{ position:fixed; right:18px; bottom:18px; z-index:45; width:min(360px, calc(100vw - 24px)); height:min(520px, calc(100vh - 36px)); display:flex; flex-direction:column; background:var(--panel); color:var(--ink); border:1px solid var(--line); border-radius:14px; box-shadow:0 18px 50px rgba(0,0,0,.28); overflow:hidden; font:15px/1.45 var(--ui); }
.hlp[hidden]{ display:none; }
.hlp-head{ display:flex; align-items:center; justify-content:space-between; gap:10px; padding:12px 14px; background:var(--accent); color:var(--accent-ink); }
.hlp-head strong{ font-weight:600; font-size:.98rem; }
.hlp-head span{ display:block; font-size:.78rem; opacity:.85; }
.hlp-x{ border:0; background:transparent; color:inherit; width:36px; height:36px; border-radius:8px; cursor:pointer; font-size:1.3rem; line-height:1; }
.hlp-x:hover{ background:rgba(255,255,255,.15); }
.hlp-log{ flex:1; overflow-y:auto; padding:14px; display:flex; flex-direction:column; gap:10px; }
.hlp-msg{ max-width:88%; padding:9px 12px; border-radius:12px; white-space:pre-line; }
.hlp-bot{ align-self:flex-start; background:var(--panel-2); border-bottom-left-radius:4px; }
.hlp-me{ align-self:flex-end; background:var(--accent); color:var(--accent-ink); border-bottom-right-radius:4px; }
.hlp-msg a{ color:inherit; font-weight:600; }
.hlp-chips{ display:flex; flex-wrap:wrap; gap:6px; padding:0 14px 10px; }
.hlp-chip{ border:1px solid var(--line); background:var(--panel); color:var(--ink); border-radius:999px; padding:6px 11px; font:500 .82rem/1.2 var(--ui); cursor:pointer; }
.hlp-chip:hover{ border-color:var(--accent); color:var(--accent); }
.hlp-form{ display:flex; gap:8px; padding:10px 12px; border-top:1px solid var(--line); }
.hlp-form input{ flex:1; min-width:0; border:1px solid var(--line); border-radius:10px; padding:9px 11px; background:var(--panel); color:var(--ink); font:inherit; }
.hlp-form button{ border:0; border-radius:10px; padding:0 14px; background:var(--accent); color:var(--accent-ink); font:600 .9rem var(--ui); cursor:pointer; }
.hlp-mail{ display:flex; align-items:center; gap:8px; margin:10px 14px 0; padding:9px 12px; border:1px solid var(--line); border-radius:10px; background:var(--panel-2); color:var(--ink); text-decoration:none; font-size:.86rem; line-height:1.3; }
.hlp-mail:hover{ border-color:var(--accent); }
.hlp-mail strong{ color:var(--accent); white-space:nowrap; }
.hlp-mail svg{ width:18px; height:18px; flex:none; color:var(--accent); }
.foot-mail{ display:block; text-align:center; font-size:.82rem; color:var(--ink-2); text-decoration:none; margin-top:2px; }
.foot-mail span{ color:var(--accent); font-weight:600; text-decoration:underline; }
@media (max-width: 600px){ .hlp{ right:0; left:0; bottom:0; width:100%; height:min(70vh, 560px); border-radius:14px 14px 0 0; } .hlp-launch span{ display:none; } .hlp-launch{ padding:11px; } }
`;
  const style = document.createElement('style'); style.textContent = css;
  (MOUNT ? DOC : document.head).appendChild(style);
  const MAIL_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>';

  // Email link under "Add to cart", always visible.
  const foot = DOC.querySelector('.panel-foot');
  if (foot) {
    const a = document.createElement('a');
    a.className = 'foot-mail'; a.href = designMailHref();
    a.innerHTML = 'Need help with the design, or want us to make it? <span>Email us</span>';
    a.addEventListener('click', () => { a.href = designMailHref(); });
    foot.appendChild(a);
  }

  const launch = document.createElement('button');
  launch.type = 'button'; launch.className = 'hlp-launch';
  launch.setAttribute('aria-expanded', 'false'); launch.setAttribute('aria-controls', 'hlpPanel');
  launch.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-5A8 8 0 1 1 21 12z"/></svg><span>Need help?</span>';
  launch.setAttribute('aria-label', 'Open the design helper');
  $('stage').appendChild(launch);

  const panel = document.createElement('section');
  panel.className = 'hlp'; panel.id = 'hlpPanel'; panel.hidden = true;
  panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'Design helper');
  panel.innerHTML = `<header class="hlp-head"><div><strong>Design helper</strong><span>How to use the designer</span></div><button type="button" class="hlp-x" aria-label="Close the helper">×</button></header>
    <a class="hlp-mail" href="#">${MAIL_ICON}<span>Need help with the design, or want us to make it? <strong>Email us</strong></span></a>
    <div class="hlp-log" aria-live="polite"></div><div class="hlp-chips"></div>
    <form class="hlp-form"><label class="sr-only" for="hlpIn">Ask how to do something</label><input id="hlpIn" type="text" autocomplete="off" placeholder="e.g. How do I rotate text?"><button type="submit">Send</button></form>`;
  $('designer').appendChild(panel);
  const mail = panel.querySelector('.hlp-mail');
  mail.addEventListener('click', () => { mail.href = designMailHref(); });
  const log = panel.querySelector('.hlp-log'), chipsBox = panel.querySelector('.hlp-chips');
  const input = panel.querySelector('input');

  const escHtml = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  function say(html, who = 'bot') {
    const m = document.createElement('div');
    m.className = `hlp-msg ${who === 'bot' ? 'hlp-bot' : 'hlp-me'}`;
    if (who === 'bot') m.innerHTML = html; else m.textContent = html;
    log.appendChild(m); log.scrollTop = log.scrollHeight;
  }
  function chips(list) {
    chipsBox.innerHTML = '';
    for (const c of list) {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'hlp-chip'; b.textContent = c;
      b.onclick = () => ask(c);
      chipsBox.appendChild(b);
    }
  }
  const START = ['Rotate something', 'Resize text', 'Change my text', 'Change the wood', 'Add an image', 'Edit an image'];
  const MORE = ['Move something', 'Change the font', 'Add a decoration', 'Add a border', 'Delete something'];

  const woodsHere = () => productWoods();
  function pickWood(w) {
    const btn = [...$('woods').children].find((b) => (b.getAttribute('aria-label') || '').startsWith(w.label));
    if (btn) btn.click(); else { setWood(w); requestRender(); }
  }
  async function addTextValue(v) {
    const e = await newTextElement(v);
    if (els.length && !P.family) { const step = Math.min(DW, DH) * 0.05; e.x += step; e.y += step; }
    els.push(e); fitInside(e); selId = e.id;
    renderMask(); updateLayers(); renderProps(); commit();
  }
  const mailLink = (label = 'email our designers') => `<a href="${designMailHref()}">${label}</a>`;
  const imgAdd = () => P && P.family
    ? 'Under “Image”, tap “Upload a photo” and pick a JPG or PNG. The picture becomes the raised top layer, cut around its outline. For a cut that follows your family, use a PNG with a transparent background.'
    : 'Under “Add an image”, tap “Upload artwork” and pick a file. JPG, PNG, SVG and EPS all work. You can also drag a file straight onto the preview. It appears on the board, ready to move and resize.';

  // First match wins, so more specific questions come first.
  const HELP_RULES = [
    { re: /^(hi|hello|hey|help|start|menu|what can you do|how does this work)\b/, run: () => ({ text: 'Hi! I can show you how to use the designer. Pick a topic below or type a question, like “how do I rotate text?”', chips: START }) },
    { re: /\b(email|contact|human|real person|someone|make it for me|design it for me|do it for me|help me design|custom design|can you design)\b/, run: () => ({ text: `Our designers can help, or make the whole design for you. Tap “Email us” at the top of this chat, or ${mailLink('send us an email')} at ${DESIGN_EMAIL}. Tell us what you have in mind and we’ll take it from there.` }) },
    { re: /\b(3d|three d|preview|turn the board|spin the board|see it|what.*look like)\b/, run: () => ({ text: 'Tap “3D preview” at the top of the preview to see your piece in 3D. Drag on it to turn it around, and pinch or scroll to zoom. Tap “Design” to go back to editing.', chips: ['Zoom in', 'Move something'] }) },
    { re: /\b(zoom|reset view|closer|fit)\b/, run: () => ({ text: 'Pinch with two fingers, or scroll with a mouse, to zoom the preview. The square-corners button at the top right resets the view.' }) },
    { re: /\b(undo|redo|mistake|go back)\b/, run: () => ({ text: 'Use the curved arrows at the top right of the preview to undo or redo. On a keyboard, press Ctrl+Z (or ⌘Z on a Mac) to undo.' }) },
    { re: /\b(border)\b/, run: () => ({ text: 'Turn on the “Border” switch on the left, then tap a style. Use “Line thickness” to make it thinner or bolder. On most pieces you can also choose whether the corners follow the edge of the board or stay square.' }) },
    { re: /\b(sign size|custom size|board size|size of the (sign|board)|dimensions|width and height)\b/, run: () => ({ text: $('sizeBlock') && !$('sizeBlock').hidden ? 'Under “Choose a size”, tap one of the sizes, or tap Custom and type your own width and height in inches.' : `This piece comes in one size: ${P.size}.` }) },
    { re: /\b(curve|curved|circle|around|arc|follow|bend)\b/, run: () => ({ text: `Tap your text to select it, then under “Text shape” choose “${P.round ? 'Around the circle' : 'Follow border'}”. Drag the text to slide it along, tap “Top” or “Bottom” to jump it into place, and use the “Text size” and “Letter spacing” sliders.` }) },
    { re: /\b(spacing|space between|kerning|tracking)\b/, run: () => ({ text: 'Letter spacing is available for curved text: select it and use the “Letter spacing” slider. For straight text, press Enter to put words on separate lines and use “Line alignment” to line them up.' }) },
    { re: /\b(rotat\w*|angle|tilt|spin|straighten|crooked|sideways|upside)\b|\bturn\b(?!.*\b(on|off)\b)/, run: () => ({ text: 'Tap the item to select it, then drag the round handle above it to rotate. For an exact angle, type it in the “Angle (°)” box in the panel on the left. Tap “Straighten” to set it back to level.', chips: ['Resize something', 'Move something'] }) },
    { re: /\b(mirror|flip|reverse)\b/, run: () => ({ text: 'Select the item and tap “Mirror” in the panel on the left to flip it. Tap it again to flip it back.' }) },
    { re: /\b(font)\b.*\b(size|bigger|smaller|larger)\b|\b(text|letters?|words|name|font)\b.*\b(resize|bigger|smaller|larger|size|scale|shrink|enlarge)\b|\b(resize|bigger|smaller|larger|size|scale|shrink|enlarge)\b.*\b(text|letters?|words|name|font)\b/, run: () => ({ text: 'Tap the text to select it, then drag any corner handle to make it bigger or smaller. For an exact size, type a width or height in inches in the panel on the left. Curved text has a “Text size” slider instead.', chips: ['Change the font', 'Rotate something'] }) },
    { re: /\b(resize|bigger|smaller|larger|scale|shrink|enlarge|size)\b/, run: () => ({ text: 'Tap the item to select it, then drag a corner handle to resize it. It keeps its shape as it grows or shrinks. You can also type an exact width or height in inches in the panel on the left.' }) },
    { re: /\b(font|typeface|script|cursive|serif)\b/, run: () => ({ text: 'Tap your text to select it. In the panel on the left, tap any font under “Font” and your text changes right away.' }) },
    { re: /\b(align|alignment|center|centre|left|right)\b/, run: () => ({ text: 'Select your text and use “Line alignment” to line up multiple lines left, center or right. To center the whole item on the board, tap “Center” at the bottom of the panel.' }) },
    { re: /\b(background|backdrop|cut ?out|transparent)\b/, run: () => ({ text: `The designer doesn’t remove backgrounds. For the cleanest result, upload a PNG with a transparent background, or ${mailLink('email our designers')} and we’ll prep the picture for you.` }) },
    { re: /\b(move|drag|position|place|reposition|nudge|shift|slide)\b/, run: () => ({ text: 'Press and drag the item on the board to move it. On a keyboard, select it and use the arrow keys for small nudges (hold Shift for bigger steps). Tap “Center” to put it in the middle.' }) },
    { re: /\b(delete|remove|get rid|erase|trash)\b/, run: () => ({ text: 'Select the item on the board, then tap “Remove” at the bottom of the panel, or press Delete on a keyboard. Changed your mind? Use the undo arrow at the top right.' }) },
    { re: /\b(duplicate|copy|clone|another one|same again)\b/, run: () => ({ text: 'Select the item and tap “Duplicate” in the panel. The copy appears just next to the original.' }) },
    { re: /\b(add|new|insert|put)\b.*["“'](.+?)["”']/, run: async (q, raw) => {
        const m = raw.match(/["“'](.+?)["”']/);
        await addTextValue(m[1]);
        return { text: `I added “${escHtml(m[1])}” to your design. Drag it to move it and use the corner handles to resize it.`, chips: ['Change the font', 'Rotate something'] };
      } },
    { re: /\b(add|new|another|insert|put)\b.*\b(text|name|words|date|message|line|monogram|initials)\b/, run: () => ({ text: `Tap “Add text”${P && P.family ? ' under “Plate text”' : ' under “Add text”'}, then type in the box that opens on the left. Press Enter to start a new line.\n\nTip: you can also tell me, like add "The Millers".`, chips: ['Change the font', 'Resize text'] }) },
    { re: /\b(text|words|name|spelling|typo|lettering|message|wording|date|line)\b/, run: () => ({ text: 'Double-click (or double-tap) your text on the preview and type right there. Press Escape or tap away when you’re done. You can also select it and edit it in the text box in the panel on the left. Press Enter for a new line.', chips: ['Change the font', 'Resize text', 'Curve my text'] }) },
    { re: /\b(walnut|maple|cherry|birch|poplar)\b/, run: (q) => {
        const id = q.match(/\b(walnut|maple|cherry|birch|poplar)\b/)[1];
        const w = woodsHere().find((x) => x.id === id);
        if (!w) return { text: `${id[0].toUpperCase() + id.slice(1)} isn't offered for this piece. Under “Choose a wood” you can pick ${woodsHere().map((x) => x.label).join(', ')}.` };
        pickWood(w);
        return { text: `Switched to ${w.label}. To change it again, tap a different wood under “Choose a wood”.`, chips: ['See it in 3D'] };
      } },
    { re: /\b(wood|color|colour|stain|finish|material)\b/, run: () => ({ text: `Under “Choose a wood” at the top of the panel, tap the wood you want. The preview updates right away. This piece comes in ${woodsHere().map((x) => x.label).join(', ')}.\n\nYou can also tell me, like “use ${woodsHere()[0].id}”.`, chips: woodsHere().slice(0, 3).map((w) => `Use ${w.id}`) }) },
    { re: /\b(add|upload|insert|put|import|use my)\b.*\b(image|photo|picture|pic|logo|artwork|file|drawing)\b|\bupload\b/, run: () => ({ text: imgAdd(), chips: ['Edit an image', 'Resize something'] }) },
    { re: /\b(dark|darker|lighter|light|burn|deep|faint|contrast)\b/, run: () => ({ text: 'Select the item and drag the “Burn darkness” slider. For images in Line art mode, the “Detail” slider controls how much of the picture is burned. “Swap light and dark” flips which parts get engraved.' }) },
    { re: /\b(image|photo|picture|pic|logo|artwork|drawing|edit)\b/, run: () => ({ text: 'Tap the image on the board to select it. In the panel on the left you can:\n• Choose “Line art” (one depth, best for logos) or “Photo” (shades of gray)\n• Adjust “Detail”, “Burn darkness” or “Swap light and dark”\n• Type an exact size or angle, or tap Center, Straighten or Mirror\n\nTo use a different picture, tap “Remove” and upload the new one.', chips: ['Resize something', 'Rotate something'] }) },
    { re: /\b(decoration|decorations|graphic|graphics|icon|icons|clip ?art|symbol|heart|star|tree|wreath|flourish|shape)\b/, run: () => ({ text: 'Open “Decorations” on the left. There are 100 graphics across 5 pages, so use Previous and Next to browse, then tap one. It lands on your board, ready to move, resize and rotate like anything else.' }) },
    { re: /\b(raised|two.?layer|layered|family photo)\b/, run: () => ({ text: 'Layered pieces have a base plate and a raised top layer. Upload your photo under “Image” and it becomes the raised layer, cut around your picture. Add names and a border on the base plate with “Add text” and “Border”, and keep text in the open area below the picture.' }) },
    { re: /\b(layer|layers|list|on your board|select|choose an item|pick)\b/, run: () => ({ text: 'Everything on your design is listed under “On your board”. Tap an item in the list, or tap it on the preview, to select it and see its options.' }) },
    { re: /\b(mask|masking|crop|cropped|trim|run off|bleed|off the edge|past the edge)\b/, run: () => ({ text: 'Images and decorations can run past the edge of the engraving area. Anything outside it is trimmed off, so you can let a photo or pattern bleed off the board. Select an item and use “Crop at the edge” in the panel to turn this on or off. For text it starts off, so you don’t lose letters by accident.' }) },
    { re: /\b(warning|orange|red|too close|edge|outside|cut off)\b/, run: () => ({ text: 'An orange outline means part of your design is too close to the edge, where we can’t engrave cleanly. Drag it inward or make it a little smaller. Or, to let it run off the edge on purpose, select it and turn on “Crop at the edge” in the panel.' }) },
    { re: /\b(photo in the frame|frame photo|my photo in)\b/, run: () => ({ text: 'Under “Photo in the frame”, tap “Choose a photo” to preview your own picture in the frame. It’s only for the preview and isn’t engraved.' }) },
    { re: /\b(collapse|fold|expand|hide section|sections?)\b/, run: () => ({ text: 'Tap any section heading on the left, like “Choose a wood” or “Decorations”, to fold it away or open it again.' }) },
    { re: /\b(proof|save|download)\b/, run: () => ({ text: 'Tap “Save proof” at the bottom of the panel to download a picture of your design.' }) },
    { re: /\b(cart|order|checkout|buy|finish|done)\b/, run: () => ({ text: 'When you’re happy with it, tap “Add to cart” at the bottom of the panel. Your design is saved with the order, so we engrave exactly what you see.' }) },
    { re: /\b(thanks|thank you|thx|great|perfect|awesome|cool)\b/, run: () => ({ text: 'Happy to help! Anything else?', chips: MORE }) },
  ];

  async function ask(raw) {
    const text = raw.trim(); if (!text) return;
    say(text, 'me');
    const q = text.toLowerCase().replace(/[’]/g, "'");
    if (!P) { say('Pick a product first, then I can show you how to design it.'); return; }
    const rule = HELP_RULES.find((r) => r.re.test(q));
    let res;
    try {
      res = rule ? await rule.run(q, text) : { text: `I can help with using the designer, like moving, rotating and resizing things, changing text and fonts, picking a wood, or adding and editing images. Try one of these, or ${mailLink()} for help with your design.`, chips: START };
    } catch (err) { console.warn(err); res = { text: 'Something went wrong there. Please try it from the panel on the left.' }; }
    say(res.text);
    chips(res.chips || MORE);
  }

  function open() {
    panel.hidden = false; launch.hidden = true; launch.setAttribute('aria-expanded', 'true');
    if (!log.children.length) { say(`Hi! I can show you how to use the designer for your ${P ? P.name.toLowerCase() : 'piece'}. Pick a topic or ask me anything about it.`); chips(START); }
    if (matchMedia('(pointer: fine)').matches) input.focus();
  }
  function close() { panel.hidden = true; launch.hidden = false; launch.setAttribute('aria-expanded', 'false'); launch.focus(); }
  launch.onclick = open;
  panel.querySelector('.hlp-x').onclick = close;
  panel.addEventListener('keydown', (ev) => { if (ev.key === 'Escape') { ev.stopPropagation(); close(); } });
  panel.querySelector('form').onsubmit = (ev) => { ev.preventDefault(); const v = input.value; input.value = ''; ask(v); };
})();

/* ---------------------------------------------------------------
   Split "Add your design" into two sections: Add an image, Add text.
---------------------------------------------------------------- */
(() => {
  const blk = $('addBlock'), textBtn = $('textBtn');
  if (!blk || !textBtn) return;
  const h2 = blk.querySelector('h2');
  if (h2) { h2.textContent = 'Add an image'; h2.id = 'addImgLbl'; }
  const row = blk.querySelector('.add-row');
  if (row) row.style.gridTemplateColumns = '1fr';
  const hint = blk.querySelector('.hint');
  if (hint) hint.textContent = 'Upload a photo, logo or drawing. JPG, PNG, SVG and EPS all work, and you can also drop a file onto the preview.';
  const tb = document.createElement('div');
  tb.className = 'block'; tb.id = 'addTextBlock'; tb.hidden = blk.hidden;
  tb.innerHTML = '<h2 id="addTextLbl">Add text</h2>';
  textBtn.style.width = '100%';
  tb.appendChild(textBtn);
  const th = document.createElement('p');
  th.className = 'hint'; th.textContent = 'Names, dates, a message or a monogram. Double-click (or double-tap) any text on the preview to type right there.';
  tb.appendChild(th);
  blk.after(tb);
})();

/* ---------------------------------------------------------------
   Edit text on the preview: double-click (or double-tap) any text
   to type right on the board. Changes show up live and are kept in
   step with the text box in the panel.
---------------------------------------------------------------- */
(() => {
  const style = document.createElement('style');
  style.textContent = `.inline-edit{ position:absolute; z-index:4; box-sizing:border-box; margin:0; padding:6px 10px; border:2px solid var(--accent); border-radius:8px; background:rgba(255,255,255,.94); color:#1d2326; resize:none; overflow:hidden; white-space:pre; line-height:1.2; box-shadow:0 6px 20px rgba(0,0,0,.18); transform-origin:50% 50%; outline:none; }`;
  (MOUNT ? DOC : document.head).appendChild(style);
  let ed = null;
  const mc = document.createElement('canvas').getContext('2d');
  function place() {
    if (!ed) return;
    const { e, ta } = ed;
    if (!els.includes(e)) { close(); return; }
    const a = toScreen(0, 0), b = toScreen(1, 0);
    const k = Math.hypot(b.x - a.x, b.y - a.y), ang = Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
    const f = FONTS.find((x) => x.id === e.font) || FONTS[0];
    const fpx = Math.max(16, Math.min(96, 220 * e.ipp * k));
    ta.style.font = `${f.weight} ${fpx}px "${f.family}"`;
    ta.style.textAlign = e.align || 'center';
    mc.font = ta.style.font;
    const lines = ta.value.split('\n');
    const w = Math.max(fpx * 2, ...lines.map((l) => mc.measureText(l).width));
    const width = Math.ceil(w + 24 + fpx * 0.4), height = Math.ceil(lines.length * fpx * 1.2 + 16);
    const c = toScreen(e.x, e.y);
    Object.assign(ta.style, { width: `${width}px`, height: `${height}px`, left: `${c.x - width / 2}px`, top: `${c.y - height / 2}px`, transform: `rotate(${ang + e.rot}deg)` });
  }
  function open(e) {
    if (!e || e.type !== 'text') return;
    if (e.path) {            // curved text is edited in the panel
      select(e.id); renderProps();
      const t = DOC.querySelector('#props textarea'); if (t) { t.focus(); t.select(); }
      return;
    }
    close();
    if (view === '3d') setView('flat', false);
    select(e.id);
    const ta = document.createElement('textarea');
    ta.className = 'inline-edit'; ta.value = e.text; ta.spellcheck = true;
    ta.setAttribute('aria-label', 'Edit text. Press Escape when you’re done.');
    $('stage').appendChild(ta);
    ed = { e, ta, start: e.text };
    place(); ta.focus(); ta.select();
    let t;
    ta.addEventListener('input', () => {
      e.text = ta.value; place();
      clearTimeout(t);
      t = setTimeout(async () => {
        await rebuild(e); place();
        const pt = DOC.querySelector('#props textarea');
        if (pt && pt !== ta && DOC.activeElement !== pt) pt.value = e.text;
      }, 80);
    });
    ta.addEventListener('keydown', (ev) => {
      ev.stopPropagation();
      if (ev.key === 'Escape' || (ev.key === 'Enter' && (ev.metaKey || ev.ctrlKey))) { ev.preventDefault(); close(); }
    });
    ta.addEventListener('blur', () => setTimeout(close, 0));
  }
  async function close() {
    if (!ed) return;
    const { e, ta, start } = ed; ed = null;
    ta.remove();
    if (els.includes(e) && e.text !== start) { await rebuild(e); commit(); }
    renderProps();
  }
  const hitText = (ev) => {
    if (!P) return null;
    const p = local(ev), bp = toBoard(p.x, p.y), hit = bp && topHit(bp);
    return hit && hit.type === 'text' ? { hit, p } : null;
  };
  overlay.addEventListener('dblclick', (ev) => { const h = hitText(ev); if (h) { ev.preventDefault(); open(h.hit); } });
  let lastTap = { t: 0, id: null, x: 0, y: 0 };
  overlay.addEventListener('pointerup', (ev) => {
    if (ev.pointerType === 'mouse') return;
    const h = hitText(ev), now = performance.now();
    if (h && h.hit.id === lastTap.id && now - lastTap.t < 400 && Math.hypot(h.p.x - lastTap.x, h.p.y - lastTap.y) < 30) { lastTap.t = 0; open(h.hit); }
    else lastTap = { t: now, id: h ? h.hit.id : null, x: h ? h.p.x : 0, y: h ? h.p.y : 0 };
  });
  window.addEventListener('resize', () => requestAnimationFrame(place));
  overlay.addEventListener('wheel', () => requestAnimationFrame(place), { passive: true });
})();

/* ---------------------------------------------------------------
   Collapsible sections: tap a section's heading to fold it away.
   Everything starts folded except "Choose a wood".
---------------------------------------------------------------- */
(() => {
  const css = `
.sec-toggle{ all:unset; box-sizing:border-box; display:flex; align-items:center; justify-content:space-between; gap:10px; width:100%; min-height:32px; cursor:pointer; border-radius:6px; font:inherit; color:inherit; }
.sec-toggle:focus-visible{ outline:2px solid var(--accent); outline-offset:3px; }
.sec-toggle:hover .sec-chev{ color:var(--ink); }
.sec-chev{ width:18px; height:18px; flex:none; color:var(--ink-2); transition:transform .18s ease; }
.sec-toggle[aria-expanded="false"] .sec-chev{ transform:rotate(-90deg); }
.block-head h2{ flex:1; min-width:0; }
.block.is-collapsed{ margin-bottom:14px; }
.block.is-collapsed > h2, .block.is-collapsed > .block-head{ margin-bottom:0; }
`;
  const style = document.createElement('style'); style.textContent = css;
  (MOUNT ? DOC : document.head).appendChild(style);
  const OPEN_AT_START = ['woodLabel'];
  const CHEV = '<svg class="sec-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  DOC.querySelectorAll('.panel-scroll > .block').forEach((blk, i) => {
    if (blk.id === 'props' || blk.id === 'plateHead') return;
    const head = [...blk.children].find((c) => c.matches('h2, .block-head'));
    if (!head) return;
    const h2 = head.matches('h2') ? head : head.querySelector('h2');
    if (!h2) return;
    const key = blk.id || h2.id || `s${i}`;
    const body = document.createElement('div');
    body.className = 'sec-body'; body.id = `secBody-${key}`;
    let n = head.nextSibling;
    while (n) { const next = n.nextSibling; body.appendChild(n); n = next; }
    blk.appendChild(body);
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'sec-toggle'; btn.setAttribute('aria-controls', body.id);
    const label = document.createElement('span');
    while (h2.firstChild) label.appendChild(h2.firstChild);
    btn.appendChild(label); btn.insertAdjacentHTML('beforeend', CHEV);
    h2.appendChild(btn);
    const set = (open) => { btn.setAttribute('aria-expanded', String(open)); body.hidden = !open; blk.classList.toggle('is-collapsed', !open); };
    set(OPEN_AT_START.includes(key));
    btn.onclick = () => set(btn.getAttribute('aria-expanded') !== 'true');
    // Turning the border on opens its section so the style choices are visible.
    const sw = head.querySelector('.switch');
    if (sw) sw.addEventListener('click', () => { if (sw.getAttribute('aria-checked') === 'true' && body.hidden) set(true); });
  });
})();